// CreateClientGatewaysModal.tsx
// Redesigned: side-panel modal → inline Gateway Settings tab page
// All original business logic is 100% preserved. Only the render/UI layer changed.

import { useDisclosure } from "@chakra-ui/hooks";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import {
  getGatewayForClient,
  verifyWalletAddress,
} from "api/client-gateways";
import { getAllGatewaysSecond, getAllGatewaysByClient } from "api/graphQL_gateways";
import { createClientGateway } from "api/graphQL_client-gateways";
import AssignGateways from "./AssignGateways";

import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Button,
} from "@chakra-ui/react";

import sipe from "assets/img/payment-clients/sipe.png";
import pixLotus from "assets/img/payment-clients/pix.png";
import pix from "assets/img/payment-clients/pix.png";
import blumon from "assets/img/payment-clients/blumon.png";
import stripe from "assets/img/payment-clients/stripe.png";
import memphis from "assets/img/payment-clients/memphis.png";
import repyd from "assets/img/payment-clients/rapyd.png";
import mit from "assets/img/payment-clients/mit.png";
import banwire from "assets/img/payment-clients/banwire.jpg";
import valitor from "assets/img/payment-clients/valitor.png";
import bambora from "assets/img/payment-clients/bambora.png";
import Scipiopay from "assets/img/payment-clients/Scipiopay.png";
import Aurea_via from "assets/img/payment-clients/Aurea_via.png";
import Betapay from "assets/img/payment-clients/Betapay.png";
import Kasha from "assets/img/payment-clients/Kasha.jpg";
import Platy from "assets/img/payment-clients/Platy.png";
import reSet from "assets/img/payment-clients/reset.png";
import Supefina from "assets/img/payment-clients/supefina.svg";
import Linx from "assets/img/payment-clients/linx_logo.png";
import Master_Pay from "assets/img/payment-clients/master_Pay.png";
import Neonpay from "assets/img/payment-clients/neonpay.png";
import Bm2pay from "assets/img/payment-clients/bm2pay.svg";
import Threexpay from "assets/img/payment-clients/3XPAY.png";
import Digitarium from "assets/img/payment-clients/digitarium.png";
import Moneto from "assets/img/payment-clients/moneto.png";
import Tangoindia from "assets/img/payment-clients/tangoindia.png";
import G2pay from "assets/img/payment-clients/g2pay.png";
import AlphaPays from "assets/img/payment-clients/alphapays.svg";
import Clickopay from "assets/img/payment-clients/clickopay.svg";
import CFGPayments from "assets/img/payment-clients/cfg.png";
import Ragapay from "assets/img/payment-clients/ragapay.png";
import Capa from "assets/img/payment-clients/capa.svg";
import Orionx from "assets/img/payment-clients/orionx.svg";
import Mauricio from "assets/img/payment-clients/placeholder.png";
import Blox from "assets/img/payment-clients/blox.svg";
import Terracall from "assets/img/payment-clients/Terracall.png";
import MyXspend from "assets/img/payment-clients/myxspend.svg";
import Bennupay from "assets/img/payment-clients/bennupay.png";
import Xorapay from "assets/img/payment-clients/Xorapay.png";
import Murkon from "assets/img/payment-clients/Murkon.png";
import Changelly from "assets/img/payment-clients/Changelly.png";
import TestGateway from "assets/img/payment-clients/testgateway.png";
import Transvoucher from "assets/img/payment-clients/Transvoucher.png";
import DNSPay from "assets/img/payment-clients/dnspay.png";
import Gate2Way from "assets/img/payment-clients/Gate2Way.png";
import PayoutsTech from "assets/img/payment-clients/PayoutsTech.png";

import { getCurrencySymbol, currencyCodes } from "utils/currencyList";
import DivLoader from "components/divloader/DivLoader";
import InputField from "components/fields/InputField";
import TextArea from "components/fields/TextArea";
import { useEffect, useState, useContext, useMemo, useRef } from "react";
import { toast } from "react-hot-toast";
import {
  MdCircle,
  MdClose,
  MdHighlightOff,
  MdWarning,
} from "react-icons/md";
import DeleteClientGatewayModal from "./DeleteClientGatewayModal";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import GatewayPricing from "./GatewayPricing";
import BankInfo from "./BankInfo";
import WalletAddress from "./WalletAddress";
import Radio from "components/radio";
import { ClientContext } from "ClientProvider";
import { BsPlusCircle, BsDashCircle } from "react-icons/bs";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import { IoEyeOutline } from "react-icons/io5";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import Checkbox from "components/checkbox";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Link } from "react-router-dom";
import { getProfileSecond } from "api/graphQL_users";
import { Select as AntSelect } from "antd";
import countryList from "react-select-country-list";
import WhiteListClients from "views/admin/WhiteList";

// ─── Interfaces ───────────────────────────────────────────────────────────────
interface iGateway {
  client_id?: string;
  id?: string;
  name: string;
  gateway_type: any;
  inputs: any;
  image: string;
  to_convert?: any;
  new_currency?: any;
  reserved_pricing?: any;
  settlement?: any;
  is_active?: boolean;
  mid_country_live?: string;
  mid_country_test?: string;
  test_endpoint: string;
  live_endpoint: string;
  mark_up: string;
}

interface PredefinedCredentials {
  id: string;
  [key: string]: any;
}

export const GatewayTypes: iGateway[] = [
  { client_id:"",id:"",name:"3xpay",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_secret_test:"",api_secret_live:"",api_key_live:"",is_live:false},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Threexpay },
  { client_id:"",id:"",name:"Stripe",is_active:true,gateway_type:"",inputs:{secret_key_live:"",secret_key_test:"",statement_descriptor:"",statement_descriptor_suffix:"",is_live:false},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:stripe },
  { client_id:"",id:"",name:"Sipe",is_active:true,gateway_type:"",inputs:{key:"",business_name:"",merchant_id:"",app_id:"",nonce_string:"",body:"",notify_url:"",base_url:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:sipe },
  { client_id:"",id:"",name:"Blumon",is_active:true,gateway_type:"",inputs:{business_name:"",username:"",password:"",base_url:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:blumon },
  { client_id:"",id:"",name:"Pix-Lotus",gateway_type:"",inputs:{subscription_key:"",authorization:"",base_url:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",is_active:true,to_convert:"",new_currency:"",mark_up:"0",image:pixLotus },
  { client_id:"",id:"",name:"Re-set",gateway_type:"",inputs:{secretKey_test:"",secretKey_live:"",brand_id_test:"",brand_id_live:"",base_url:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",is_active:true,to_convert:"",new_currency:"",mark_up:"0",image:reSet },
  { client_id:"",id:"",name:"Pix",gateway_type:"",inputs:{name_test:"",name_live:"",email_test:"",email_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:pix,is_active:true },
  { client_id:"",id:"",name:"Raypd",is_active:true,gateway_type:"",inputs:{access_key_live:"",access_key_test:"",secret_key_live:"",secret_key_test:"",mid_country_test:"",mid_country_live:"",is_live:false,descriptor:""},to_convert:"",new_currency:"",mark_up:"0",image:repyd,test_endpoint:"",live_endpoint:"" },
  { client_id:"",id:"",name:"Banwire",gateway_type:"",inputs:{username_live:"",username_test:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",is_active:true,to_convert:"",new_currency:"",mark_up:"0",image:banwire },
  { client_id:"",id:"",name:"Valitor",gateway_type:"",inputs:{apikey_live:"",apikey_test:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",is_active:true,to_convert:"",new_currency:"",mark_up:"0",image:valitor },
  { client_id:"",id:"",name:"Bambora",is_active:true,gateway_type:"",inputs:{merchantId_test:"",merchantId_live:"",passcode_test:"",passcode_live:"",hash_key_test:"",hash_key_live:"",recurring_passcode_test:"",recurring_passcode_live:"",reporting_passcode_test:"",reporting_passcode_live:"",batch_passcode_test:"",batch_passcode_live:"",subscription_passcode_test:"",subscription_passcode_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:bambora },
  { client_id:"",id:"",name:"Scipiopay",is_active:true,gateway_type:"",inputs:{shop_id_test:"",shop_id_live:"",shop_secret_key_test:"",shop_secret_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Scipiopay },
  { client_id:"",id:"",name:"Aurea Via",is_active:true,gateway_type:"",inputs:{companyNum_test:"",companyNum_live:"",personalHashkey_test:"",personalHashkey_live:"",test_endpoint:"",live_endpoint:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Aurea_via },
  { client_id:"",id:"",name:"Betapay",is_active:true,gateway_type:"",inputs:{api_token_test:"",api_token_live:"",merchant_id_test:"",merchant_id_live:"",terminal_id_test:"",terminal_id_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Betapay },
  { client_id:"",id:"",name:"Kasha",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",merchant_domain_test:"",merchant_domain_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Kasha },
  { client_id:"",id:"",name:"Supefina",is_active:true,gateway_type:"",inputs:{merchant_id_test:"",merchant_id_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Supefina },
  { client_id:"",id:"",name:"Platy 2DS",is_active:true,gateway_type:"",inputs:{merchant_id_test:"",merchant_id_live:"",api_key_test:"",password_test:"",platy_api_key_test:"",platy_secret_key_test:"",username_test:"",api_key_live:"",password_live:"",platy_api_key_live:"",platy_secret_key_live:"",username_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Platy },
  { client_id:"",id:"",name:"Platy 3DS",is_active:true,gateway_type:"",inputs:{merchant_id_test:"",merchant_id_live:"",api_key_test:"",password_test:"",platy_api_key_test:"",platy_secret_key_test:"",username_test:"",api_key_live:"",password_live:"",platy_api_key_live:"",platy_secret_key_live:"",username_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Platy },
  { client_id:"",id:"",name:"Masterpay",is_active:true,gateway_type:"",inputs:{merchant_private_key_test:"",merchant_private_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Master_Pay },
  { client_id:"",id:"",name:"Neonpay",is_active:true,gateway_type:"",inputs:{merchant_key_test:"",merchant_key_live:"",password_test:"",password_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Neonpay },
  { client_id:"",id:"",name:"Bm2pay",is_active:true,gateway_type:"",inputs:{client_id_test:"",client_id_live:"",client_secret_test:"",client_secret_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Bm2pay },
  { client_id:"",id:"",name:"Digitarium",is_active:true,gateway_type:"",inputs:{merchant_key_test:"",merchant_key_live:"",password_test:"",password_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Digitarium },
  { client_id:"",id:"",name:"Tangoindia",is_active:true,gateway_type:"",inputs:{api_id_test:"",api_id_live:"",api_key_test:"",api_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Tangoindia },
  { client_id:"",id:"",name:"G2Pay",is_active:true,gateway_type:"",inputs:{signing_key_test:"",signing_key_live:"",api_key_test:"",api_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:G2pay },
  { client_id:"",id:"",name:"Clickopay",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",salt_key_test:"",salt_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Clickopay },
  { client_id:"",id:"",name:"CFGPayments",is_active:true,gateway_type:"",inputs:{secret_key_test:"",secret_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:CFGPayments },
  { client_id:"",id:"",name:"Capa",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",webhook_secret_test:"",webhook_secret_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Capa },
  { client_id:"",id:"",name:"Orionx",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",secret_key_test:"",secret_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Orionx },
  { client_id:"",id:"",name:"Mauricio",is_active:true,gateway_type:"",inputs:{client_id_test:"",client_id_live:"",api_secret_test:"",api_secret_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Mauricio },
  { client_id:"",id:"",name:"Blox",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Blox },
  { client_id:"",id:"",name:"Terracall",is_active:true,gateway_type:"",inputs:{client_id_test:"",client_id_live:"",client_secret_test:"",client_secret_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Terracall },
  { client_id:"",id:"",name:"MyXspend",is_active:true,gateway_type:"",inputs:{email_test:"",email_live:"",password_test:"",password_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:MyXspend },
  { client_id:"",id:"",name:"Bennupay",is_active:true,gateway_type:"",inputs:{secret_key_test:"",secret_key_live:"",brand_id_test:"",brand_id_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Bennupay },
  { client_id:"",id:"",name:"Xorapay",is_active:true,gateway_type:"",inputs:{secret_key_test:"",secret_key_live:"",encryption_key_test:"",encryption_key_live:"",webhook_hash_test:"",webhook_hash_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Xorapay },
  { client_id:"",id:"",name:"Murkon",is_active:true,gateway_type:"",inputs:{entity_login_test:"",entity_login_live:"",entity_pass_test:"",entity_pass_live:"",entity_code_test:"",entity_code_live:"",entity_type_test:"",entity_type_live:"",terminal_id_test:"",terminal_id_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Murkon },
  { client_id:"",id:"",name:"Changelly Fiat",is_active:true,gateway_type:"",inputs:{public_api_key_test:"",public_api_key_live:"",private_key_test:"",private_key_live:"",provider_test:"",provider_live:"",wallet_address_test:"",wallet_address_live:"",to_currency_test:"",to_currency_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Changelly },
  { client_id:"",id:"",name:"Changelly Crypto",is_active:true,gateway_type:"",inputs:{public_api_key_test:"",public_api_key_live:"",private_key_test:"",private_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Changelly },
  { client_id:"",id:"",name:"Transvoucher",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",api_secret_test:"",api_secret_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Transvoucher },
  { client_id:"",id:"",name:"DNSPay",is_active:true,gateway_type:"",inputs:{endpoint_id_test:"",endpoint_id_live:"",merchant_key_test:"",merchant_key_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:DNSPay },
  { client_id:"",id:"",name:"Gate2Way",is_active:true,gateway_type:"",inputs:{api_key_test:"",api_key_live:"",api_secret_test:"",api_secret_live:"",payment_method_test:"",payment_method_live:"",payout_payment_method_test:"",payout_payment_method_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:Gate2Way },
  { client_id:"",id:"",name:"Payouts Tech",is_active:true,gateway_type:"",inputs:{client_key_test:"",client_key_live:"",password_test:"",password_live:"",brand_test:"",brand_live:"",payout_client_key_test:"",payout_client_key_live:"",payout_password_test:"",payout_password_live:"",payout_brand_test:"",payout_brand_live:"",is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:PayoutsTech },
  { client_id:"",id:"",name:"TestGateway",is_active:true,gateway_type:"",inputs:{is_live:false,descriptor:""},test_endpoint:"",live_endpoint:"",to_convert:"",new_currency:"",mark_up:"0",image:TestGateway },
];

// ─── Main Component ────────────────────────────────────────────────────────────
const CreateClientGatewaysModal = ({
  id,
  fetchClients,
  assigned_payment_methods,
  infoData,
  refreshParent,
  gatewayRefreshKey,
  paymentMethods,
  allGateways,
  org_id,
  isupdating
}: {
  id: string;
  fetchClients: () => void;
  refreshParent : () => void;
  assigned_payment_methods?: any;
  infoData?: any;
  gatewayRefreshKey?:any;
  paymentMethods? : any;
  allGateways?: any;
  org_id?:any;
  isupdating?:any;
}) => {
  // ── All original state ─────────────────────────────────────────────────────
  const [allPaymentMethods, setAllPaymentMethods] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [type, setType] = useState<string>();
  const [hashID, setHashID] = useState<string>();
  const [formValues, setFormValues] = useState<any>({});
  const [addedgateways, setAddedGateways] = useState<iGateway[]>(GatewayTypes);
  const [gatewayTypes, setGatewayTypes] = useState<any[]>([]);
  const [gatewayTypesCopy, setGatewayTypesCopy] = useState<any[]>([]);
  const [formValuesErr, setFormValuesErr] = useState<any>();
  const [toggleBtn, setToggleBtn] = useState<any>(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [bankInfoCount, setBankInfoCount] = useState<number>(1);
  const [walletCount, setWalletCount] = useState<number>(1);
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);
  const [methodName, setMethodName] = useState<boolean>(false);
  const [pricingRight, setPricingRight] = useState<boolean>(false);
  const [isPaymentMethodOpen, setIsPaymentMethodOpen] = useState<boolean>(false);
  const [settelmentRight, setSettelmentRight] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [walletErrors, setWalletErrors] = useState("");
  const [currencyConv, setCurrencyConv] = useState<string>("requestPassthrough");
  const [selectedCurrency, setSelectedCurrency] = useState<string>("USD");
  const [isOpenWalletAddress, setIsOpenWalletAddress] = useState<boolean>(false);
  const [addNewWallet, setAddNewWallet] = useState<any>([]);
  const [descardWallet, setDescardWallet] = useState<any>([]);
  const [wallertVerifyIput, setWallertVerifyIput] = useState<any>({});
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
  const [credentialsType, setCredentialsType] = useState("custom");
  const [predefinedCredentials, setPredefinedCredentials] = useState<any[]>([]);
  const [selectedCredential, setSelectedCredential] = useState("");
  const [selectedPredefinedCredentials, setSelectedPredefinedCredentials] = useState<PredefinedCredentials | null>(null);
  const [credentialError, setCredentialError] = useState("");
  const [clientGatewayType, setClientGatewayType] = useState("");
  const [TwoFaLoading, setTwoFaLoading] = useState(false);
  const [authCode, setAuthCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<Array<HTMLInputElement | null>>(new Array(6).fill(null));
  const [isWallet2FaCloseModal, setIsWallet2FaCloseModal] = useState<boolean>(false);
  const [isValidateAdditionalFeesPricing, setisValidateAdditionalFeesPricing] = useState<boolean>(false);
  const [isValidateAdditionalFeesCost, setisValidateAdditionalFeesCost] = useState<boolean>(false);
  const [isValidateVelocity, setisValidateVelocity] = useState<boolean>(false);
  const [isValidateAdditionalFees, setisValidateAdditionalFees] = useState<boolean>(false);
  const [storeGetwayId, setStoreGateWayId] = useState<any>();
  const CountryOptions = useMemo(() => countryList().getData(), []);
  const binCountryOptions = useMemo(() => countryList().getData(), []);
  const [sideLoading,setSideLoading] = useState(false)

  const handleChange2fa = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      const newCode = [...authCode];
      newCode[index] = value;
      setAuthCode(newCode);
      if (value !== "" && index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown2fa = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && authCode[index] === "") {
      if (index > 0) inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste2fa = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      setAuthCode(pastedData.split(""));
      inputRefs.current[5]?.focus();
    }
  };

  const handleCurrencySelect = (event: any) => setSelectedCurrency(event);

  const convertIntoArray = (saved_form_fees_details_test: any) => {
    const data = [
      { name: "Payment", is_Active: saved_form_fees_details_test[0]?.payments === true ? true : false, disabled: saved_form_fees_details_test[0]?.payments === null ? false : true },
      { name: "Refund", is_Active: saved_form_fees_details_test[0]?.refund === true ? true : false, disabled: saved_form_fees_details_test[0]?.refund === null ? false : true },
      { name: "APM", is_Active: saved_form_fees_details_test[0]?.apm === true ? true : false, disabled: saved_form_fees_details_test[0]?.apm === null ? false : true },
      { name: "Authorization", is_Active: saved_form_fees_details_test[0]?.authorization === true ? true : false, disabled: saved_form_fees_details_test[0]?.authorization === null ? false : true },
      { name: "Subscription", is_Active: saved_form_fees_details_test[0]?.subscription === true ? true : false, disabled: saved_form_fees_details_test[0]?.subscription === null ? false : true },
      { name: "Token", is_Active: saved_form_fees_details_test[0]?.token === true ? true : false, disabled: saved_form_fees_details_test[0]?.token === null ? false : true },
      { name: "Payout", is_Active: saved_form_fees_details_test[0]?.payout === true ? true : false, disabled: saved_form_fees_details_test[0]?.payout === null ? false : true },
      { name: "Payin", is_Active: saved_form_fees_details_test[0]?.payin === true ? true : false, disabled: saved_form_fees_details_test[0]?.payin === null ? false : true },
      { name: "Crypto Payin", is_Active: saved_form_fees_details_test[0]?.payin === true ? true : false, disabled: saved_form_fees_details_test[0]?.payin === null ? false : true },
      { name: "Crypto Payout", is_Active: saved_form_fees_details_test[0]?.crypto_payin === true ? true : false, disabled: saved_form_fees_details_test[0]?.crypto_payout === null ? false : true },
    ];
    return data;
  };


  useEffect(() => {
    const update_client_gateway_type = gatewayTypes?.filter((data) => data?.name === type)?.[0]?.type;

    setClientGatewayType(update_client_gateway_type)

    setSideLoading(true)
    const method = singleRoleData[0]?.client?.value?.client_show_method_name;
    const pricing_right =
      singleRoleData[0]?.client?.value?.client_gateway_pricing;
    const settelment_right =
      singleRoleData[0]?.client?.value?.client_gateway_settlement;
    setPricingRight(pricing_right);
    setSettelmentRight(settelment_right);
    setMethodName(method);
    let saved_form_inputs = addedgateways.filter((data) => {
      return data?.name === type;
    });
    let saved_form_inputs_test = gatewayTypes?.filter(
      (data) => data?.name === type
    )?.[0]?.meta_info;

    let saved_form_CardTypes = gatewayTypes?.filter(
      (data) => data?.name === type
    )?.[0]?.card_types;

    let saved_form_fees_details_test = gatewayTypes?.filter(
      (data) => data?.name === type
    );
    // let is_active =

    let newSavedInput =
      saved_form_inputs &&
      saved_form_inputs.length > 0 &&
      saved_form_inputs?.map((item: any) => {
        const value = item?.is_live;
        // const is_active = saved_form_fees_details_test[0].is_active;
        const is_active = item?.is_active;

        const clonedObject =
          type === "Stripe"
            ? {
                ...item?.inputs,
                is_live: value === undefined ? false : value,
                is_active: is_active,
                secret_key_test: item?.inputs?.secret_key_test
                  ? item?.inputs?.secret_key_test
                  : saved_form_inputs_test?.secret_key,
                secret_key_live: item?.inputs?.secret_key_live
                  ? item?.inputs?.secret_key_live
                  : "",
                statement_descriptor_suffix: item?.inputs
                  ?.statement_descriptor_suffix
                  ? item?.inputs?.statement_descriptor_suffix
                  : saved_form_inputs_test?.statement_descriptor_suffix,
                statement_descriptor: item?.inputs?.statement_descriptor
                  ? item?.inputs?.statement_descriptor
                  : saved_form_inputs_test?.statement_descriptor,

                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                // is_active: item?.is_active,

                // client_cost:
                //   item?.reserved_pricing?.client_cost ||
                //   item?.reserved_pricing?.client_card_types?.map((i: any) => {
                //     return {
                //       ...i,
                //       percentage_fee: "",
                //       fixed_fee: "",
                //     };
                //   }) ||
                //   [],
                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Pix"
            ? {
                ...item?.inputs,
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                // subscription_key_test: item?.inputs?.subscription_key_test
                //   ? item?.inputs?.subscription_key_test
                //   : saved_form_inputs_test?.subscription_key,
                // subscription_key_live: item?.inputs?.subscription_key_live
                //   ? item?.inputs?.subscription_key_live
                //   : "",
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countrie_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                name_test: item?.inputs?.name_test
                  ? item?.inputs?.name_test
                  : saved_form_inputs_test?.name_test,
                name_live: item?.inputs?.name_live
                  ? item?.inputs?.name_live
                  : "",

                email_test: item?.inputs?.email_test
                  ? item?.inputs?.email_test
                  : saved_form_inputs_test?.email_test,
                email_live: item?.inputs?.email_live
                  ? item?.inputs?.email_live
                  : "",

                // business_name: item?.inputs?.business_name
                //   ? item?.inputs?.business_name
                //   : saved_form_inputs_test?.business_name,

                // client_cost:
                //   item?.reserved_pricing?.client_cost ||
                //   item?.reserved_pricing?.client_card_types.map((i: any) => {
                //     return {
                //       ...i,
                //       percentage_fee: "",
                //       fixed_fee: "",
                //     };
                //   }) ||
                //   [],
                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Banwire"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                username_test: item?.inputs?.username_test
                  ? item?.inputs?.username_test
                  : saved_form_inputs_test?.username_test,
                username_live: item?.inputs?.username_live
                  ? item?.inputs?.username_live
                  : "",

                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                // client_cost:
                //   item?.reserved_pricing?.client_cost ||
                //   item?.reserved_pricing?.client_card_types.map((i: any) => {
                //     return {
                //       ...i,
                //       percentage_fee: "",
                //       fixed_fee: "",
                //     };
                //   }) ||
                //   [],
                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Valitor"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                apikey_test: item?.inputs?.apikey_test
                  ? item?.inputs?.apikey_test
                  : saved_form_inputs_test?.apikey_test,
                apikey_live: item?.inputs?.apikey_live
                  ? item?.inputs?.apikey_live
                  : "",
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Bambora"
            ? {
                ...item?.inputs,
                is_live: value === undefined ? false : value,
                is_active: is_active,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                  advanced_avs : {
                    validate_address  : item?.advanced_avs?.validate_address || false,
                    validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                    validate_email  : item?.advanced_avs?.validate_email || false,
                    validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                  },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                merchantId_test: item?.inputs?.merchantId_test
                  ? item?.inputs?.merchantId_test
                  : saved_form_inputs_test?.merchantId_test,
                merchantId_live: item?.inputs?.merchantId_live
                  ? item?.inputs?.merchantId_live
                  : "",
                passcode_test: item?.inputs?.passcode_test
                  ? item?.inputs?.passcode_test
                  : saved_form_inputs_test?.passcode_test,
                passcode_live: item?.inputs?.passcode_live
                  ? item?.inputs?.passcode_live
                  : "",
                hash_key_test: item?.inputs?.hash_key_test
                  ? item?.inputs?.hash_key_test
                  : saved_form_inputs_test?.hash_key_test,
                hash_key_live: item?.inputs?.hash_key_live
                  ? item?.inputs?.hash_key_live
                  : "",
                recurring_passcode_test: item?.inputs?.recurring_passcode_test
                  ? item?.inputs?.recurring_passcode_test
                  : saved_form_inputs_test?.recurring_passcode_test,
                recurring_passcode_live: item?.inputs?.recurring_passcode_live
                  ? item?.inputs?.recurring_passcode_live
                  : "",
                reporting_passcode_test: item?.inputs?.reporting_passcode_test
                  ? item?.inputs?.reporting_passcode_test
                  : saved_form_inputs_test?.reporting_passcode_test,
                reporting_passcode_live: item?.inputs?.reporting_passcode_live
                  ? item?.inputs?.reporting_passcode_live
                  : "",  
                batch_passcode_test: item?.inputs?.batch_passcode_test
                  ? item?.inputs?.batch_passcode_test
                  : saved_form_inputs_test?.batch_passcode_test,
                batch_passcode_live: item?.inputs?.batch_passcode_live
                  ? item?.inputs?.batch_passcode_live
                  : "", 
                subscription_passcode_test: item?.inputs?.subscription_passcode_test
                  ? item?.inputs?.subscription_passcode_test
                  : saved_form_inputs_test?.subscription_passcode_test,
                subscription_passcode_live: item?.inputs?.subscription_passcode_live
                  ? item?.inputs?.subscription_passcode_live
                  : "",  
                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
              : type === "Digitarium"
              ? {
                  ...item?.inputs,
                  is_live: value === undefined ? false : value,
                  is_active: is_active,
                  test_endpoint: item?.test_endpoint
                    ? item?.test_endpoint
                    : saved_form_fees_details_test[0]?.test_endpoint,
                  live_endpoint: item?.live_endpoint
                    ? item?.live_endpoint
                    : saved_form_fees_details_test[0]?.live_endpoint,
                    advanced_avs : {
                      validate_address  : item?.advanced_avs?.validate_address || false,
                      validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                      validate_email  : item?.advanced_avs?.validate_email || false,
                      validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                    },
                  velocity: {
                    transaction_limit: {
                      allow_transaction_limit:
                        item?.velocity?.transaction_limit
                          ?.allow_transaction_limit || false,
                      limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                      period: item?.velocity?.transaction_limit?.period || "",
                    },
                    blocked_countries: {
                      allow_blocked_countries:
                        item?.velocity?.blocked_countries
                          ?.allow_blocked_countries || false,
                      country_code:
                        item?.velocity?.blocked_countries?.country_code || [],
                    },
                    blocked_countries_bin: {
                      allow_blocked_countries_bin:
                        item?.velocity?.blocked_countries_bin
                          ?.allow_blocked_countries_bin || false,
                      country_code:
                        item?.velocity?.blocked_countries_bin?.country_code || [],
                    },
                    max_transaction_limit: {
                      allow_max_transaction_limit:
                        item?.velocity?.max_transaction_limit
                          ?.allow_max_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.max_transaction_limit?.limit_amount || "",
                      currency:
                        item?.velocity?.max_transaction_limit?.currency || "",
                    },
                    min_transaction_limit: {
                      allow_min_transaction_limit:
                        item?.velocity?.min_transaction_limit
                          ?.allow_min_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.min_transaction_limit?.limit_amount || "",
                      currency:
                        item?.velocity?.min_transaction_limit?.currency || "",
                    },
                    max_transaction_period: {
                      allow_max_transaction_period:
                        item?.velocity?.max_transaction_period
                          ?.allow_max_transaction_period || false,
                      limit_amount:
                        item?.velocity?.max_transaction_period?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.max_transaction_period?.currency || "",
                      period:
                        item?.velocity?.max_transaction_period?.period || "",
                    },
                    retry_time: {
                      allow_retry_time:
                        item?.velocity?.retry_time?.allow_retry_time || false,
                      limit_minutes:
                        item?.velocity?.retry_time?.limit_minutes || "",
                    },
                    max_attempts_day: {
                      allow_max_attempts_day:
                        item?.velocity?.max_attempts_day
                          ?.allow_max_attempts_day || false,
                      limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                    },
                    max_attempts_week: {
                      allow_max_attempts_week:
                        item?.velocity?.max_attempts_week
                          ?.allow_max_attempts_week || false,
                      limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                    },
                    max_attempts_month: {
                      allow_max_attempts_month:
                        item?.velocity?.max_attempts_month
                          ?.allow_max_attempts_month || false,
                      limit_no:
                        item?.velocity?.max_attempts_month?.limit_no || "",
                    },
                    max_attempts_total: {
                      allow_max_attempts_total:
                        item?.velocity?.max_attempts_total
                          ?.allow_max_attempts_total || false,
                      limit_no:
                        item?.velocity?.max_attempts_total?.limit_no || "",
                    },
                  },
  
                  merchantKey_test: item?.inputs?.merchantKey_test
                    ? item?.inputs?.merchantKey_test
                    : saved_form_inputs_test?.merchantKey_test,
                  merchantKey_live: item?.inputs?.merchantKey_live
                    ? item?.inputs?.merchantKey_live
                    : "",
                  password_test: item?.inputs?.password_test
                    ? item?.inputs?.password_test
                    : saved_form_inputs_test?.password_test,
                  password_live: item?.inputs?.password_live
                    ? item?.inputs?.password_live
                    : "", 
                  client_card_types:
                    // item?.reserved_pricing?.client_card_types || [],
                    item?.reserved_pricing?.client_card_types?.map((m: any) => {
                      return {
                        card_name: m?.card_name,
                        percentage_fee: m?.percentage_fee,
                        fixed_fee: m?.fixed_fee,
                        currency_code: m?.currency_code,
                        allow_card: m?.allow_card,
  
                        cost_percentage_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.percentage_fee || "",
                        cost_fixed_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.fixed_fee || "",
                        cost_currency_code: item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.currency_code,
                      };
                    }),
                  // additional_fees: item?.reserved_pricing?.additional_fees || {},
                  additional_fees: {
                    chargeback_fees:
                      item?.reserved_pricing?.additional_fees?.chargeback_fees,
                    dispute_fees:
                      item?.reserved_pricing?.additional_fees?.dispute_fees,
                    reserve_fees:
                      item?.reserved_pricing?.additional_fees?.reserve_fees,
                    refunded_tnx_fees:
                      item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                    declined_tnx_fees:
                      item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                    cost_chargeback_fees:
                      item?.cost?.additional_fees?.chargeback_fees,
                    cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                    cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                    cost_refunded_tnx_fees:
                      item?.cost?.additional_fees?.refunded_tnx_fees,
                    cost_declined_tnx_fees:
                      item?.cost?.additional_fees?.declined_tnx_fees,
                  },
                  cardTypes: saved_form_CardTypes,
                  payout_fees: item?.payout_fees || {},
                  wallet_ids: item?.wallet_ids || [],
                  ewallet_New_addressess: [],
                  disCard_walletes: [],
                  fess_conditions: {
                    apm: saved_form_fees_details_test[0]?.apm,
                    payout: saved_form_fees_details_test[0]?.payout,
                    payin: saved_form_fees_details_test[0]?.payin,
                  },
                  payment_methods: item?.payment_method
                    ? item?.payment_method?.filterPaymentMethod
                    : convertIntoArray(saved_form_fees_details_test),
                  gateway_method_fees:
                    // item?.reserved_pricing?.gateway_method_fees || {},
                    {
                      apm_fees:
                        item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                      cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                      payout_fees:
                        item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                      cost_payout_fees:
                        item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                      payin_fees:
                        item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                      cost_payin_fees:
                        item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    },
                  type: type,
                  whitelist_enabled: item?.whitelist_enabled,
                }
                : type === "Tangoindia"
                ? {
                    ...item?.inputs,
                    is_live: value === undefined ? false : value,
                    is_active: is_active,
                    test_endpoint: item?.test_endpoint
                      ? item?.test_endpoint
                      : saved_form_fees_details_test[0]?.test_endpoint,
                    live_endpoint: item?.live_endpoint
                      ? item?.live_endpoint
                      : saved_form_fees_details_test[0]?.live_endpoint,
                      advanced_avs : {
                        validate_address  : item?.advanced_avs?.validate_address || false,
                        validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                        validate_email  : item?.advanced_avs?.validate_email || false,
                        validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                      },
                    velocity: {
                      transaction_limit: {
                        allow_transaction_limit:
                          item?.velocity?.transaction_limit
                            ?.allow_transaction_limit || false,
                        limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                        period: item?.velocity?.transaction_limit?.period || "",
                      },
                      blocked_countries: {
                        allow_blocked_countries:
                          item?.velocity?.blocked_countries
                            ?.allow_blocked_countries || false,
                        country_code:
                          item?.velocity?.blocked_countries?.country_code || [],
                      },
                      blocked_countries_bin: {
                        allow_blocked_countries_bin:
                          item?.velocity?.blocked_countries_bin
                            ?.allow_blocked_countries_bin || false,
                        country_code:
                          item?.velocity?.blocked_countries_bin?.country_code || [],
                      },
                      max_transaction_limit: {
                        allow_max_transaction_limit:
                          item?.velocity?.max_transaction_limit
                            ?.allow_max_transaction_limit || false,
                        limit_amount:
                          item?.velocity?.max_transaction_limit?.limit_amount || "",
                        currency:
                          item?.velocity?.max_transaction_limit?.currency || "",
                      },
                      min_transaction_limit: {
                        allow_min_transaction_limit:
                          item?.velocity?.min_transaction_limit
                            ?.allow_min_transaction_limit || false,
                        limit_amount:
                          item?.velocity?.min_transaction_limit?.limit_amount || "",
                        currency:
                          item?.velocity?.min_transaction_limit?.currency || "",
                      },
                      max_transaction_period: {
                        allow_max_transaction_period:
                          item?.velocity?.max_transaction_period
                            ?.allow_max_transaction_period || false,
                        limit_amount:
                          item?.velocity?.max_transaction_period?.limit_amount ||
                          "",
                        currency:
                          item?.velocity?.max_transaction_period?.currency || "",
                        period:
                          item?.velocity?.max_transaction_period?.period || "",
                      },
                      retry_time: {
                        allow_retry_time:
                          item?.velocity?.retry_time?.allow_retry_time || false,
                        limit_minutes:
                          item?.velocity?.retry_time?.limit_minutes || "",
                      },
                      max_attempts_day: {
                        allow_max_attempts_day:
                          item?.velocity?.max_attempts_day
                            ?.allow_max_attempts_day || false,
                        limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                      },
                      max_attempts_week: {
                        allow_max_attempts_week:
                          item?.velocity?.max_attempts_week
                            ?.allow_max_attempts_week || false,
                        limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                      },
                      max_attempts_month: {
                        allow_max_attempts_month:
                          item?.velocity?.max_attempts_month
                            ?.allow_max_attempts_month || false,
                        limit_no:
                          item?.velocity?.max_attempts_month?.limit_no || "",
                      },
                      max_attempts_total: {
                        allow_max_attempts_total:
                          item?.velocity?.max_attempts_total
                            ?.allow_max_attempts_total || false,
                        limit_no:
                          item?.velocity?.max_attempts_total?.limit_no || "",
                      },
                    },
    
                    api_id_test: item?.inputs?.api_id_test
                      ? item?.inputs?.api_id_test
                      : saved_form_inputs_test?.api_id_test,
                    api_id_live: item?.inputs?.api_id_live
                      ? item?.inputs?.api_id_live
                      : "",
                    api_key_test: item?.inputs?.api_key_test
                      ? item?.inputs?.api_key_test
                      : saved_form_inputs_test?.api_key_test,
                    api_key_live: item?.inputs?.api_key_live
                      ? item?.inputs?.api_key_live
                      : "", 
                    client_card_types:
                      // item?.reserved_pricing?.client_card_types || [],
                      item?.reserved_pricing?.client_card_types?.map((m: any) => {
                        return {
                          card_name: m?.card_name,
                          percentage_fee: m?.percentage_fee,
                          fixed_fee: m?.fixed_fee,
                          currency_code: m?.currency_code,
                          allow_card: m?.allow_card,
    
                          cost_percentage_fee:
                            item?.cost?.client_card_types?.filter(
                              (f: any) => f?.card_name == m?.card_name
                            )[0]?.percentage_fee || "",
                          cost_fixed_fee:
                            item?.cost?.client_card_types?.filter(
                              (f: any) => f?.card_name == m?.card_name
                            )[0]?.fixed_fee || "",
                          cost_currency_code: item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.currency_code,
                        };
                      }),
                    // additional_fees: item?.reserved_pricing?.additional_fees || {},
                    additional_fees: {
                      chargeback_fees:
                        item?.reserved_pricing?.additional_fees?.chargeback_fees,
                      dispute_fees:
                        item?.reserved_pricing?.additional_fees?.dispute_fees,
                      reserve_fees:
                        item?.reserved_pricing?.additional_fees?.reserve_fees,
                      refunded_tnx_fees:
                        item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                      declined_tnx_fees:
                        item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                      cost_chargeback_fees:
                        item?.cost?.additional_fees?.chargeback_fees,
                      cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                      cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                      cost_refunded_tnx_fees:
                        item?.cost?.additional_fees?.refunded_tnx_fees,
                      cost_declined_tnx_fees:
                        item?.cost?.additional_fees?.declined_tnx_fees,
                    },
                    cardTypes: saved_form_CardTypes,
                    payout_fees: item?.payout_fees || {},
                    wallet_ids: item?.wallet_ids || [],
                    ewallet_New_addressess: [],
                    disCard_walletes: [],
                    fess_conditions: {
                      apm: saved_form_fees_details_test[0]?.apm,
                      payout: saved_form_fees_details_test[0]?.payout,
                      payin: saved_form_fees_details_test[0]?.payin,
                    },
                    payment_methods: item?.payment_method
                      ? item?.payment_method?.filterPaymentMethod
                      : convertIntoArray(saved_form_fees_details_test),
                    gateway_method_fees:
                      // item?.reserved_pricing?.gateway_method_fees || {},
                      {
                        apm_fees:
                          item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                        cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                        payout_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                        cost_payout_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                        payin_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                        cost_payin_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                      },
                    type: type,
                    whitelist_enabled: item?.whitelist_enabled,
                  }
                  : type === "G2Pay"
                ? {
                    ...item?.inputs,
                    is_live: value === undefined ? false : value,
                    is_active: is_active,
                    test_endpoint: item?.test_endpoint
                      ? item?.test_endpoint
                      : saved_form_fees_details_test[0]?.test_endpoint,
                    live_endpoint: item?.live_endpoint
                      ? item?.live_endpoint
                      : saved_form_fees_details_test[0]?.live_endpoint,
                      advanced_avs : {
                        validate_address  : item?.advanced_avs?.validate_address || false,
                        validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                        validate_email  : item?.advanced_avs?.validate_email || false,
                        validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                      },
                    velocity: {
                      transaction_limit: {
                        allow_transaction_limit:
                          item?.velocity?.transaction_limit
                            ?.allow_transaction_limit || false,
                        limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                        period: item?.velocity?.transaction_limit?.period || "",
                      },
                      blocked_countries: {
                        allow_blocked_countries:
                          item?.velocity?.blocked_countries
                            ?.allow_blocked_countries || false,
                        country_code:
                          item?.velocity?.blocked_countries?.country_code || [],
                      },
                      blocked_countries_bin: {
                        allow_blocked_countries_bin:
                          item?.velocity?.blocked_countries_bin
                            ?.allow_blocked_countries_bin || false,
                        country_code:
                          item?.velocity?.blocked_countries_bin?.country_code || [],
                      },
                      max_transaction_limit: {
                        allow_max_transaction_limit:
                          item?.velocity?.max_transaction_limit
                            ?.allow_max_transaction_limit || false,
                        limit_amount:
                          item?.velocity?.max_transaction_limit?.limit_amount || "",
                        currency:
                          item?.velocity?.max_transaction_limit?.currency || "",
                      },
                      min_transaction_limit: {
                        allow_min_transaction_limit:
                          item?.velocity?.min_transaction_limit
                            ?.allow_min_transaction_limit || false,
                        limit_amount:
                          item?.velocity?.min_transaction_limit?.limit_amount || "",
                        currency:
                          item?.velocity?.min_transaction_limit?.currency || "",
                      },
                      max_transaction_period: {
                        allow_max_transaction_period:
                          item?.velocity?.max_transaction_period
                            ?.allow_max_transaction_period || false,
                        limit_amount:
                          item?.velocity?.max_transaction_period?.limit_amount ||
                          "",
                        currency:
                          item?.velocity?.max_transaction_period?.currency || "",
                        period:
                          item?.velocity?.max_transaction_period?.period || "",
                      },
                      retry_time: {
                        allow_retry_time:
                          item?.velocity?.retry_time?.allow_retry_time || false,
                        limit_minutes:
                          item?.velocity?.retry_time?.limit_minutes || "",
                      },
                      max_attempts_day: {
                        allow_max_attempts_day:
                          item?.velocity?.max_attempts_day
                            ?.allow_max_attempts_day || false,
                        limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                      },
                      max_attempts_week: {
                        allow_max_attempts_week:
                          item?.velocity?.max_attempts_week
                            ?.allow_max_attempts_week || false,
                        limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                      },
                      max_attempts_month: {
                        allow_max_attempts_month:
                          item?.velocity?.max_attempts_month
                            ?.allow_max_attempts_month || false,
                        limit_no:
                          item?.velocity?.max_attempts_month?.limit_no || "",
                      },
                      max_attempts_total: {
                        allow_max_attempts_total:
                          item?.velocity?.max_attempts_total
                            ?.allow_max_attempts_total || false,
                        limit_no:
                          item?.velocity?.max_attempts_total?.limit_no || "",
                      },
                    },
    
                    signing_key_test: item?.inputs?.signing_key_test
                      ? item?.inputs?.signing_key_test
                      : saved_form_inputs_test?.signing_key_test,
                    signing_key_live: item?.inputs?.signing_key_live
                      ? item?.inputs?.signing_key_live
                      : "",
                    api_key_test: item?.inputs?.api_key_test
                      ? item?.inputs?.api_key_test
                      : saved_form_inputs_test?.api_key_test,
                    api_key_live: item?.inputs?.api_key_live
                      ? item?.inputs?.api_key_live
                      : "", 
                    client_card_types:
                      // item?.reserved_pricing?.client_card_types || [],
                      item?.reserved_pricing?.client_card_types?.map((m: any) => {
                        return {
                          card_name: m?.card_name,
                          percentage_fee: m?.percentage_fee,
                          fixed_fee: m?.fixed_fee,
                          currency_code: m?.currency_code,
                          allow_card: m?.allow_card,
    
                          cost_percentage_fee:
                            item?.cost?.client_card_types?.filter(
                              (f: any) => f?.card_name == m?.card_name
                            )[0]?.percentage_fee || "",
                          cost_fixed_fee:
                            item?.cost?.client_card_types?.filter(
                              (f: any) => f?.card_name == m?.card_name
                            )[0]?.fixed_fee || "",
                          cost_currency_code: item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.currency_code,
                        };
                      }),
                    // additional_fees: item?.reserved_pricing?.additional_fees || {},
                    additional_fees: {
                      chargeback_fees:
                        item?.reserved_pricing?.additional_fees?.chargeback_fees,
                      dispute_fees:
                        item?.reserved_pricing?.additional_fees?.dispute_fees,
                      reserve_fees:
                        item?.reserved_pricing?.additional_fees?.reserve_fees,
                      refunded_tnx_fees:
                        item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                      declined_tnx_fees:
                        item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                      cost_chargeback_fees:
                        item?.cost?.additional_fees?.chargeback_fees,
                      cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                      cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                      cost_refunded_tnx_fees:
                        item?.cost?.additional_fees?.refunded_tnx_fees,
                      cost_declined_tnx_fees:
                        item?.cost?.additional_fees?.declined_tnx_fees,
                    },
                    cardTypes: saved_form_CardTypes,
                    payout_fees: item?.payout_fees || {},
                    wallet_ids: item?.wallet_ids || [],
                    ewallet_New_addressess: [],
                    disCard_walletes: [],
                    fess_conditions: {
                      apm: saved_form_fees_details_test[0]?.apm,
                      payout: saved_form_fees_details_test[0]?.payout,
                      payin: saved_form_fees_details_test[0]?.payin,
                    },
                    payment_methods: item?.payment_method
                      ? item?.payment_method?.filterPaymentMethod
                      : convertIntoArray(saved_form_fees_details_test),
                    gateway_method_fees:
                      // item?.reserved_pricing?.gateway_method_fees || {},
                      {
                        apm_fees:
                          item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                        cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                        payout_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                        cost_payout_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                        payin_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                        cost_payin_fees:
                          item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                      },
                    type: type,
                    whitelist_enabled: item?.whitelist_enabled,
                  }
                  : type === "Clickopay"
                  ? {
                      ...item?.inputs,
                      is_live: value === undefined ? false : value,
                      is_active: is_active,
                      test_endpoint: item?.test_endpoint
                        ? item?.test_endpoint
                        : saved_form_fees_details_test[0]?.test_endpoint,
                      live_endpoint: item?.live_endpoint
                        ? item?.live_endpoint
                        : saved_form_fees_details_test[0]?.live_endpoint,
                        advanced_avs : {
                          validate_address  : item?.advanced_avs?.validate_address || false,
                          validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                          validate_email  : item?.advanced_avs?.validate_email || false,
                          validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                        },
                      velocity: {
                        transaction_limit: {
                          allow_transaction_limit:
                            item?.velocity?.transaction_limit
                              ?.allow_transaction_limit || false,
                          limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                          period: item?.velocity?.transaction_limit?.period || "",
                        },
                        blocked_countries: {
                          allow_blocked_countries:
                            item?.velocity?.blocked_countries
                              ?.allow_blocked_countries || false,
                          country_code:
                            item?.velocity?.blocked_countries?.country_code || [],
                        },
                        blocked_countries_bin: {
                          allow_blocked_countries_bin:
                            item?.velocity?.blocked_countries_bin
                              ?.allow_blocked_countries_bin || false,
                          country_code:
                            item?.velocity?.blocked_countries_bin?.country_code || [],
                        },
                        max_transaction_limit: {
                          allow_max_transaction_limit:
                            item?.velocity?.max_transaction_limit
                              ?.allow_max_transaction_limit || false,
                          limit_amount:
                            item?.velocity?.max_transaction_limit?.limit_amount || "",
                          currency:
                            item?.velocity?.max_transaction_limit?.currency || "",
                        },
                        min_transaction_limit: {
                          allow_min_transaction_limit:
                            item?.velocity?.min_transaction_limit
                              ?.allow_min_transaction_limit || false,
                          limit_amount:
                            item?.velocity?.min_transaction_limit?.limit_amount || "",
                          currency:
                            item?.velocity?.min_transaction_limit?.currency || "",
                        },
                        max_transaction_period: {
                          allow_max_transaction_period:
                            item?.velocity?.max_transaction_period
                              ?.allow_max_transaction_period || false,
                          limit_amount:
                            item?.velocity?.max_transaction_period?.limit_amount ||
                            "",
                          currency:
                            item?.velocity?.max_transaction_period?.currency || "",
                          period:
                            item?.velocity?.max_transaction_period?.period || "",
                        },
                        retry_time: {
                          allow_retry_time:
                            item?.velocity?.retry_time?.allow_retry_time || false,
                          limit_minutes:
                            item?.velocity?.retry_time?.limit_minutes || "",
                        },
                        max_attempts_day: {
                          allow_max_attempts_day:
                            item?.velocity?.max_attempts_day
                              ?.allow_max_attempts_day || false,
                          limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                        },
                        max_attempts_week: {
                          allow_max_attempts_week:
                            item?.velocity?.max_attempts_week
                              ?.allow_max_attempts_week || false,
                          limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                        },
                        max_attempts_month: {
                          allow_max_attempts_month:
                            item?.velocity?.max_attempts_month
                              ?.allow_max_attempts_month || false,
                          limit_no:
                            item?.velocity?.max_attempts_month?.limit_no || "",
                        },
                        max_attempts_total: {
                          allow_max_attempts_total:
                            item?.velocity?.max_attempts_total
                              ?.allow_max_attempts_total || false,
                          limit_no:
                            item?.velocity?.max_attempts_total?.limit_no || "",
                        },
                      },
      
                      api_key_test: item?.inputs?.api_key_test
                        ? item?.inputs?.api_key_test
                        : saved_form_inputs_test?.api_key_test,
                      api_key_live: item?.inputs?.api_key_live
                        ? item?.inputs?.api_key_live
                        : "",
                      salt_key_test: item?.inputs?.salt_key_test
                        ? item?.inputs?.salt_key_test
                        : saved_form_inputs_test?.salt_key_test,
                      salt_key_live: item?.inputs?.salt_key_live
                        ? item?.inputs?.salt_key_live
                        : "", 
                      client_card_types:
                        // item?.reserved_pricing?.client_card_types || [],
                        item?.reserved_pricing?.client_card_types?.map((m: any) => {
                          return {
                            card_name: m?.card_name,
                            percentage_fee: m?.percentage_fee,
                            fixed_fee: m?.fixed_fee,
                            currency_code: m?.currency_code,
                            allow_card: m?.allow_card,
      
                            cost_percentage_fee:
                              item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.percentage_fee || "",
                            cost_fixed_fee:
                              item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.fixed_fee || "",
                            cost_currency_code: item?.cost?.client_card_types?.filter(
                              (f: any) => f?.card_name == m?.card_name
                            )[0]?.currency_code,
                          };
                        }),
                      // additional_fees: item?.reserved_pricing?.additional_fees || {},
                      additional_fees: {
                        chargeback_fees:
                          item?.reserved_pricing?.additional_fees?.chargeback_fees,
                        dispute_fees:
                          item?.reserved_pricing?.additional_fees?.dispute_fees,
                        reserve_fees:
                          item?.reserved_pricing?.additional_fees?.reserve_fees,
                        refunded_tnx_fees:
                          item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                        declined_tnx_fees:
                          item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                        cost_chargeback_fees:
                          item?.cost?.additional_fees?.chargeback_fees,
                        cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                        cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                        cost_refunded_tnx_fees:
                          item?.cost?.additional_fees?.refunded_tnx_fees,
                        cost_declined_tnx_fees:
                          item?.cost?.additional_fees?.declined_tnx_fees,
                      },
                      cardTypes: saved_form_CardTypes,
                      payout_fees: item?.payout_fees || {},
                      wallet_ids: item?.wallet_ids || [],
                      ewallet_New_addressess: [],
                      disCard_walletes: [],
                      fess_conditions: {
                        apm: saved_form_fees_details_test[0]?.apm,
                        payout: saved_form_fees_details_test[0]?.payout,
                        payin: saved_form_fees_details_test[0]?.payin,
                      },
                      payment_methods: item?.payment_method
                        ? item?.payment_method?.filterPaymentMethod
                        : convertIntoArray(saved_form_fees_details_test),
                      gateway_method_fees:
                        // item?.reserved_pricing?.gateway_method_fees || {},
                        {
                          apm_fees:
                            item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                          cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                          payout_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                          cost_payout_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                          payin_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          cost_payin_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                        },
                      type: type,
                      whitelist_enabled: item?.whitelist_enabled,
                    }
                    : type === "CFGPayments"
                  ? {
                      ...item?.inputs,
                      is_live: value === undefined ? false : value,
                      is_active: is_active,
                      test_endpoint: item?.test_endpoint
                        ? item?.test_endpoint
                        : saved_form_fees_details_test[0]?.test_endpoint,
                      live_endpoint: item?.live_endpoint
                        ? item?.live_endpoint
                        : saved_form_fees_details_test[0]?.live_endpoint,
                        advanced_avs : {
                          validate_address  : item?.advanced_avs?.validate_address || false,
                          validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                          validate_email  : item?.advanced_avs?.validate_email || false,
                          validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                        },
                      velocity: {
                        transaction_limit: {
                          allow_transaction_limit:
                            item?.velocity?.transaction_limit
                              ?.allow_transaction_limit || false,
                          limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                          period: item?.velocity?.transaction_limit?.period || "",
                        },
                        blocked_countries: {
                          allow_blocked_countries:
                            item?.velocity?.blocked_countries
                              ?.allow_blocked_countries || false,
                          country_code:
                            item?.velocity?.blocked_countries?.country_code || [],
                        },
                        blocked_countries_bin: {
                          allow_blocked_countries_bin:
                            item?.velocity?.blocked_countries_bin
                              ?.allow_blocked_countries_bin || false,
                          country_code:
                            item?.velocity?.blocked_countries_bin?.country_code || [],
                        },
                        max_transaction_limit: {
                          allow_max_transaction_limit:
                            item?.velocity?.max_transaction_limit
                              ?.allow_max_transaction_limit || false,
                          limit_amount:
                            item?.velocity?.max_transaction_limit?.limit_amount || "",
                          currency:
                            item?.velocity?.max_transaction_limit?.currency || "",
                        },
                        min_transaction_limit: {
                          allow_min_transaction_limit:
                            item?.velocity?.min_transaction_limit
                              ?.allow_min_transaction_limit || false,
                          limit_amount:
                            item?.velocity?.min_transaction_limit?.limit_amount || "",
                          currency:
                            item?.velocity?.min_transaction_limit?.currency || "",
                        },
                        max_transaction_period: {
                          allow_max_transaction_period:
                            item?.velocity?.max_transaction_period
                              ?.allow_max_transaction_period || false,
                          limit_amount:
                            item?.velocity?.max_transaction_period?.limit_amount ||
                            "",
                          currency:
                            item?.velocity?.max_transaction_period?.currency || "",
                          period:
                            item?.velocity?.max_transaction_period?.period || "",
                        },
                        retry_time: {
                          allow_retry_time:
                            item?.velocity?.retry_time?.allow_retry_time || false,
                          limit_minutes:
                            item?.velocity?.retry_time?.limit_minutes || "",
                        },
                        max_attempts_day: {
                          allow_max_attempts_day:
                            item?.velocity?.max_attempts_day
                              ?.allow_max_attempts_day || false,
                          limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                        },
                        max_attempts_week: {
                          allow_max_attempts_week:
                            item?.velocity?.max_attempts_week
                              ?.allow_max_attempts_week || false,
                          limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                        },
                        max_attempts_month: {
                          allow_max_attempts_month:
                            item?.velocity?.max_attempts_month
                              ?.allow_max_attempts_month || false,
                          limit_no:
                            item?.velocity?.max_attempts_month?.limit_no || "",
                        },
                        max_attempts_total: {
                          allow_max_attempts_total:
                            item?.velocity?.max_attempts_total
                              ?.allow_max_attempts_total || false,
                          limit_no:
                            item?.velocity?.max_attempts_total?.limit_no || "",
                        },
                      },
                      secret_key_test: item?.inputs?.secret_key_test
                        ? item?.inputs?.secret_key_test
                        : saved_form_inputs_test?.secret_key_test,
                      secret_key_live: item?.inputs?.secret_key_live
                        ? item?.inputs?.secret_key_live
                        : "",
                      client_card_types:
                        // item?.reserved_pricing?.client_card_types || [],
                        item?.reserved_pricing?.client_card_types?.map((m: any) => {
                          return {
                            card_name: m?.card_name,
                            percentage_fee: m?.percentage_fee,
                            fixed_fee: m?.fixed_fee,
                            currency_code: m?.currency_code,
                            allow_card: m?.allow_card,
      
                            cost_percentage_fee:
                              item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.percentage_fee || "",
                            cost_fixed_fee:
                              item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.fixed_fee || "",
                            cost_currency_code: item?.cost?.client_card_types?.filter(
                              (f: any) => f?.card_name == m?.card_name
                            )[0]?.currency_code,
                          };
                        }),
                      // additional_fees: item?.reserved_pricing?.additional_fees || {},
                      additional_fees: {
                        chargeback_fees:
                          item?.reserved_pricing?.additional_fees?.chargeback_fees,
                        dispute_fees:
                          item?.reserved_pricing?.additional_fees?.dispute_fees,
                        reserve_fees:
                          item?.reserved_pricing?.additional_fees?.reserve_fees,
                        refunded_tnx_fees:
                          item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                        declined_tnx_fees:
                          item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                        cost_chargeback_fees:
                          item?.cost?.additional_fees?.chargeback_fees,
                        cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                        cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                        cost_refunded_tnx_fees:
                          item?.cost?.additional_fees?.refunded_tnx_fees,
                        cost_declined_tnx_fees:
                          item?.cost?.additional_fees?.declined_tnx_fees,
                      },
                      cardTypes: saved_form_CardTypes,
                      payout_fees: item?.payout_fees || {},
                      wallet_ids: item?.wallet_ids || [],
                      ewallet_New_addressess: [],
                      disCard_walletes: [],
                      fess_conditions: {
                        apm: saved_form_fees_details_test[0]?.apm,
                        payout: saved_form_fees_details_test[0]?.payout,
                        payin: saved_form_fees_details_test[0]?.payin,
                      },
                      payment_methods: item?.payment_method
                        ? item?.payment_method?.filterPaymentMethod
                        : convertIntoArray(saved_form_fees_details_test),
                      gateway_method_fees:
                        // item?.reserved_pricing?.gateway_method_fees || {},
                        {
                          apm_fees:
                            item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                          cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                          payout_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                          cost_payout_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                          payin_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          cost_payin_fees:
                            item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                        },
                      type: type,
                      whitelist_enabled: item?.whitelist_enabled,
                    }
                      : type === "Capa"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        api_key_test: item?.inputs?.api_key_test
                          ? item?.inputs?.api_key_test
                          : saved_form_inputs_test?.api_key_test,
                        api_key_live: item?.inputs?.api_key_live
                          ? item?.inputs?.api_key_live
                          : "",
                        webhook_secret_test: item?.inputs?.webhook_secret_test
                          ? item?.inputs?.webhook_secret_test
                          : saved_form_inputs_test?.webhook_secret_test,
                        webhook_secret_live: item?.inputs?.webhook_secret_live
                          ? item?.inputs?.webhook_secret_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        crypto_fees : {
                          percentage_fee: item?.reserved_pricing?.crypto_fees?.percentage_fee,
                          fixed_fee:  item?.reserved_pricing?.crypto_fees?.fixed_fee,
                          currency_code:  item?.reserved_pricing?.crypto_fees?.currency_code,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                        : type === "Orionx"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        api_key_test: item?.inputs?.api_key_test
                          ? item?.inputs?.api_key_test
                          : saved_form_inputs_test?.api_key_test,
                        api_key_live: item?.inputs?.api_key_live
                          ? item?.inputs?.api_key_live
                          : "",
                        secret_key_test: item?.inputs?.secret_key_test
                          ? item?.inputs?.secret_key_test
                          : saved_form_inputs_test?.secret_key_test,
                        secret_key_live: item?.inputs?.secret_key_live
                          ? item?.inputs?.secret_key_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        crypto_fees : {
                          percentage_fee: item?.reserved_pricing?.crypto_fees?.percentage_fee,
                          fixed_fee:  item?.reserved_pricing?.crypto_fees?.fixed_fee,
                          currency_code:  item?.reserved_pricing?.crypto_fees?.currency_code,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                         : type === "Mauricio"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        client_id_test: item?.inputs?.client_id_test
                          ? item?.inputs?.client_id_test
                          : saved_form_inputs_test?.client_id_test,
                        client_id_live: item?.inputs?.client_id_live
                          ? item?.inputs?.client_id_live
                          : "",
                        api_secret_test: item?.inputs?.api_secret_test
                          ? item?.inputs?.api_secret_test
                          : saved_form_inputs_test?.api_secret_test,
                        api_secret_live: item?.inputs?.api_secret_live
                          ? item?.inputs?.api_secret_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                         : type === "Blox"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        api_key_test: item?.inputs?.api_key_test
                          ? item?.inputs?.api_key_test
                          : saved_form_inputs_test?.api_key_test,
                        api_key_live: item?.inputs?.api_key_live
                          ? item?.inputs?.api_key_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        crypto_fees : {
                          percentage_fee: item?.reserved_pricing?.crypto_fees?.percentage_fee,
                          fixed_fee:  item?.reserved_pricing?.crypto_fees?.fixed_fee,
                          currency_code:  item?.reserved_pricing?.crypto_fees?.currency_code,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                          : type === "Terracall"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        client_id_test: item?.inputs?.client_id_test
                          ? item?.inputs?.client_id_test
                          : saved_form_inputs_test?.client_id_test,
                        client_id_live: item?.inputs?.client_id_live
                          ? item?.inputs?.client_id_live
                          : "",
                        client_secret_test: item?.inputs?.client_secret_test
                          ? item?.inputs?.client_secret_test
                          : saved_form_inputs_test?.client_secret_test,
                        client_secret_live: item?.inputs?.client_secret_live
                          ? item?.inputs?.client_secret_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                          : type === "MyXspend"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        email_test: item?.inputs?.email_test
                          ? item?.inputs?.email_test
                          : saved_form_inputs_test?.email_test,
                        email_live: item?.inputs?.email_live
                          ? item?.inputs?.email_live
                          : "",
                        password_test: item?.inputs?.password_test
                          ? item?.inputs?.password_test
                          : saved_form_inputs_test?.password_test,
                        password_live: item?.inputs?.password_live
                          ? item?.inputs?.password_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                           : type === "Bennupay"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        secret_key_test: item?.inputs?.secret_key_test
                          ? item?.inputs?.secret_key_test
                          : saved_form_inputs_test?.secret_key_test,
                        secret_key_live: item?.inputs?.secret_key_live
                          ? item?.inputs?.secret_key_live
                          : "",
                        brand_id_test: item?.inputs?.brand_id_test
                          ? item?.inputs?.brand_id_test
                          : saved_form_inputs_test?.brand_id_test,
                        brand_id_live: item?.inputs?.brand_id_live
                          ? item?.inputs?.brand_id_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                        : type === "Xorapay"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        secret_key_test: item?.inputs?.secret_key_test
                          ? item?.inputs?.secret_key_test
                          : saved_form_inputs_test?.secret_key_test,
                        secret_key_live: item?.inputs?.secret_key_live
                          ? item?.inputs?.secret_key_live
                          : "",
                        encryption_key_test: item?.inputs?.encryption_key_test
                          ? item?.inputs?.encryption_key_test
                          : saved_form_inputs_test?.encryption_key_test,
                        encryption_key_live: item?.inputs?.encryption_key_live
                          ? item?.inputs?.encryption_key_live
                          : "",
                        webhook_hash_test: item?.inputs?.webhook_hash_test
                          ? item?.inputs?.webhook_hash_test
                          : saved_form_inputs_test?.webhook_hash_test,
                        webhook_hash_live: item?.inputs?.webhook_hash_live
                          ? item?.inputs?.webhook_hash_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                         : type === "Murkon"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        entity_login_test: item?.inputs?.entity_login_test
                          ? item?.inputs?.entity_login_test
                          : saved_form_inputs_test?.entity_login_test,
                        entity_login_live: item?.inputs?.entity_login_live
                          ? item?.inputs?.entity_login_live
                          : "",
                        entity_pass_test: item?.inputs?.entity_pass_test
                          ? item?.inputs?.entity_pass_test
                          : saved_form_inputs_test?.entity_pass_test,
                        entity_pass_live: item?.inputs?.entity_pass_live
                          ? item?.inputs?.entity_pass_live
                          : "",
                        entity_code_test: item?.inputs?.entity_code_test
                          ? item?.inputs?.entity_code_test
                          : saved_form_inputs_test?.entity_code_test,
                        entity_code_live: item?.inputs?.entity_code_live
                          ? item?.inputs?.entity_code_live
                          : "",
                        entity_type_test: item?.inputs?.entity_type_test
                          ? item?.inputs?.entity_type_test
                          : saved_form_inputs_test?.entity_type_test,
                        entity_type_live: item?.inputs?.entity_type_live
                          ? item?.inputs?.entity_type_live
                          : "",
                        terminal_id_test: item?.inputs?.terminal_id_test
                          ? item?.inputs?.terminal_id_test
                          : saved_form_inputs_test?.terminal_id_test,
                        terminal_id_live: item?.inputs?.terminal_id_live
                          ? item?.inputs?.terminal_id_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                         : type === "Changelly Fiat"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        public_api_key_test: item?.inputs?.public_api_key_test
                          ? item?.inputs?.public_api_key_test
                          : saved_form_inputs_test?.public_api_key_test,
                        public_api_key_live: item?.inputs?.public_api_key_live
                          ? item?.inputs?.public_api_key_live
                          : "",
                        private_key_test: item?.inputs?.private_key_test
                          ? item?.inputs?.private_key_test
                          : saved_form_inputs_test?.private_key_test,
                        private_key_live: item?.inputs?.private_key_live
                          ? item?.inputs?.private_key_live
                          : "",
                        provider_test: item?.inputs?.provider_test
                          ? item?.inputs?.provider_test
                          : saved_form_inputs_test?.provider_test,
                        provider_live: item?.inputs?.provider_live
                          ? item?.inputs?.provider_live
                          : "",
                        wallet_address_test: item?.inputs?.wallet_address_test
                          ? item?.inputs?.wallet_address_test
                          : saved_form_inputs_test?.wallet_address_test,
                        wallet_address_live: item?.inputs?.wallet_address_live
                          ? item?.inputs?.wallet_address_live
                          : "",
                        to_currency_test: item?.inputs?.to_currency_test
                          ? item?.inputs?.to_currency_test
                          : saved_form_inputs_test?.to_currency_test,
                        to_currency_live: item?.inputs?.to_currency_live
                          ? item?.inputs?.to_currency_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                         : type === "Changelly Crypto"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        public_api_key_test: item?.inputs?.public_api_key_test
                          ? item?.inputs?.public_api_key_test
                          : saved_form_inputs_test?.public_api_key_test,
                        public_api_key_live: item?.inputs?.public_api_key_live
                          ? item?.inputs?.public_api_key_live
                          : "",
                        private_key_test: item?.inputs?.private_key_test
                          ? item?.inputs?.private_key_test
                          : saved_form_inputs_test?.private_key_test,
                        private_key_live: item?.inputs?.private_key_live
                          ? item?.inputs?.private_key_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                        : type === "Transvoucher"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        api_key_test: item?.inputs?.api_key_test
                          ? item?.inputs?.api_key_test
                          : saved_form_inputs_test?.api_key_test,
                        api_key_live: item?.inputs?.api_key_live
                          ? item?.inputs?.api_key_live
                          : "",
                        api_secret_test: item?.inputs?.api_secret_test
                          ? item?.inputs?.api_secret_test
                          : saved_form_inputs_test?.api_secret_test,
                        api_secret_live: item?.inputs?.api_secret_live
                          ? item?.inputs?.api_secret_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                        : type === "DNSPay"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        endpoint_id_test: item?.inputs?.endpoint_id_test
                          ? item?.inputs?.endpoint_id_test
                          : saved_form_inputs_test?.endpoint_id_test,
                        endpoint_id_live: item?.inputs?.endpoint_id_live
                          ? item?.inputs?.endpoint_id_live
                          : "",
                        merchant_key_test: item?.inputs?.merchant_key_test
                          ? item?.inputs?.merchant_key_test
                          : saved_form_inputs_test?.merchant_key_test,
                        merchant_key_live: item?.inputs?.merchant_key_live
                          ? item?.inputs?.merchant_key_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                        : type === "Gate2Way"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        api_key_test: item?.inputs?.api_key_test
                          ? item?.inputs?.api_key_test
                          : saved_form_inputs_test?.api_key_test,
                        api_key_live: item?.inputs?.api_key_live
                          ? item?.inputs?.api_key_live
                          : "",
                        api_secret_test: item?.inputs?.api_secret_test
                          ? item?.inputs?.api_secret_test
                          : saved_form_inputs_test?.api_secret_test,
                        api_secret_live: item?.inputs?.api_secret_live
                          ? item?.inputs?.api_secret_live
                          : "",
                        payment_method_test: item?.inputs?.payment_method_test
                          ? item?.inputs?.payment_method_test
                          : saved_form_inputs_test?.payment_method_test,
                        payment_method_live: item?.inputs?.payment_method_live
                          ? item?.inputs?.payment_method_live
                          : "",
                        payout_payment_method_test: item?.inputs?.payout_payment_method_test
                          ? item?.inputs?.payout_payment_method_test
                          : saved_form_inputs_test?.payout_payment_method_test,
                        payout_payment_method_live: item?.inputs?.payout_payment_method_live
                          ? item?.inputs?.payout_payment_method_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                        : type === "Payouts Tech"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        client_key_test: item?.inputs?.client_key_test
                          ? item?.inputs?.client_key_test
                          : saved_form_inputs_test?.client_key_test,
                        client_key_live: item?.inputs?.client_key_live
                          ? item?.inputs?.client_key_live
                          : "",
                        password_test: item?.inputs?.password_test
                          ? item?.inputs?.password_test
                          : saved_form_inputs_test?.password_test,
                        password_live: item?.inputs?.password_live
                          ? item?.inputs?.password_live
                          : "",
                        brand_test: item?.inputs?.brand_test
                          ? item?.inputs?.brand_test
                          : saved_form_inputs_test?.brand_test,
                        brand_live: item?.inputs?.brand_live
                          ? item?.inputs?.brand_live
                          : "",
                        payout_client_key_test: item?.inputs?.payout_client_key_test
                          ? item?.inputs?.payout_client_key_test
                          : saved_form_inputs_test?.payout_client_key_test,
                        payout_client_key_live: item?.inputs?.payout_client_key_live
                          ? item?.inputs?.payout_client_key_live
                          : "",
                        payout_password_test: item?.inputs?.payout_password_test
                          ? item?.inputs?.payout_password_test
                          : saved_form_inputs_test?.payout_password_test,
                        payout_password_live: item?.inputs?.payout_password_live
                          ? item?.inputs?.payout_password_live
                          : "",
                        payout_brand_test: item?.inputs?.payout_brand_test
                          ? item?.inputs?.payout_brand_test
                          : saved_form_inputs_test?.payout_brand_test,
                        payout_brand_live: item?.inputs?.payout_brand_live
                          ? item?.inputs?.payout_brand_live
                          : "",
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                         : type === "TestGateway"
                    ? {
                        ...item?.inputs,
                        is_live: value === undefined ? false : value,
                        is_active: is_active,
                        test_endpoint: item?.test_endpoint
                          ? item?.test_endpoint
                          : saved_form_fees_details_test[0]?.test_endpoint,
                        live_endpoint: item?.live_endpoint
                          ? item?.live_endpoint
                          : saved_form_fees_details_test[0]?.live_endpoint,
                          advanced_avs : {
                            validate_address  : item?.advanced_avs?.validate_address || false,
                            validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                            validate_email  : item?.advanced_avs?.validate_email || false,
                            validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                          },
                        velocity: {
                          transaction_limit: {
                            allow_transaction_limit:
                              item?.velocity?.transaction_limit
                                ?.allow_transaction_limit || false,
                            limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                            period: item?.velocity?.transaction_limit?.period || "",
                          },
                          blocked_countries: {
                            allow_blocked_countries:
                              item?.velocity?.blocked_countries
                                ?.allow_blocked_countries || false,
                            country_code:
                              item?.velocity?.blocked_countries?.country_code || [],
                          },
                          blocked_countries_bin: {
                            allow_blocked_countries_bin:
                              item?.velocity?.blocked_countries_bin
                                ?.allow_blocked_countries_bin || false,
                            country_code:
                              item?.velocity?.blocked_countries_bin?.country_code || [],
                          },
                          max_transaction_limit: {
                            allow_max_transaction_limit:
                              item?.velocity?.max_transaction_limit
                                ?.allow_max_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.max_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.max_transaction_limit?.currency || "",
                          },
                          min_transaction_limit: {
                            allow_min_transaction_limit:
                              item?.velocity?.min_transaction_limit
                                ?.allow_min_transaction_limit || false,
                            limit_amount:
                              item?.velocity?.min_transaction_limit?.limit_amount || "",
                            currency:
                              item?.velocity?.min_transaction_limit?.currency || "",
                          },
                          max_transaction_period: {
                            allow_max_transaction_period:
                              item?.velocity?.max_transaction_period
                                ?.allow_max_transaction_period || false,
                            limit_amount:
                              item?.velocity?.max_transaction_period?.limit_amount ||
                              "",
                            currency:
                              item?.velocity?.max_transaction_period?.currency || "",
                            period:
                              item?.velocity?.max_transaction_period?.period || "",
                          },
                          retry_time: {
                            allow_retry_time:
                              item?.velocity?.retry_time?.allow_retry_time || false,
                            limit_minutes:
                              item?.velocity?.retry_time?.limit_minutes || "",
                          },
                          max_attempts_day: {
                            allow_max_attempts_day:
                              item?.velocity?.max_attempts_day
                                ?.allow_max_attempts_day || false,
                            limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                          },
                          max_attempts_week: {
                            allow_max_attempts_week:
                              item?.velocity?.max_attempts_week
                                ?.allow_max_attempts_week || false,
                            limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                          },
                          max_attempts_month: {
                            allow_max_attempts_month:
                              item?.velocity?.max_attempts_month
                                ?.allow_max_attempts_month || false,
                            limit_no:
                              item?.velocity?.max_attempts_month?.limit_no || "",
                          },
                          max_attempts_total: {
                            allow_max_attempts_total:
                              item?.velocity?.max_attempts_total
                                ?.allow_max_attempts_total || false,
                            limit_no:
                              item?.velocity?.max_attempts_total?.limit_no || "",
                          },
                        },
                        
                        client_card_types:
                          // item?.reserved_pricing?.client_card_types || [],
                          item?.reserved_pricing?.client_card_types?.map((m: any) => {
                            return {
                              card_name: m?.card_name,
                              percentage_fee: m?.percentage_fee,
                              fixed_fee: m?.fixed_fee,
                              currency_code: m?.currency_code,
                              allow_card: m?.allow_card,
        
                              cost_percentage_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.percentage_fee || "",
                              cost_fixed_fee:
                                item?.cost?.client_card_types?.filter(
                                  (f: any) => f?.card_name == m?.card_name
                                )[0]?.fixed_fee || "",
                              cost_currency_code: item?.cost?.client_card_types?.filter(
                                (f: any) => f?.card_name == m?.card_name
                              )[0]?.currency_code,
                            };
                          }),
                        // additional_fees: item?.reserved_pricing?.additional_fees || {},
                        additional_fees: {
                          chargeback_fees:
                            item?.reserved_pricing?.additional_fees?.chargeback_fees,
                          dispute_fees:
                            item?.reserved_pricing?.additional_fees?.dispute_fees,
                          reserve_fees:
                            item?.reserved_pricing?.additional_fees?.reserve_fees,
                          refunded_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                          declined_tnx_fees:
                            item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                          cost_chargeback_fees:
                            item?.cost?.additional_fees?.chargeback_fees,
                          cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                          cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                          cost_refunded_tnx_fees:
                            item?.cost?.additional_fees?.refunded_tnx_fees,
                          cost_declined_tnx_fees:
                            item?.cost?.additional_fees?.declined_tnx_fees,
                        },
                        cardTypes: saved_form_CardTypes,
                        payout_fees: item?.payout_fees || {},
                        wallet_ids: item?.wallet_ids || [],
                        ewallet_New_addressess: [],
                        disCard_walletes: [],
                        fess_conditions: {
                          apm: saved_form_fees_details_test[0]?.apm,
                          payout: saved_form_fees_details_test[0]?.payout,
                          payin: saved_form_fees_details_test[0]?.payin,
                        },
                        payment_methods: item?.payment_method
                          ? item?.payment_method?.filterPaymentMethod
                          : convertIntoArray(saved_form_fees_details_test),
                        gateway_method_fees:
                          // item?.reserved_pricing?.gateway_method_fees || {},
                          {
                            apm_fees:
                              item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                            cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                            payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            cost_payout_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                            payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                            cost_payin_fees:
                              item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                          },
                        type: type,
                        whitelist_enabled: item?.whitelist_enabled,
                      }
                : type === "Re-set"
            ? {
                ...item?.inputs,
                is_live: value === undefined ? false : value,
                is_active: is_active,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                  advanced_avs : {
                    validate_address  : item?.advanced_avs?.validate_address || false,
                    validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                    validate_email  : item?.advanced_avs?.validate_email || false,
                    validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                  },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                secretKey_test: item?.inputs?.secretKey_test
                  ? item?.inputs?.secretKey_test
                  : saved_form_inputs_test?.merchant_id_test,
                secretKey_live: item?.inputs?.secretKey_live
                  ? item?.inputs?.secretKey_live
                  : "",
                brand_id_test: item?.inputs?.brand_id_test
                  ? item?.inputs?.brand_id_test
                  : saved_form_inputs_test?.merchant_id_test,
                brand_id_live: item?.inputs?.brand_id_live
                  ? item?.inputs?.brand_id_live
                  : "",
                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Raypd"
            ? {
                ...item?.inputs,
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },
                secret_key_test: item?.inputs?.secret_key_test
                  ? item?.inputs?.secret_key_test
                  : saved_form_inputs_test?.secret_key_test,
                secret_key_live: item?.inputs?.secret_key_live
                  ? item?.inputs?.secret_key_live
                  : "",
                mid_country_test: item?.inputs?.mid_country_test
                  ? item?.inputs?.mid_country_test
                  : saved_form_inputs_test?.mid_country_test || "",
                mid_country_live: item?.inputs?.mid_country_live
                  ? item?.inputs?.mid_country_live
                  : "",
                access_key_test: item?.inputs?.access_key_test
                  ? item?.inputs?.access_key_test
                  : saved_form_inputs_test?.access_key_test,
                access_key_live: item?.inputs?.access_key_live
                  ? item?.inputs?.access_key_live
                  : "",
                client_card_types:
                  // item?.reserved_pricing?.client_card_types || [],
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Scipiopay"
            ? {
                ...item?.inputs,
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                shop_id_test: item?.inputs?.shop_id_test
                  ? item?.inputs?.shop_id_test
                  : saved_form_inputs_test?.shop_id_test,
                shop_id_live: item?.inputs?.shop_id_live
                  ? item?.inputs?.shop_id_live
                  : "",
                shop_secret_key_test: item?.inputs?.shop_secret_key_test
                  ? item?.inputs?.shop_secret_key_test
                  : saved_form_inputs_test?.shop_secret_key_test,
                shop_secret_key_live: item?.inputs?.shop_secret_key_live
                  ? item?.inputs?.shop_secret_key_live
                  : "",
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                // additional_fees: item?.reserved_pricing?.additional_fees || {},
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees: {
                  apm_fees:
                    item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                  cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                  payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  cost_payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  cost_payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            
            : type === "Platy 2DS"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },

                api_key_test: item?.inputs?.api_key_test
                  ? item?.inputs?.api_key_test
                  : saved_form_inputs_test?.api_key_test,
                api_key_live: item?.inputs?.api_key_live
                  ? item?.inputs?.api_key_live
                  : "",

                password_test: item?.inputs?.password_test
                  ? item?.inputs?.password_test
                  : saved_form_inputs_test?.password_test,
                password_live: item?.inputs?.password_live
                  ? item?.inputs?.password_live
                  : "",

                platy_api_key_test: item?.inputs?.platy_api_key_test
                  ? item?.inputs?.platy_api_key_test
                  : saved_form_inputs_test?.platy_api_key_test,
                platy_api_key_live: item?.inputs?.platy_api_key_live
                  ? item?.inputs?.platy_api_key_live
                  : "",

                platy_secret_key_test: item?.inputs?.platy_secret_key_test
                  ? item?.inputs?.platy_secret_key_test
                  : saved_form_inputs_test?.platy_secret_key_test,
                platy_secret_key_live: item?.inputs?.platy_secret_key_live
                  ? item?.inputs?.platy_secret_key_live
                  : "",

                username_test: item?.inputs?.username_test
                  ? item?.inputs?.username_test
                  : saved_form_inputs_test?.platy_secret_key_test,
                username_live: item?.inputs?.username_live
                  ? item?.inputs?.username_live
                  : "",

                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
              : type === "3xpay"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },

                api_key_test: item?.inputs?.api_key_test
                  ? item?.inputs?.api_key_test
                  : saved_form_inputs_test?.api_key_test,
                api_key_live: item?.inputs?.api_key_live
                  ? item?.inputs?.api_key_live
                  : "",

                api_secret_test: item?.inputs?.api_secret_test
                  ? item?.inputs?.api_secret_test
                  : saved_form_inputs_test?.api_secret_test,
                api_secret_live: item?.inputs?.api_secret_live
                  ? item?.inputs?.api_secret_live
                  : "",

                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
              : type === "Platy 3DS"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },

                api_key_test: item?.inputs?.api_key_test
                  ? item?.inputs?.api_key_test
                  : saved_form_inputs_test?.api_key_test,
                api_key_live: item?.inputs?.api_key_live
                  ? item?.inputs?.api_key_live
                  : "",

                password_test: item?.inputs?.password_test
                  ? item?.inputs?.password_test
                  : saved_form_inputs_test?.password_test,
                password_live: item?.inputs?.password_live
                  ? item?.inputs?.password_live
                  : "",

                platy_api_key_test: item?.inputs?.platy_api_key_test
                  ? item?.inputs?.platy_api_key_test
                  : saved_form_inputs_test?.platy_api_key_test,
                platy_api_key_live: item?.inputs?.platy_api_key_live
                  ? item?.inputs?.platy_api_key_live
                  : "",

                platy_secret_key_test: item?.inputs?.platy_secret_key_test
                  ? item?.inputs?.platy_secret_key_test
                  : saved_form_inputs_test?.platy_secret_key_test,
                platy_secret_key_live: item?.inputs?.platy_secret_key_live
                  ? item?.inputs?.platy_secret_key_live
                  : "",

                username_test: item?.inputs?.username_test
                  ? item?.inputs?.username_test
                  : saved_form_inputs_test?.platy_secret_key_test,
                username_live: item?.inputs?.username_live
                  ? item?.inputs?.username_live
                  : "",

                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Betapay"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                api_token_test: item?.inputs?.api_token_test
                  ? item?.inputs?.api_token_test
                  : saved_form_inputs_test?.api_token_test,
                api_token_live: item?.inputs?.api_token_live
                  ? item?.inputs?.api_token_live
                  : "",
                merchant_id_test: item?.inputs?.merchant_id_test
                  ? item?.inputs?.merchant_id_test
                  : saved_form_inputs_test?.merchant_id_test,
                merchant_id_live: item?.inputs?.merchant_id_live
                  ? item?.inputs?.merchant_id_live
                  : "",
                terminal_id_test: item?.inputs?.terminal_id_test
                  ? item?.inputs?.terminal_id_test
                  : saved_form_inputs_test?.terminal_id_test,
                terminal_id_live: item?.inputs?.terminal_id_live
                  ? item?.inputs?.terminal_id_live
                  : "",
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees: {
                  apm_fees:
                    item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                  cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                  payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  cost_payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  cost_payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Aurea Via"
            ? {
                ...item?.inputs,
                is_active: is_active,
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                companyNum_test: item?.inputs?.companyNum_test
                  ? item?.inputs?.companyNum_test
                  : saved_form_inputs_test?.companyNum_test,
                companyNum_live: item?.inputs?.companyNum_live
                  ? item?.inputs?.companyNum_live
                  : "",
                personalHashkey_test: item?.inputs?.personalHashkey_test
                  ? item?.inputs?.personalHashkey_test
                  : saved_form_inputs_test?.personalHashkey_test,
                personalHashkey_live: item?.inputs?.personalHashkey_live
                  ? item?.inputs?.personalHashkey_live
                  : "",

                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Kasha"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,
                api_key_test: item?.inputs?.api_key_test
                  ? item?.inputs?.api_key_test
                  : saved_form_inputs_test?.api_key_test,
                api_key_live: item?.inputs?.api_key_live
                  ? item?.inputs?.api_key_live
                  : "",

                merchant_domain_test: item?.inputs?.merchant_domain_test
                  ? item?.inputs?.merchant_domain_test
                  : saved_form_inputs_test?.merchant_domain_test,
                merchant_domain_live: item?.inputs?.merchant_domain_live
                  ? item?.inputs?.merchant_domain_live
                  : "",
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees: {
                  apm_fees:
                    item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                  cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                  payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  cost_payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  cost_payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Supefina"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                merchant_id_test: item?.inputs?.merchant_id_test
                  ? item?.inputs?.merchant_id_test
                  : saved_form_inputs_test?.merchant_id_test,
                merchant_id_live: item?.inputs?.merchant_id_live
                  ? item?.inputs?.merchant_id_live
                  : "",
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees: {
                  apm_fees:
                    item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                  cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                  payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  cost_payout_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                  payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  cost_payin_fees:
                    item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Masterpay"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                merchant_private_key_test: item?.inputs
                  ?.merchant_private_key_test
                  ? item?.inputs?.merchant_private_key_test
                  : saved_form_inputs_test?.merchant_private_key_test,
                merchant_private_key_live: item?.inputs
                  ?.merchant_private_key_live
                  ? item?.inputs?.merchant_private_key_live
                  : "",
                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
            : type === "Neonpay"
            ? {
                ...item?.inputs,
                is_active: is_active,
                advanced_avs : {
                  validate_address  : item?.advanced_avs?.validate_address || false,
                  validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                  validate_email  : item?.advanced_avs?.validate_email || false,
                  validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                },
                velocity: {
                  transaction_limit: {
                    allow_transaction_limit:
                      item?.velocity?.transaction_limit
                        ?.allow_transaction_limit || false,
                    limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                    period: item?.velocity?.transaction_limit?.period || "",
                  },
                  blocked_countries: {
                    allow_blocked_countries:
                      item?.velocity?.blocked_countries
                        ?.allow_blocked_countries || false,
                    country_code:
                      item?.velocity?.blocked_countries?.country_code || [],
                  },
                  blocked_countries_bin: {
                    allow_blocked_countries_bin:
                      item?.velocity?.blocked_countries_bin
                        ?.allow_blocked_countries_bin || false,
                    country_code:
                      item?.velocity?.blocked_countries_bin?.country_code || [],
                  },
                  max_transaction_limit: {
                    allow_max_transaction_limit:
                      item?.velocity?.max_transaction_limit
                        ?.allow_max_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.max_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.max_transaction_limit?.currency || "",
                  },
                  min_transaction_limit: {
                    allow_min_transaction_limit:
                      item?.velocity?.min_transaction_limit
                        ?.allow_min_transaction_limit || false,
                    limit_amount:
                      item?.velocity?.min_transaction_limit?.limit_amount || "",
                    currency:
                      item?.velocity?.min_transaction_limit?.currency || "",
                  },
                  max_transaction_period: {
                    allow_max_transaction_period:
                      item?.velocity?.max_transaction_period
                        ?.allow_max_transaction_period || false,
                    limit_amount:
                      item?.velocity?.max_transaction_period?.limit_amount ||
                      "",
                    currency:
                      item?.velocity?.max_transaction_period?.currency || "",
                    period:
                      item?.velocity?.max_transaction_period?.period || "",
                  },
                  retry_time: {
                    allow_retry_time:
                      item?.velocity?.retry_time?.allow_retry_time || false,
                    limit_minutes:
                      item?.velocity?.retry_time?.limit_minutes || "",
                  },
                  max_attempts_day: {
                    allow_max_attempts_day:
                      item?.velocity?.max_attempts_day
                        ?.allow_max_attempts_day || false,
                    limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                  },
                  max_attempts_week: {
                    allow_max_attempts_week:
                      item?.velocity?.max_attempts_week
                        ?.allow_max_attempts_week || false,
                    limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                  },
                  max_attempts_month: {
                    allow_max_attempts_month:
                      item?.velocity?.max_attempts_month
                        ?.allow_max_attempts_month || false,
                    limit_no:
                      item?.velocity?.max_attempts_month?.limit_no || "",
                  },
                  max_attempts_total: {
                    allow_max_attempts_total:
                      item?.velocity?.max_attempts_total
                        ?.allow_max_attempts_total || false,
                    limit_no:
                      item?.velocity?.max_attempts_total?.limit_no || "",
                  },
                },

                is_live: value === undefined ? false : value,
                test_endpoint: item?.test_endpoint
                  ? item?.test_endpoint
                  : saved_form_fees_details_test[0]?.test_endpoint,
                live_endpoint: item?.live_endpoint
                  ? item?.live_endpoint
                  : saved_form_fees_details_test[0]?.live_endpoint,

                merchant_key_test: item?.inputs?.merchant_key_test
                  ? item?.inputs?.merchant_key_test
                  : saved_form_inputs_test?.merchant_key_test,
                merchant_key_live: item?.inputs?.merchant_key_live
                  ? item?.inputs?.merchant_key_live
                  : "",

                password_test: item?.inputs?.password_test
                  ? item?.inputs?.password_test
                  : saved_form_inputs_test?.password_test,
                password_live: item?.inputs?.password_live
                  ? item?.inputs?.password_live
                  : "",

                // term_url_3ds_test: item?.inputs?.term_url_3ds_test
                //   ? item?.inputs?.term_url_3ds_test
                //   : saved_form_inputs_test?.term_url_3ds_test || "",
                // term_url_3ds_live: item?.inputs?.term_url_3ds_live
                //   ? item?.inputs?.term_url_3ds_live
                  // : "",

                client_card_types:
                  item?.reserved_pricing?.client_card_types?.map((m: any) => {
                    return {
                      card_name: m?.card_name,
                      percentage_fee: m?.percentage_fee,
                      fixed_fee: m?.fixed_fee,
                      currency_code: m?.currency_code,
                      allow_card: m?.allow_card,

                      cost_percentage_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.percentage_fee || "",
                      cost_fixed_fee:
                        item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.fixed_fee || "",
                      cost_currency_code: item?.cost?.client_card_types?.filter(
                        (f: any) => f?.card_name == m?.card_name
                      )[0]?.currency_code,
                    };
                  }),
                additional_fees: {
                  chargeback_fees:
                    item?.reserved_pricing?.additional_fees?.chargeback_fees,
                  dispute_fees:
                    item?.reserved_pricing?.additional_fees?.dispute_fees,
                  reserve_fees:
                    item?.reserved_pricing?.additional_fees?.reserve_fees,
                  refunded_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                  declined_tnx_fees:
                    item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                  cost_chargeback_fees:
                    item?.cost?.additional_fees?.chargeback_fees,
                  cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                  cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                  cost_refunded_tnx_fees:
                    item?.cost?.additional_fees?.refunded_tnx_fees,
                  cost_declined_tnx_fees:
                    item?.cost?.additional_fees?.declined_tnx_fees,
                },
                cardTypes: saved_form_CardTypes,
                payout_fees: item?.payout_fees || {},
                wallet_ids: item?.wallet_ids || [],
                ewallet_New_addressess: [],
                disCard_walletes: [],
                fess_conditions: {
                  apm: saved_form_fees_details_test[0]?.apm,
                  payout: saved_form_fees_details_test[0]?.payout,
                  payin: saved_form_fees_details_test[0]?.payin,
                },
                payment_methods: item?.payment_method
                  ? item?.payment_method?.filterPaymentMethod
                  : convertIntoArray(saved_form_fees_details_test),
                gateway_method_fees:
                  // item?.reserved_pricing?.gateway_method_fees || {},
                  {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                type: type,
                whitelist_enabled: item?.whitelist_enabled,
              }
              : type === "Bm2pay"
              ? {
                  ...item?.inputs,
                  is_active: is_active,
                  advanced_avs : {
                    validate_address  : item?.advanced_avs?.validate_address || false,
                    validate_phone_number  : item?.advanced_avs?.validate_phone_number || false,
                    validate_email  : item?.advanced_avs?.validate_email || false,
                    validate_ip_address  : item?.advanced_avs?.validate_ip_address || false,
                  },
                  velocity: {
                    transaction_limit: {
                      allow_transaction_limit:
                        item?.velocity?.transaction_limit
                          ?.allow_transaction_limit || false,
                      limit_no: item?.velocity?.transaction_limit?.limit_no || "",
                      period: item?.velocity?.transaction_limit?.period || "",
                    },
                    blocked_countries: {
                      allow_blocked_countries:
                        item?.velocity?.blocked_countries
                          ?.allow_blocked_countries || false,
                      country_code:
                        item?.velocity?.blocked_countries?.country_code || [],
                    },
                    blocked_countries_bin: {
                      allow_blocked_countries_bin:
                        item?.velocity?.blocked_countries_bin
                          ?.allow_blocked_countries_bin || false,
                      country_code:
                        item?.velocity?.blocked_countries_bin?.country_code || [],
                    },
                    max_transaction_limit: {
                      allow_max_transaction_limit:
                        item?.velocity?.max_transaction_limit
                          ?.allow_max_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.max_transaction_limit?.limit_amount || "",
                      currency:
                        item?.velocity?.max_transaction_limit?.currency || "",
                    },
                    min_transaction_limit: {
                      allow_min_transaction_limit:
                        item?.velocity?.min_transaction_limit
                          ?.allow_min_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.min_transaction_limit?.limit_amount || "",
                      currency:
                        item?.velocity?.min_transaction_limit?.currency || "",
                    },
                    max_transaction_period: {
                      allow_max_transaction_period:
                        item?.velocity?.max_transaction_period
                          ?.allow_max_transaction_period || false,
                      limit_amount:
                        item?.velocity?.max_transaction_period?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.max_transaction_period?.currency || "",
                      period:
                        item?.velocity?.max_transaction_period?.period || "",
                    },
                    retry_time: {
                      allow_retry_time:
                        item?.velocity?.retry_time?.allow_retry_time || false,
                      limit_minutes:
                        item?.velocity?.retry_time?.limit_minutes || "",
                    },
                    max_attempts_day: {
                      allow_max_attempts_day:
                        item?.velocity?.max_attempts_day
                          ?.allow_max_attempts_day || false,
                      limit_no: item?.velocity?.max_attempts_day?.limit_no || "",
                    },
                    max_attempts_week: {
                      allow_max_attempts_week:
                        item?.velocity?.max_attempts_week
                          ?.allow_max_attempts_week || false,
                      limit_no: item?.velocity?.max_attempts_week?.limit_no || "",
                    },
                    max_attempts_month: {
                      allow_max_attempts_month:
                        item?.velocity?.max_attempts_month
                          ?.allow_max_attempts_month || false,
                      limit_no:
                        item?.velocity?.max_attempts_month?.limit_no || "",
                    },
                    max_attempts_total: {
                      allow_max_attempts_total:
                        item?.velocity?.max_attempts_total
                          ?.allow_max_attempts_total || false,
                      limit_no:
                        item?.velocity?.max_attempts_total?.limit_no || "",
                    },
                  },
  
                  is_live: value === undefined ? false : value,
                  test_endpoint: item?.test_endpoint
                    ? item?.test_endpoint
                    : saved_form_fees_details_test[0]?.test_endpoint,
                  live_endpoint: item?.live_endpoint
                    ? item?.live_endpoint
                    : saved_form_fees_details_test[0]?.live_endpoint,
  
                  client_id_test: item?.inputs?.client_id_test
                    ? item?.inputs?.client_id_test
                    : saved_form_inputs_test?.client_id_test,
                  client_id_live: item?.inputs?.client_id_live
                    ? item?.inputs?.client_id_live
                    : "",
  
                  client_secret_test: item?.inputs?.client_secret_test
                    ? item?.inputs?.client_secret_test
                    : saved_form_inputs_test?.client_secret_test,
                  client_secret_live: item?.inputs?.client_secret_live
                    ? item?.inputs?.client_secret_live
                    : "",
                  client_card_types:
                    item?.reserved_pricing?.client_card_types?.map((m: any) => {
                      return {
                        card_name: m?.card_name,
                        percentage_fee: m?.percentage_fee,
                        fixed_fee: m?.fixed_fee,
                        currency_code: m?.currency_code,
                        allow_card: m?.allow_card,
  
                        cost_percentage_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.percentage_fee || "",
                        cost_fixed_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.fixed_fee || "",
                        cost_currency_code: item?.cost?.client_card_types?.filter(
                          (f: any) => f?.card_name == m?.card_name
                        )[0]?.currency_code,
                      };
                    }),
                  additional_fees: {
                    chargeback_fees:
                      item?.reserved_pricing?.additional_fees?.chargeback_fees,
                    dispute_fees:
                      item?.reserved_pricing?.additional_fees?.dispute_fees,
                    reserve_fees:
                      item?.reserved_pricing?.additional_fees?.reserve_fees,
                    refunded_tnx_fees:
                      item?.reserved_pricing?.additional_fees?.refunded_tnx_fees,
                    declined_tnx_fees:
                      item?.reserved_pricing?.additional_fees?.declined_tnx_fees,
                    cost_chargeback_fees:
                      item?.cost?.additional_fees?.chargeback_fees,
                    cost_dispute_fees: item?.cost?.additional_fees?.dispute_fees,
                    cost_reserve_fees: item?.cost?.additional_fees?.reserve_fees,
                    cost_refunded_tnx_fees:
                      item?.cost?.additional_fees?.refunded_tnx_fees,
                    cost_declined_tnx_fees:
                      item?.cost?.additional_fees?.declined_tnx_fees,
                  },
                  cardTypes: saved_form_CardTypes,
                  payout_fees: item?.payout_fees || {},
                  wallet_ids: item?.wallet_ids || [],
                  ewallet_New_addressess: [],
                  disCard_walletes: [],
                  fess_conditions: {
                    apm: saved_form_fees_details_test[0]?.apm,
                    payout: saved_form_fees_details_test[0]?.payout,
                    payin: saved_form_fees_details_test[0]?.payin,
                  },
                  payment_methods: item?.payment_method
                    ? item?.payment_method?.filterPaymentMethod
                    : convertIntoArray(saved_form_fees_details_test),
                  gateway_method_fees: {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                  type: type,
                  whitelist_enabled: item?.whitelist_enabled,
                }
            : type === "Sipe" || type === "Blumon" || type === "Pix-Lotus"
            ? saved_form_inputs?.[0]?.client_id !== ""
              ? {
                  ...item?.inputs,
                  // is_live: value,
                  is_live: value === undefined ? false : value,
                  is_active: is_active,
                  velocity: {
                    transaction_limit: {
                      allow_transaction_limit:
                        item?.velocity?.transaction_limit
                          ?.allow_transaction_limit || false,
                      limit_no:
                        item?.velocity?.transaction_limit?.limit_no || "",
                      period: item?.velocity?.transaction_limit?.period || "",
                    },
                    blocked_countries: {
                      allow_blocked_countries:
                        item?.velocity?.blocked_countries
                          ?.allow_blocked_countries || false,
                      country_code:
                        item?.velocity?.blocked_countries?.country_code || [],
                    },
                    blocked_countries_bin: {
                      allow_blocked_countries_bin:
                        item?.velocity?.blocked_countries_bin
                          ?.allow_blocked_countries_bin || false,
                      country_code:
                        item?.velocity?.blocked_countries_bin?.country_code ||
                        [],
                    },
                    max_transaction_limit: {
                      allow_max_transaction_limit:
                        item?.velocity?.max_transaction_limit
                          ?.allow_max_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.max_transaction_limit?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.max_transaction_limit?.currency || "",
                    },
                    min_transaction_limit: {
                      allow_min_transaction_limit:
                        item?.velocity?.min_transaction_limit
                          ?.allow_min_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.min_transaction_limit?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.min_transaction_limit?.currency || "",
                    },
                    max_transaction_period: {
                      allow_max_transaction_period:
                        item?.velocity?.max_transaction_period
                          ?.allow_max_transaction_period || false,
                      limit_amount:
                        item?.velocity?.max_transaction_period?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.max_transaction_period?.currency || "",
                      period:
                        item?.velocity?.max_transaction_period?.period || "",
                    },
                    retry_time: {
                      allow_retry_time:
                        item?.velocity?.retry_time?.allow_retry_time || false,
                      limit_minutes:
                        item?.velocity?.retry_time?.limit_minutes || "",
                    },
                    max_attempts_day: {
                      allow_max_attempts_day:
                        item?.velocity?.max_attempts_day
                          ?.allow_max_attempts_day || false,
                      limit_no:
                        item?.velocity?.max_attempts_day?.limit_no || "",
                    },
                    max_attempts_week: {
                      allow_max_attempts_week:
                        item?.velocity?.max_attempts_week
                          ?.allow_max_attempts_week || false,
                      limit_no:
                        item?.velocity?.max_attempts_week?.limit_no || "",
                    },
                    max_attempts_month: {
                      allow_max_attempts_month:
                        item?.velocity?.max_attempts_month
                          ?.allow_max_attempts_month || false,
                      limit_no:
                        item?.velocity?.max_attempts_month?.limit_no || "",
                    },
                    max_attempts_total: {
                      allow_max_attempts_total:
                        item?.velocity?.max_attempts_total
                          ?.allow_max_attempts_total || false,
                      limit_no:
                        item?.velocity?.max_attempts_total?.limit_no || "",
                    },
                  },

                  client_card_types:
                    item?.reserved_pricing?.client_card_types?.map((m: any) => {
                      return {
                        card_name: m?.card_name,
                        percentage_fee: m?.percentage_fee,
                        fixed_fee: m?.fixed_fee,
                        currency_code: m?.currency_code,
                        allow_card: m?.allow_card,
                        cost_percentage_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.percentage_fee || "",
                        cost_fixed_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.fixed_fee || "",
                        cost_currency_code:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.currency_code,
                      };
                    }),

                  test_endpoint: item?.test_endpoint
                    ? item?.test_endpoint
                    : saved_form_fees_details_test[0]?.test_endpoint,
                  live_endpoint: item?.live_endpoint
                    ? item?.live_endpoint
                    : saved_form_fees_details_test[0]?.live_endpoint,
                  additional_fees: {
                    chargeback_fees:
                      item?.reserved_pricing?.additional_fees?.chargeback_fees,
                    dispute_fees:
                      item?.reserved_pricing?.additional_fees?.dispute_fees,
                    reserve_fees:
                      item?.reserved_pricing?.additional_fees?.reserve_fees,
                    refunded_tnx_fees:
                      item?.reserved_pricing?.additional_fees
                        ?.refunded_tnx_fees,
                    declined_tnx_fees:
                      item?.reserved_pricing?.additional_fees
                        ?.declined_tnx_fees,
                    cost_chargeback_fees:
                      item?.cost?.additional_fees?.chargeback_fees,
                    cost_dispute_fees:
                      item?.cost?.additional_fees?.dispute_fees,
                    cost_reserve_fees:
                      item?.cost?.additional_fees?.reserve_fees,
                    cost_refunded_tnx_fees:
                      item?.cost?.additional_fees?.refunded_tnx_fees,
                    cost_declined_tnx_fees:
                      item?.cost?.additional_fees?.declined_tnx_fees,
                  },
                  cardTypes: saved_form_CardTypes,
                  payout_fees: item?.payout_fees || {},
                  wallet_ids: item?.wallet_ids || [],
                  ewallet_New_addressess: [],
                  disCard_walletes: [],
                  fess_conditions: {
                    apm: saved_form_fees_details_test[0]?.apm,
                    payout: saved_form_fees_details_test[0]?.payout,
                    payin: saved_form_fees_details_test[0]?.payin,
                  },
                  payment_methods: convertIntoArray(
                    saved_form_fees_details_test
                  ),
                  gateway_method_fees: {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                  type: type,
                  whitelist_enabled: item?.whitelist_enabled,
                }
              : {
                  ...item?.inputs,
                  // is_live: value,
                  is_live: value === undefined ? false : value,
                  is_active: is_active,
                  velocity: {
                    transaction_limit: {
                      allow_transaction_limit:
                        item?.velocity?.transaction_limit
                          ?.allow_transaction_limit || false,
                      limit_no:
                        item?.velocity?.transaction_limit?.limit_no || "",
                      period: item?.velocity?.transaction_limit?.period || "",
                    },
                    blocked_countries: {
                      allow_blocked_countries:
                        item?.velocity?.blocked_countries
                          ?.allow_blocked_countries || false,
                      country_code:
                        item?.velocity?.blocked_countries?.country_code || [],
                    },
                    blocked_countries_bin: {
                      allow_blocked_countries_bin:
                        item?.velocity?.blocked_countries_bin
                          ?.allow_blocked_countries_bin || false,
                      country_code:
                        item?.velocity?.blocked_countries_bin?.country_code ||
                        [],
                    },
                    max_transaction_limit: {
                      allow_max_transaction_limit:
                        item?.velocity?.max_transaction_limit
                          ?.allow_max_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.max_transaction_limit?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.max_transaction_limit?.currency || "",
                    },
                    min_transaction_limit: {
                      allow_min_transaction_limit:
                        item?.velocity?.min_transaction_limit
                          ?.allow_min_transaction_limit || false,
                      limit_amount:
                        item?.velocity?.min_transaction_limit?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.min_transaction_limit?.currency || "",
                    },
                    max_transaction_period: {
                      allow_max_transaction_period:
                        item?.velocity?.max_transaction_period
                          ?.allow_max_transaction_period || false,
                      limit_amount:
                        item?.velocity?.max_transaction_period?.limit_amount ||
                        "",
                      currency:
                        item?.velocity?.max_transaction_period?.currency || "",
                      period:
                        item?.velocity?.max_transaction_period?.period || "",
                    },
                    retry_time: {
                      allow_retry_time:
                        item?.velocity?.retry_time?.allow_retry_time || false,
                      limit_minutes:
                        item?.velocity?.retry_time?.limit_minutes || "",
                    },
                    max_attempts_day: {
                      allow_max_attempts_day:
                        item?.velocity?.max_attempts_day
                          ?.allow_max_attempts_day || false,
                      limit_no:
                        item?.velocity?.max_attempts_day?.limit_no || "",
                    },
                    max_attempts_week: {
                      allow_max_attempts_week:
                        item?.velocity?.max_attempts_week
                          ?.allow_max_attempts_week || false,
                      limit_no:
                        item?.velocity?.max_attempts_week?.limit_no || "",
                    },
                    max_attempts_month: {
                      allow_max_attempts_month:
                        item?.velocity?.max_attempts_month
                          ?.allow_max_attempts_month || false,
                      limit_no:
                        item?.velocity?.max_attempts_month?.limit_no || "",
                    },
                    max_attempts_total: {
                      allow_max_attempts_total:
                        item?.velocity?.max_attempts_total
                          ?.allow_max_attempts_total || false,
                      limit_no:
                        item?.velocity?.max_attempts_total?.limit_no || "",
                    },
                  },

                  ...saved_form_inputs_test,
                  client_card_types:
                    item?.reserved_pricing?.client_card_types?.map((m: any) => {
                      return {
                        card_name: m?.card_name,
                        percentage_fee: m?.percentage_fee,
                        fixed_fee: m?.fixed_fee,
                        currency_code: m?.currency_code,
                        allow_card: m?.allow_card,

                        cost_percentage_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.percentage_fee || "",
                        cost_fixed_fee:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.fixed_fee || "",
                        cost_currency_code:
                          item?.cost?.client_card_types?.filter(
                            (f: any) => f?.card_name == m?.card_name
                          )[0]?.currency_code,
                      };
                    }),

                  test_endpoint: item?.test_endpoint
                    ? item?.test_endpoint
                    : saved_form_fees_details_test[0]?.test_endpoint,
                  live_endpoint: item?.live_endpoint
                    ? item?.live_endpoint
                    : saved_form_fees_details_test[0]?.live_endpoint,
                  additional_fees: {
                    chargeback_fees:
                      item?.reserved_pricing?.additional_fees?.chargeback_fees,
                    dispute_fees:
                      item?.reserved_pricing?.additional_fees?.dispute_fees,
                    reserve_fees:
                      item?.reserved_pricing?.additional_fees?.reserve_fees,
                    refunded_tnx_fees:
                      item?.reserved_pricing?.additional_fees
                        ?.refunded_tnx_fees,
                    declined_tnx_fees:
                      item?.reserved_pricing?.additional_fees
                        ?.declined_tnx_fees,
                    cost_chargeback_fees:
                      item?.cost?.additional_fees?.chargeback_fees,
                    cost_dispute_fees:
                      item?.cost?.additional_fees?.dispute_fees,
                    cost_reserve_fees:
                      item?.cost?.additional_fees?.reserve_fees,
                    cost_refunded_tnx_fees:
                      item?.cost?.additional_fees?.refunded_tnx_fees,
                    cost_declined_tnx_fees:
                      item?.cost?.additional_fees?.declined_tnx_fees,
                  },
                  cardTypes: saved_form_CardTypes,
                  payout_fees: item?.payout_fees || {},
                  wallet_ids: item?.wallet_ids || [],
                  ewallet_New_addressess: [],
                  disCard_walletes: [],
                  fess_conditions: {
                    apm: saved_form_fees_details_test[0]?.apm,
                    payout: saved_form_fees_details_test[0]?.payout,
                    payin: saved_form_fees_details_test[0]?.payin,
                  },
                  payment_methods: convertIntoArray(
                    saved_form_fees_details_test
                  ),
                  gateway_method_fees: {
                    apm_fees:
                      item?.reserved_pricing?.gateway_method_fees?.apm_fees,
                    cost_apm_fees: item?.cost?.gateway_method_fees?.apm_fees,
                    payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    cost_payout_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payout_fees,
                    payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                    cost_payin_fees:
                      item?.reserved_pricing?.gateway_method_fees?.payin_fees,
                  },
                  type: type,
                  whitelist_enabled: item?.whitelist_enabled,
                }
            : {
                ...item?.inputs,
                is_live: value,
              };

        return {
          ...item,
          inputs: clonedObject,
        };
      });

    if (newSavedInput && newSavedInput.length > 0 && newSavedInput[0]?.inputs) {
      setFormValues(newSavedInput[0]?.inputs ?? {});
    } else {
      let form_inputs = gatewayTypes.filter((data) => data?.name === type);
      if (form_inputs && form_inputs.length > 0) {
        setFormValues(form_inputs[0]?.inputs);
      }
    }
    setTimeout(() => {
      setSideLoading(false)
    }, 1000);
    
  }, [type, addedgateways, gatewayTypes]);

  const handleReset = () => { setFormValues({}); setFormValuesErr({}); };

  function handleValueChange(e: any) {
    setFormValues({ ...formValues, [e.target.id]: e.target.value });
    setFormValuesErr({ ...formValuesErr, [e.target.id]: "" });
  }

  function handleCheckChange(e: any) {
    const filterPaymentMethod = formValues?.payment_methods?.map((method: any) => {
      if (method.name === e.target.id) return { ...method, is_Active: !method.is_Active };
      return method;
    });
    setFormValues({ ...formValues, payment_methods: filterPaymentMethod });
  }

  const handlePriceValueChange = (e: any, index: number, cardType: string, inputFieldType: any) => {
    if (inputFieldType === "cost_cardType_currency_code") {
      setFormValuesErr((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, cost_currency_code: "" } : m) }));
      if (formValues?.client_card_types?.filter((f: any) => f?.card_name === cardType)?.length > 0) {
        setFormValues((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, cost_currency_code: e } : m) }));
      } else {
        setFormValues((prev: any) => ({ ...prev, client_card_types: [...prev?.client_card_types, { card_name: cardType, cost_currency_code: e }] }));
      }
    } else if (inputFieldType === "cardType_currency_code") {
      setFormValuesErr((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, currency_code: "" } : m) }));
      if (formValues?.client_card_types?.filter((f: any) => f?.card_name === cardType)?.length > 0) {
        setFormValues((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, currency_code: e } : m) }));
      } else {
        setFormValues((prev: any) => ({ ...prev, client_card_types: [...prev?.client_card_types, { card_name: cardType, currency_code: e }] }));
      }
    } else {
      const name = e.target.id;
      let value = e.target.value;
      if (name === "allow_card") value = value === "true" ? true : false;
      if (name === "percentage_fee") value = value >= 0 && value <= 100 ? value : "";
      if (name === "cost_percentage_fee") value = value >= 0 && value <= 100 ? value : "";
      if (name === "fixed_fee") value = value >= 0 ? value : "";
      if (name === "cost_fixed_fee") value = value >= 0 ? value : "";
      if (name === "allow_card") {
        setFormValuesErr((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, percentage_fee: "", fixed_fee: "", currency_code: "", cost_percentage_fee: "", cost_fixed_fee: "", cost_currency_code: "" } : m) }));
      } else {
        setFormValuesErr((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, [name]: "" } : m) }));
      }
      if (formValues?.client_card_types?.filter((f: any) => f?.card_name === cardType)?.length > 0) {
        setFormValues((prev: any) => ({ ...prev, client_card_types: prev?.client_card_types?.map((m: any) => cardType === m?.card_name ? { ...m, [name]: value } : m) }));
      } else {
        const data = { card_name: cardType, [name]: value, cost_percentage_fee: "0", cost_fixed_fee: "0", cost_currency_code: "USD" };
        if (formValues?.client_card_types?.length > 0) {
          setFormValues((prev: any) => ({ ...prev, client_card_types: [...prev?.client_card_types, data] }));
        } else {
          setFormValues((prev: any) => ({ ...prev, client_card_types: [data] }));
        }
      }
    }
  };

  const handleMarginFee = (e: any) => {
    const name = e.target.id;
    let value = e.target.value;
    if (name === "percentage_fee") value = value >= 0 && value <= 100 ? value : "";
    if (name === "fixed_fee") value = value >= 0 ? value : "";
    setFormValues((prev: any) => ({ ...prev, crypto_fees: { ...prev?.crypto_fees, [name]: value } }));
    setFormValuesErr((prev: any) => ({ ...prev, crypto_fees: { ...(prev.crypto_fees || {}), [name]: value === "" ? "Please enter a value" : "" } }));
  };

  const hanldleCryptoCurrenyChange = (e: any, feeType: string) => {
    setFormValues((prev: any) => ({ ...prev, crypto_fees: { ...prev?.crypto_fees, currency_code: e } }));
  };

  const handleAdditionalValueChange = (e: any, feeType: string) => {
    if (feeType === "cost_chargeback_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, cost_chargeback_fees: { ...prev?.additional_fees?.cost_chargeback_fees, currency_code: e } } })); return; }
    if (feeType === "cost_dispute_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, cost_dispute_fees: { ...prev?.additional_fees?.cost_dispute_fees, currency_code: e } } })); return; }
    if (feeType === "dispute_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, dispute_fees: { ...prev?.additional_fees?.dispute_fees, currency_code: e } } })); return; }
    if (feeType === "chargeback_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, chargeback_fees: { ...prev?.additional_fees?.chargeback_fees, currency_code: e } } })); return; }
    if (feeType === "decliened_tnx_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, declined_tnx_fees: { ...prev?.additional_fees?.declined_tnx_fees, currency_code: e } } })); return; }
    if (feeType === "cost_decliened_tnx_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, cost_declined_tnx_fees: { ...prev?.additional_fees?.cost_declined_tnx_fees, currency_code: e } } })); return; }
    if (feeType === "refunded_tnx_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, refunded_tnx_fees: { ...prev?.additional_fees?.refunded_tnx_fees, currency_code: e } } })); return; }
    if (feeType === "cost_refunded_tnx_currency_code") { setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, cost_refunded_tnx_fees: { ...prev?.additional_fees?.cost_refunded_tnx_fees, currency_code: e } } })); return; }
    const name = e.target.id;
    let value = e.target.value;
    if (name === "percentage_fee") value = value >= 0 && value <= 100 ? value : "";
    if (name === "fixed_fee") value = value >= 0 ? value : "";
    if (["allow_chargeback_fees","allow_dispute_fees","allow_declined_tnx_fees","allow_refunded_tnx_fees","allow_reserve_fees"].includes(name)) value = value === "true" ? true : false;
    setFormValues((prev: any) => ({ ...prev, additional_fees: { ...prev?.additional_fees, [feeType]: { ...prev?.additional_fees[feeType], [name]: value } } }));
  };

  const handleAdditionalValueChangeOfCost = (e: any, feeType: string) => handleAdditionalValueChange(e, feeType);

  const handleGatewayMethodfeesValueChange = (e: any, feeType: string) => {
    if (feeType === "cost_payin_currency_code") { setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, cost_payin_fees: { ...prev?.gateway_method_fees?.cost_payin_fees, currency_code: e } } })); return; }
    if (feeType === "cost_payout_currency_code") { setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, cost_payout_fees: { ...prev?.gateway_method_fees?.cost_payout_fees, currency_code: e } } })); return; }
    if (feeType === "cost_apm_currency_code") { setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, cost_apm_fees: { ...prev?.gateway_method_fees?.cost_apm_fees, currency_code: e } } })); return; }
    if (feeType === "apm_currency_code") { setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, apm_fees: { ...prev?.gateway_method_fees?.apm_fees, currency_code: e } } })); return; }
    if (feeType === "payout_currency_code") { setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, payout_fees: { ...prev?.gateway_method_fees?.payout_fees, currency_code: e } } })); return; }
    if (feeType === "payin_currency_code") { setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, payin_fees: { ...prev?.gateway_method_fees?.payin_fees, currency_code: e } } })); return; }
    const name = e.target.id;
    let value = e.target.value;
    if (name === "percentage_fee") value = value >= 0 && value <= 100 ? value : "";
    if (name === "fixed_fee") value = value >= 0 ? value : "";
    setFormValues((prev: any) => ({ ...prev, gateway_method_fees: { ...prev?.gateway_method_fees, [feeType]: { ...prev?.gateway_method_fees[feeType], [name]: value } } }));
  };

  const handleVelocityValueChange = (e: any, fieldType: string, rowType: string) => {
    if (rowType === "transaction_limit") {
      if (fieldType === "period") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, transaction_limit: { ...prev?.velocity?.transaction_limit, period: e } } })); return; }
      const name = e.target.id; let value = e.target.value;
      if (name === "limit_no") value = value >= 0 ? value : "";
      if (name === "allow_transaction_limit") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (rowType === "max_transaction_limit") {
      if (fieldType === "currency") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, max_transaction_limit: { ...prev?.velocity?.max_transaction_limit, currency: e } } })); return; }
      const name = e.target.id; let value = e.target.value;
      if (name === "limit_amount") value = value >= 0 ? value : "";
      if (name === "allow_max_transaction_limit") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (rowType === "min_transaction_limit") {
      if (fieldType === "currency") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, min_transaction_limit: { ...prev?.velocity?.min_transaction_limit, currency: e } } })); return; }
      const name = e.target.id; let value = e.target.value;
      if (name === "limit_amount") value = value >= 0 ? value : "";
      if (name === "allow_min_transaction_limit") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (rowType === "max_transaction_period") {
      if (fieldType === "period") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, max_transaction_period: { ...prev?.velocity?.max_transaction_period, period: e } } })); return; }
      if (fieldType === "currency") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, max_transaction_period: { ...prev?.velocity?.max_transaction_period, currency: e } } })); return; }
      const name = e.target.id; let value = e.target.value;
      if (name === "limit_amount") value = value >= 0 ? value : "";
      if (name === "allow_max_transaction_period") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (rowType === "retry_time") {
      const name = e.target.id; let value = e.target.value;
      if (name === "limit_minutes") value = value >= 0 ? value : "";
      if (name === "allow_retry_time") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (["max_attempts_day","max_attempts_week","max_attempts_month","max_attempts_total"].includes(rowType)) {
      const name = e.target.id; let value = e.target.value;
      if (name === "limit_no") value = value >= 0 ? value : "";
      if (["allow_max_attempts_day","allow_max_attempts_week","allow_max_attempts_month","allow_max_attempts_total"].includes(name)) value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (rowType === "blocked_countries") {
      if (fieldType === "country_code") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, blocked_countries: { ...prev?.velocity?.blocked_countries, country_code: e } } })); return; }
      const name = e.target.id; let value = e.target.value;
      if (name === "allow_blocked_countries") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
    if (rowType === "blocked_countries_bin") {
      if (fieldType === "country_code") { setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, blocked_countries_bin: { ...prev?.velocity?.blocked_countries_bin, country_code: e } } })); return; }
      const name = e.target.id; let value = e.target.value;
      if (name === "allow_blocked_countries_bin") value = value === "true" ? true : false;
      setFormValues((prev: any) => ({ ...prev, velocity: { ...prev?.velocity, [rowType]: { ...prev?.velocity[rowType], [name]: value } } }));
    }
  };

  const handleAdvancedAVSChange = (e: any, fieldType: string) => {
    const { checked } = e.target;
    setFormValues((prev: any) => ({ ...prev, advanced_avs: { ...prev.advanced_avs, [fieldType]: checked } }));
  };

  const handlePayoutValueChange = (e: any, sectionType: string) => {
    const name = e.target.id; let value = e.target.value;
    if (name === "percentage") value = value >= 0 && value <= 100 ? value : "";
    if (name === "fixed_fee") value = value >= 0 ? value : "";
    setFormValues((prev: any) => ({ ...prev, payout_fees: { ...prev?.payout_fees, [name]: value } }));
  };

  const handleEwalletValueChange = (e: any, wallet_data: any, wallet_value_type: string) => {
    const name = e.target.id; let value = e.target.value;
    if (name === "percentage") value = value >= 0 && value <= 100 ? value : "";
    if (name === "fixed_fee") value = value >= 0 ? value : "";
    if (formValues?.wallet_ids?.filter((f: any) => f?.wallet_id === wallet_data?.wallet_id)?.length > 0) {
      setFormValues((prev: any) => ({ ...prev, wallet_ids: prev?.wallet_ids?.map((m: any) => wallet_data?.wallet_id === m?.wallet_id ? { ...m, [name]: value } : m) }));
    } else {
      setFormValues((prev: any) => ({ ...prev, wallet_ids: [...prev?.wallet_ids, { wallet_address: "", percentage: "", [name]: value }] }));
    }
  };

  const handleNewWalletValueChange = (e: any, wallet_data: any, wallet_value_type: string, wallet_Index: number) => {
    const name = e.target.id; let value = e.target.value;
    if (name === "percentage") value = value >= 0 && value <= 100 ? value : "";
    if (name === "fixed_fee") value = value >= 0 ? value : "";
    setFormValues((prev: any) => ({
      ...prev,
      ewallet_New_addressess: prev?.ewallet_New_addressess?.map((wd: any, i: number) => i === wallet_Index ? { ...wd, [name]: value } : wd),
    }));
  };

  const checkWallets = () => {
    const isCompleted = formValues?.ewallet_New_addressess?.every((w: any) => w?.wallet_address !== "" && w?.percentage !== "");
    if (isCompleted) { setWalletErrors(""); return true; }
    setWalletErrors("Please enter valid details for all wallets!"); return false;
  };

  const handleNewWallet = (e_type: string, NewWalletIndex: any) => {
    if (e_type === "add_New_wallet") {
      const isCompleted = checkWallets();
      if (isCompleted) setFormValues((prev: any) => ({ ...prev, ewallet_New_addressess: [...prev?.ewallet_New_addressess, { wallet_address: "", percentage: "" }] }));
    }
    if (e_type === "remove_New_wallet") {
      setFormValues((prev: any) => {
        const updated = prev?.ewallet_New_addressess?.filter((_: any, i: number) => Number(i) !== Number(NewWalletIndex));
        if (updated?.length === 0) setWalletErrors("");
        return { ...prev, ewallet_New_addressess: updated };
      });
    }
  };

  const handleDiscardExistingWallets = (walletData: any) => {
    if (walletData?.is_verified) {
      const WalletAddress = walletData?.wallet_id;
      let tempArr: any[] = [];
      if (formValues?.disCard_walletes?.length > 0) formValues?.disCard_walletes?.forEach((m: any) => tempArr.push(m));
      tempArr.push(WalletAddress);
      setFormValues((prev: any) => ({
        ...prev,
        wallet_ids: prev?.wallet_ids?.filter((f: any) => f?.wallet_id !== WalletAddress),
        disCard_walletes: tempArr,
      }));
    } else {
      toast.error("You can not remove wallet, please Verify with 2FA code!");
    }
  };

  const handleCredentialSelect = (event: any) => {
    setSelectedCredential(event);
    setSelectedPredefinedCredentials(predefinedCredentials.find((d: any) => d?.id === event) ?? null);
    setCredentialError("");
  };

  const handleToggle = () => {
    setSelectedCredential("");
    setSelectedPredefinedCredentials(null);
    setCredentialsType("custom");
    setFormValues((prev: any) => ({ ...prev, is_live: !formValues.is_live }));
  };

  const handleActiveToggle = (typeVal: any) => {
    setFormValues((prev: any) => ({ ...prev, is_active: !prev.is_active }));
    const filterGateway = gatewayTypes.map((i: any) => {
      if (i.name === typeVal?.target?.id) return { ...i, is_active: !i.is_active };
      return i;
    });
  };

  const onCloseWalletAddress = () => {
    setIsOpenWalletAddress(false);
    setAuthCode(["", "", "", "", "", ""]);
    setWallertVerifyIput({});
    setIsWallet2FaCloseModal(true);
    setTimeout(() => setIsWallet2FaCloseModal(false), 300);
  };

  // ── Validation helpers — unchanged ─────────────────────────────────────────
  let filterError: any = [];
  let additional_fees_filter_error: any = {};
  let hasEmptyValuesInClient_additional_fees = false;

  useEffect(() => { setFormValuesErr({}); setisValidateAdditionalFeesPricing(false); setisValidateAdditionalFeesCost(true); }, [type]);
  useEffect(() => { validateCinetCardTypes(); }, [formValues?.client_card_types]);
  useEffect(() => { validateCinetAdditionalFees(); }, [formValues?.additional_fees]);
  useEffect(() => { validateVelocityEntries(); }, [formValues?.velocity]);

  const validateCinetCardTypes = () => {
    filterError = formValues?.client_card_types?.filter((f: any) => f?.allow_card)?.map((m: any) => ({
      ...m,
      percentage_fee: m?.percentage_fee ? "" : "Required field.",
      fixed_fee: m?.fixed_fee ? "" : "Required field.",
      currency_code: m?.currency_code ? "" : "Required field.",
      cost_percentage_fee: m?.cost_percentage_fee ? "" : "Required field.",
      cost_fixed_fee: m?.cost_fixed_fee ? "" : "Required field.",
      cost_currency_code: m?.cost_currency_code ? "" : "Required field.",
    }));
    setFormValuesErr((prev: any) => ({ ...prev, client_card_types: filterError }));
  };

  const validateCinetAdditionalFees = () => {
    let additional_fees: any = {};
    if (formValues?.additional_fees?.chargeback_fees?.allow_chargeback_fees) additional_fees.chargeback_fees = { percentage_fee: formValues?.additional_fees?.chargeback_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.chargeback_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.chargeback_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.cost_chargeback_fees?.allow_chargeback_fees) additional_fees.cost_chargeback_fees = { percentage_fee: formValues?.additional_fees?.cost_chargeback_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.cost_chargeback_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.cost_chargeback_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.dispute_fees?.allow_dispute_fees) additional_fees.dispute_fees = { percentage_fee: formValues?.additional_fees?.dispute_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.dispute_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.dispute_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.cost_dispute_fees?.allow_dispute_fees) additional_fees.cost_dispute_fees = { percentage_fee: formValues?.additional_fees?.cost_dispute_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.cost_dispute_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.cost_dispute_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.declined_tnx_fees?.allow_declined_tnx_fees) additional_fees.declined_tnx_fees = { percentage_fee: formValues?.additional_fees?.declined_tnx_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.declined_tnx_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.declined_tnx_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.cost_declined_tnx_fees?.allow_declined_tnx_fees) additional_fees.cost_declined_tnx_fees = { percentage_fee: formValues?.additional_fees?.cost_declined_tnx_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.cost_declined_tnx_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.cost_declined_tnx_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.refunded_tnx_fees?.allow_refunded_tnx_fees) additional_fees.refunded_tnx_fees = { percentage_fee: formValues?.additional_fees?.refunded_tnx_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.refunded_tnx_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.refunded_tnx_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.cost_refunded_tnx_fees?.allow_refunded_tnx_fees) additional_fees.cost_refunded_tnx_fees = { percentage_fee: formValues?.additional_fees?.cost_refunded_tnx_fees?.percentage_fee ? "" : "Required field.", fixed_fee: formValues?.additional_fees?.cost_refunded_tnx_fees?.fixed_fee ? "" : "Required field.", currency_code: formValues?.additional_fees?.cost_refunded_tnx_fees?.currency_code ? "" : "Required field." };
    if (formValues?.additional_fees?.reserve_fees?.allow_reserve_fees) additional_fees.reserve_fees = { percentage_fee: formValues?.additional_fees?.reserve_fees?.percentage_fee ? "" : "Required field.", number_of_days: formValues?.additional_fees?.reserve_fees?.number_of_days ? "" : "Required field." };
    if (formValues?.additional_fees?.cost_reserve_fees?.allow_reserve_fees) additional_fees.cost_reserve_fees = { percentage_fee: formValues?.additional_fees?.cost_reserve_fees?.percentage_fee ? "" : "Required field.", number_of_days: formValues?.additional_fees?.cost_reserve_fees?.number_of_days ? "" : "Required field." };
    additional_fees_filter_error = additional_fees;
    const hasPricing = Object.keys(additional_fees).filter(k => !k.startsWith("cost")).some(k => Object.values(additional_fees[k] || {}).some(Boolean));
    const hasCost = Object.keys(additional_fees).filter(k => k.startsWith("cost")).some(k => Object.values(additional_fees[k] || {}).some(Boolean));
    setisValidateAdditionalFeesPricing(hasPricing);
    setisValidateAdditionalFeesCost(hasCost);
    setFormValuesErr((prev: any) => ({ ...prev, additional_fees }));
  };

  const validateVelocityEntries = () => {
    let velocity: any = {};
    if (formValues?.velocity?.transaction_limit?.allow_transaction_limit) velocity.transaction_limit = { limit_no: formValues?.velocity?.transaction_limit?.limit_no ? "" : "Required field.", period: formValues?.velocity?.transaction_limit?.period ? "" : "Required field." };
    if (formValues?.velocity?.max_transaction_limit?.allow_max_transaction_limit) velocity.max_transaction_limit = { limit_amount: formValues?.velocity?.max_transaction_limit?.limit_amount ? "" : "Required field.", currency: formValues?.velocity?.max_transaction_limit?.currency ? "" : "Required field." };
    if (formValues?.velocity?.min_transaction_limit?.allow_min_transaction_limit) velocity.min_transaction_limit = { limit_amount: formValues?.velocity?.min_transaction_limit?.limit_amount ? "" : "Required field.", currency: formValues?.velocity?.min_transaction_limit?.currency ? "" : "Required field." };
    if (formValues?.velocity?.max_transaction_period?.allow_max_transaction_period) velocity.max_transaction_period = { limit_amount: formValues?.velocity?.max_transaction_period?.limit_amount ? "" : "Required field.", currency: formValues?.velocity?.max_transaction_period?.currency ? "" : "Required field.", period: formValues?.velocity?.max_transaction_period?.period ? "" : "Required field." };
    if (formValues?.velocity?.retry_time?.allow_retry_time) velocity.retry_time = { limit_minutes: formValues?.velocity?.retry_time?.limit_minutes ? "" : "Required field." };
    if (formValues?.velocity?.max_attempts_day?.allow_max_attempts_day) velocity.max_attempts_day = { limit_no: formValues?.velocity?.max_attempts_day?.limit_no ? "" : "Required field." };
    if (formValues?.velocity?.max_attempts_week?.allow_max_attempts_week) velocity.max_attempts_week = { limit_no: formValues?.velocity?.max_attempts_week?.limit_no ? "" : "Required field." };
    if (formValues?.velocity?.max_attempts_month?.allow_max_attempts_month) velocity.max_attempts_month = { limit_no: formValues?.velocity?.max_attempts_month?.limit_no ? "" : "Required field." };
    if (formValues?.velocity?.max_attempts_total?.allow_max_attempts_total) velocity.max_attempts_total = { limit_no: formValues?.velocity?.max_attempts_total?.limit_no ? "" : "Required field." };
    if (formValues?.velocity?.blocked_countries?.allow_blocked_countries) velocity.blocked_countries = { country_code: formValues?.velocity?.blocked_countries?.country_code?.length > 0 ? "" : "Required field." };
    if (formValues?.velocity?.blocked_countries_bin?.allow_blocked_countries_bin) velocity.blocked_countries_bin = { country_code: formValues?.velocity?.blocked_countries_bin?.country_code?.length > 0 ? "" : "Required field." };
    additional_fees_filter_error = velocity;
    const hasErr = Object.keys(velocity).some(k => Object.values(velocity[k] || {}).some(Boolean));
    setisValidateVelocity(hasErr);
    setFormValuesErr((prev: any) => ({ ...prev, velocity }));
  };

  const getImage = (name: string) => {
    const map: Record<string, any> = {
      Sipe: sipe, "Pix-Lotus": pixLotus, "3xpay": Threexpay, Pix: pix, Blumon: blumon, Stripe: stripe,
      Raypd: repyd, Banwire: banwire, Valitor: valitor, Bambora: bambora, Digitarium: Digitarium,
      Tangoindia: Tangoindia, G2Pay: G2pay, Clickopay: Clickopay, CFGPayments: CFGPayments, Capa: Capa,
      Orionx: Orionx, Mauricio: Mauricio, Blox: Blox, Terracall: Terracall, MyXspend: MyXspend,
      Bennupay: Bennupay, Xorapay: Xorapay, Murkon: Murkon, "Changelly Fiat": Changelly,
      "Changelly Crypto": Changelly, Transvoucher: Transvoucher, DNSPay: DNSPay, Gate2Way: Gate2Way,
      "Payouts Tech": PayoutsTech, TestGateway: TestGateway, "Re-set": reSet, Scipiopay: Scipiopay,
      Betapay: Betapay, "Aurea Via": Aurea_via, Kasha: Kasha, Supefina: Supefina,
      "Platy 2DS": Platy, "Platy 3DS": Platy, Linx: Linx, Masterpay: Master_Pay,
      Neonpay: Neonpay, Bm2pay: Bm2pay,
    };
    return map[name];
  };

  const fetchAllGateways = () => {
    setIsLoading(true);
    getAllGatewaysSecond(assigned_payment_methods?.assigned_payment_methods)
      .then((data: any) => {
        setClientGatewayType(data[0]?.type);
        if (Array.isArray(data)) {
          if (data.length > 0) { setType(data[0]?.name); setHashID(data[0]?.id); }
          const newDataArray = data.map((elem: any) => ({ ...elem, image: getImage(elem.name) }));
          setGatewayTypes(newDataArray);
          setGatewayTypesCopy(newDataArray);
          data.forEach((elem: any) => { setStoreGateWayId(elem.id); });
        }
      })
      .catch((err: any) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching gateways"))
      .finally(() => setIsLoading(false));
  };

  const fetchAddedGateways = () => {
    setIsLoading(true);
    getAllGatewaysByClient(id)
    .then((data: any) => {
      if (data.status !== "Error") {
        setAddedGateways((preval: any) => {
          return preval.map((ele: any) => {
            let filtered = data.filter((d: any) => d?.name === ele?.name);
            if (filtered) return { ...ele, ...filtered[0], inputs: filtered[0]?.auth_info, gateway_type: filtered[0]?.gateway_type };
          });
        });
        setCurrencyConv(data.filter((d: any) => d?.name === type)?.[0]?.to_convert ? "currencyConverter" : "requestPassthrough");
      } else {
        toast.error(data.message);
      }
    })
    .catch((err: any) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching gateways"))
    .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (id) { fetchAllGateways(); fetchAddedGateways(); }
  }, [id]);

  useEffect(() => {
    const selectedGateway = gatewayTypes.find((d: any) => d?.name === type);
    if (selectedGateway) {
      const pc = selectedGateway?.meta_info?.predefined_credentials;
      if (pc?.length > 0) setPredefinedCredentials(pc);
    }
    const addGateway: any = addedgateways.find((d: any) => d?.name === type);
    if (addGateway?.auth_info) {
      const credType = addGateway?.auth_info?.credential_type || "custom";
      setCredentialsType(credType);
      if (credType === "predefined") {
        const preCred = addGateway?.auth_info?.predefinedCredentials;
        setSelectedCredential(preCred?.id);
        setSelectedPredefinedCredentials(preCred);
      }
    }
    setCurrencyConv(addedgateways.filter((d: any) => d?.name === type)[0]?.to_convert ? "currencyConverter" : "requestPassthrough");
    setSelectedCurrency(addedgateways.filter((d: any) => d?.name === type)[0]?.to_convert ? addedgateways.filter((d: any) => d?.name === type)[0]?.new_currency : "USD");
  }, [type, addedgateways]);


  function validateData() {
    
    let escape_arr = [
      "statement_descriptor",
      "statement_descriptor_suffix",
      "business_name",
      "descriptor",
      "mid_country_live",
      "mid_country_test",
    ];
    if (type === "Stripe") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? "secret_key_live"
          : "secret_key_test";
      escape_arr?.push(data);
    } else if (type === "Pix") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["name_live", "email_live"]
          : ["name_test", "email_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Raypd") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["access_key_live", "secret_key_live"]
          : ["access_key_test", "secret_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Banwire") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["username_live", "username_live"]
          : ["username_test", "username_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Valitor") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["apikey_live", "apikey_live"]
          : ["apikey_test", "apikey_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Bambora") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["merchantId_live", "passcode_live", "hash_key_live","recurring_passcode_live","reporting_passcode_live","batch_passcode_live","subscription_passcode_live"]
          : ["merchantId_test", "passcode_test", "hash_key_test","recurring_passcode_test","reporting_passcode_test","batch_passcode_test","subscription_passcode_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Digitarium") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["merchantKey_live", "password_live"]
          : ["merchantKey_test", "password_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Tangoindia") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_id_live", "api_key_live"]
          : ["api_id_test", "api_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "G2Pay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["signing_key_live", "api_key_live"]
          : ["signing_key_test", "api_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Clickopay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live", "salt_key_live"]
          : ["api_key_test", "salt_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "CFGPayments") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["secret_key_live"]
          : ["secret_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Capa") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live","webhook_secret_live"]
          : ["api_key_test","webhook_secret_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Orionx") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live","secret_key_live"]
          : ["api_key_test","secret_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Mauricio") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["client_id_live","api_secret_live"]
          : ["client_id_test","api_secret_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Blox") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live"]
          : ["api_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Terracall") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["client_id_live","client_secret_live"]
          : ["client_id_test","client_secret_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "MyXspend") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["email_live","password_live"]
          : ["email_test","password_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Bennupay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["secret_key_live","brand_id_live"]
          : ["secret_key_test","brand_id_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Xorapay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["secret_key_live","encryption_key_live","webhook_hash_live"]
          : ["secret_key_test","encryption_key_test","webhook_hash_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Murkon") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["entity_login_live","entity_pass_live","entity_code_live","entity_type_live","terminal_id_live"]
          : ["entity_login_test","entity_pass_test","entity_code_test","entity_type_test","terminal_id_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Changelly Fiat") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["public_api_key_live","private_key_live","provider_live","wallet_address_live","to_currency_live"]
          : ["public_api_key_test","private_key_test","provider_test","wallet_address_test","to_currency_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Changelly Crypto") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["public_api_key_live","private_key_live"]
          : ["public_api_key_test","private_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Transvoucher") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live","api_secret_live"]
          : ["api_key_test","api_secret_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "DNSPay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["endpoint_id_live","merchant_key_live"]
          : ["endpoint_id_test","merchant_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Gate2Way") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live","api_secret_live","payment_method_live","payout_payment_method_live"]
          : ["api_key_test","api_secret_test","payment_method_test","payout_payment_method_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Payouts Tech") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["client_key_live","password_live","brand_live","payout_client_key_live","payout_password_live","payout_brand_live"]
          : ["client_key_test","password_test","brand_test","payout_client_key_test","payout_password_test","payout_brand_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Re-set") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["secretKey_live", "brand_id_live"]
          : ["secretKey_test", "brand_id_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Scipiopay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["shop_secret_key_live", "shop_id_live"]
          : ["shop_id_test", "shop_secret_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Betapay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_token_live", "merchant_id_live", "terminal_id_live"]
          : ["api_token_test", "merchant_id_test", "terminal_id_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Aurea Via") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["companyNum_live", "personalHashkey_live"]
          : ["companyNum_test", "personalHashkey_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Kasha") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["api_key_live", "merchant_domain_live"]
          : ["api_key_test", "merchant_domain_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Supefina") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["merchant_id_live"]
          : ["merchant_id_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "3xpay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? [
              "api_key_live",
              "api_secret_live"
            ]
          : [
              "api_key_test",
              "api_secret_test"
            ];

      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Platy 2DS") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? [
              "api_key_live",
              "password_live",
              "platy_api_key_live",
              "platy_secret_key_live",
              "username_live",
            ]
          : [
              "api_key_test",
              "password_test",
              "platy_api_key_test",
              "platy_secret_key_test",
              "username_test",
            ];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Platy 3DS") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? [
              "api_key_live",
              "password_live",
              "platy_api_key_live",
              "platy_secret_key_live",
              "username_live",
            ]
          : [
              "api_key_test",
              "password_test",
              "platy_api_key_test",
              "platy_secret_key_test",
              "username_test",
            ];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Masterpay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["merchant_private_key_live"]
          : ["merchant_private_key_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Neonpay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["merchant_key_live", "password_live"]
          : ["merchant_key_test", "password_test"]
          // ? ["merchant_key_live", "password_live", "term_url_3ds_live"]
          // : ["merchant_key_test", "password_test", "term_url_3ds_test"]
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } else if (type === "Bm2pay") {
      const data =
        formValues?.is_live === false || formValues?.is_live === undefined
          ? ["client_id_live", "client_secret_live"]
          : ["client_id_test", "client_secret_test"];
      data?.map((item) => {
        return escape_arr?.push(item);
      });
    } 

    let verifier: any;
    Object.keys(formValues).forEach((key: any) => {
      let temp_arr = escape_arr.filter((ele) => key === ele);

      if (!(temp_arr.length > 0)) {
        if (!formValues[key as keyof any]) {
          verifier = { ...verifier, [key]: "Please enter a value" };
        }
      }
    });

    if(credentialsType == 'predefined') {
      if(selectedCredential == "") {
        setCredentialError("Please Select Predefined Credentials");
        return false;
      } else {
        setCredentialError("")
      }
    }

    console.log("validate",verifier)
    setFormValuesErr(verifier);
    validateCinetCardTypes();
    validateCinetAdditionalFees();
    validateVelocityEntries();

    hasEmptyValuesInClient_additional_fees = Object?.keys(
      additional_fees_filter_error
    )
      .map((objKey: any) => {
        if (additional_fees_filter_error[objKey]?.percentage_fee) {
          return true;
        }
        if (additional_fees_filter_error[objKey]?.fixed_fee) {
          return true;
        }
        if (additional_fees_filter_error[objKey]?.currency_code) {
          return true;
        }

        if (additional_fees_filter_error[objKey]?.number_of_days) {
          return true;
        }
        return false;
      })
      ?.some((sData: boolean) => {
        return sData == true;
      });

    if (hasEmptyValuesInClient_additional_fees) {

      return false;
    }
    if (isValidateVelocity) {
      return false;
    }

    if (isValidateAdditionalFees) {

      return false;
    }
    if (isValidateAdditionalFeesPricing) {

      return false;
    }   

    const hasEmptyValuesInClient_card_types = filterError
      ?.map((objData: any) => {
        if (objData?.percentage_fee) {
          return true;
        }
        if (objData?.fixed_fee) {
          return true;
        }
        if (objData?.currency_code) {
          return true;
        }
        if (objData?.fixed_fee) {
          return true;
        }
        if (objData?.cost_percentage_fee) {
          return true;
        }
        if (objData?.cost_fixed_fee) {
          return true;
        }
        if (objData?.cost_currency_code) {
          return true;
        }

        return false;
      })
      ?.some((sData: boolean) => {
        return sData == true;
      });

    if (hasEmptyValuesInClient_card_types) {

      return false;
    }

    const hasEmptyValues = Object.entries(formValues).some(([key, value]) => {
      let temp_arr_ = escape_arr.filter((ele) => key === ele);
      if (!(temp_arr_.length > 0)) {
        return typeof value === "string"
          ? value?.toString()?.trim() === ""
          : value === "";
      }
    });

    if (hasEmptyValues) {
      return false;
    }


    const hasEmptyWallets = checkWallets()

    if (!hasEmptyWallets) return false
      console.log("formValues",formValues , clientGatewayType);

    if(clientGatewayType == 'crypto') {
      // if(formValues.crypto_fees.percentage_fee == "") {
      //   return false
      // }

      // if(formValues.crypto_fees.fixed_fee == "") {
      //   return false
      // }

      // if(formValues.crypto_fees.currency_code == "") {
      //   return false
      // }

      if (formValues.crypto_fees.percentage_fee === "") {
        setFormValuesErr((prev:any) => ({
          ...prev,
          crypto_fees: {
            ...(prev.crypto_fees || {}),
            percentage_fee: "Please enter a value"
          }
        }));
        return false
      }

      if (formValues.crypto_fees.fixed_fee === "") {
        setFormValuesErr((prev:any) => ({
          ...prev,
          crypto_fees: {
            ...(prev.crypto_fees || {}),
            fixed_fee: "Please enter a value"
          }
        }));
        return false
      }

      if (formValues.crypto_fees.currency_code === "") {
        setFormValuesErr((prev:any) => ({
          ...prev,
          crypto_fees: {
            ...(prev.crypto_fees || {}),
            currency_code: "Please enter a value"
          }
        }));
        return false
      }

    }

    
    return true;
  }
  const handleSubmit = () => {
    let validate = validateData();
    const bank_account_number_details = [...Array(bankInfoCount)]
      .map((_, index) => {
        let accountNo = formValues?.[`accountNo_${index}`];
        let transitNo = formValues?.[`transitNo_${index}`];
        let institutionNo = formValues?.[`institutionNo_${index}`];

        if (accountNo && transitNo && institutionNo) {
          delete formValues[`accountNo_${index}`];
          delete formValues[`transitNo_${index}`];
          delete formValues[`institutionNo_${index}`];
          return {
            account_number: accountNo,
            transit_number: transitNo,
            institution_number: institutionNo,
          };
        } else {
          return null;
        }
      })
      .filter(Boolean);

    setFormValues({
      ...formValues,
      bank_account_number_details: bank_account_number_details,
    });
    if (validate) {
      let savedgateway = addedgateways.filter((data) => data?.name === type);
      let saved_gateway_id =
        savedgateway.length > 0 ? savedgateway[0]?.client_id : "";
      let gateway = gatewayTypes.filter((data) => data?.name === type);
      let gateway_id = gateway && gateway.length > 0 ? gateway[0]?.id : "";
      let newVALUE;
      if (type === "Pix") {
        newVALUE = {
          name_live:
            formValues?.is_live === true
              ? formValues?.name_live
                ? formValues?.name_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.name_live
              ? savedgateway[0]?.inputs?.name_live
              : "",
          name_test:
            formValues?.is_live === false
              ? formValues?.name_test
                ? formValues?.name_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.name_test
              ? savedgateway[0]?.inputs?.name_test
              : "",

          email_live:
            formValues?.is_live === true
              ? formValues?.email_live
                ? formValues?.email_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.email_live
              ? savedgateway[0]?.inputs?.email_live
              : "",
          // business_name: formValues?.business_name
          //   ? formValues?.business_name?.trim()
          //   : "",
          email_test:
            formValues?.is_live === false
              ? formValues?.email_test
                ? formValues?.email_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.email_test
              ? savedgateway[0]?.inputs?.email_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
          priority: formValues?.priority,
        };
      }
      if (type === "Stripe") {
        newVALUE = {
          statement_descriptor: formValues?.statement_descriptor
            ? formValues?.statement_descriptor
            : "",
          statement_descriptor_suffix: formValues?.statement_descriptor_suffix
            ? formValues?.statement_descriptor_suffix
            : "",
          secret_key_live:
            formValues?.is_live === true
              ? formValues?.secret_key_live
                ? formValues?.secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_live
              ? savedgateway[0]?.inputs?.secret_key_live
              : "",
          secret_key_test:
            formValues?.is_live === false
              ? formValues?.secret_key_test
                ? formValues?.secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_test?.trim()
              ? savedgateway[0]?.inputs?.secret_key_test
              : "",
          priority: formValues?.priority,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Raypd") {
        newVALUE = {
          secret_key_live:
            formValues?.is_live === true
              ? formValues?.secret_key_live
                ? formValues?.secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_live
              ? savedgateway[0]?.inputs?.secret_key_live
              : "",
          secret_key_test:
            formValues?.is_live === false
              ? formValues?.secret_key_test
                ? formValues?.secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_test
              ? savedgateway[0]?.inputs?.secret_key_test
              : "",
          mid_country_live:
            formValues?.is_live === true
              ? formValues?.mid_country_live
                ? formValues?.mid_country_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.mid_country_live
              ? savedgateway[0]?.inputs?.mid_country_live
              : "",
          mid_country_test:
            formValues?.is_live === false
              ? formValues?.mid_country_test
                ? formValues?.mid_country_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.mid_country_test
              ? savedgateway[0]?.inputs?.mid_country_test
              : "",
          access_key_live:
            formValues?.is_live === true
              ? formValues?.access_key_live
                ? formValues?.access_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.access_key_live
              ? savedgateway[0]?.inputs?.access_key_live
              : "",
          access_key_test:
            formValues?.is_live === false
              ? formValues?.access_key_test
                ? formValues?.access_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.access_key_test
              ? savedgateway[0]?.inputs?.access_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Banwire") {
        newVALUE = {
          username_live:
            formValues?.is_live === true
              ? formValues?.username_live
                ? formValues?.username_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.username_live
              ? savedgateway[0]?.inputs?.username_live
              : "",
          username_test:
            formValues?.is_live === false
              ? formValues?.username_test
                ? formValues?.username_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.username_test
              ? savedgateway[0]?.inputs?.username_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Valitor") {
        newVALUE = {
          apikey_live:
            formValues?.is_live === true
              ? formValues?.apikey_live
                ? formValues?.apikey_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.apikey_live
              ? savedgateway[0]?.inputs?.apikey_live
              : "",
          apikey_test:
            formValues?.is_live === false
              ? formValues?.apikey_test
                ? formValues?.apikey_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.apikey_test
              ? savedgateway[0]?.inputs?.apikey_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Bambora") {
        newVALUE = {
          merchantId_live:
            formValues?.is_live === true
              ? formValues?.merchantId_live
                ? formValues?.merchantId_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchantId_live
              ? savedgateway[0]?.inputs?.merchantId_live
              : "",
          merchantId_test:
            formValues?.is_live === false
              ? formValues?.merchantId_test
                ? formValues?.merchantId_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchantId_test
              ? savedgateway[0]?.inputs?.merchantId_test
              : "",
          passcode_live:
            formValues?.is_live === true
              ? formValues?.passcode_live
                ? formValues?.passcode_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.passcode_live
              ? savedgateway[0]?.inputs?.passcode_live
              : "",
          passcode_test:
            formValues?.is_live === false
              ? formValues?.passcode_test
                ? formValues?.passcode_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.passcode_test
              ? savedgateway[0]?.inputs?.passcode_test
              : "",
          hash_key_test:
            formValues?.is_live === false
              ? formValues?.hash_key_test
                ? formValues?.hash_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.hash_key_test
              ? savedgateway[0]?.inputs?.hash_key_test
              : "",
          hash_key_live:
            formValues?.is_live === true
              ? formValues?.hash_key_live
                ? formValues?.hash_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.hash_key_live
              ? savedgateway[0]?.inputs?.hash_key_live
              : "",
          recurring_passcode_test:
            formValues?.is_live === false
              ? formValues?.recurring_passcode_test
                ? formValues?.recurring_passcode_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.recurring_passcode_test
              ? savedgateway[0]?.inputs?.recurring_passcode_test
              : "",
          recurring_passcode_live:
            formValues?.is_live === true
              ? formValues?.recurring_passcode_live
                ? formValues?.recurring_passcode_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.recurring_passcode_live
              ? savedgateway[0]?.inputs?.recurring_passcode_live
              : "",
          reporting_passcode_test:
            formValues?.is_live === false
              ? formValues?.reporting_passcode_test
                ? formValues?.reporting_passcode_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.reporting_passcode_test
              ? savedgateway[0]?.inputs?.reporting_passcode_test
              : "",
          reporting_passcode_live:
            formValues?.is_live === true
              ? formValues?.reporting_passcode_live
                ? formValues?.reporting_passcode_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.reporting_passcode_live
              ? savedgateway[0]?.inputs?.reporting_passcode_live
              : "",
          batch_passcode_test:
            formValues?.is_live === false
              ? formValues?.batch_passcode_test
                ? formValues?.batch_passcode_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.batch_passcode_test
              ? savedgateway[0]?.inputs?.batch_passcode_test
              : "",
          batch_passcode_live:
            formValues?.is_live === true
              ? formValues?.batch_passcode_live
                ? formValues?.batch_passcode_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.batch_passcode_live
              ? savedgateway[0]?.inputs?.batch_passcode_live
              : "",
          subscription_passcode_test:
            formValues?.is_live === false
              ? formValues?.subscription_passcode_test
                ? formValues?.subscription_passcode_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.subscription_passcode_test
              ? savedgateway[0]?.inputs?.subscription_passcode_test
              : "",
          subscription_passcode_live:
            formValues?.is_live === true
              ? formValues?.subscription_passcode_live
                ? formValues?.subscription_passcode_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.subscription_passcode_live
              ? savedgateway[0]?.inputs?.subscription_passcode_live
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Digitarium") {
        newVALUE = {
          merchantKey_live:
            formValues?.is_live === true
              ? formValues?.merchantKey_live
                ? formValues?.merchantKey_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchantKey_live
              ? savedgateway[0]?.inputs?.merchantKey_live
              : "",
          merchantKey_test:
            formValues?.is_live === false
              ? formValues?.merchantKey_test
                ? formValues?.merchantKey_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchantKey_test
              ? savedgateway[0]?.inputs?.merchantKey_test
              : "",
          password_live:
            formValues?.is_live === true
              ? formValues?.password_live
                ? formValues?.password_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_live
              ? savedgateway[0]?.inputs?.password_live
              : "",
          password_test:
            formValues?.is_live === false
              ? formValues?.password_test
                ? formValues?.password_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_test
              ? savedgateway[0]?.inputs?.password_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Tangoindia") {
        newVALUE = {
          api_id_live:
            formValues?.is_live === true
              ? formValues?.api_id_live
                ? formValues?.api_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_id_live
              ? savedgateway[0]?.inputs?.api_id_live
              : "",
          api_id_test:
            formValues?.is_live === false
              ? formValues?.api_id_test
                ? formValues?.api_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_id_test
              ? savedgateway[0]?.inputs?.api_id_test
              : "",
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "G2Pay") {
        newVALUE = {
          signing_key_live:
            formValues?.is_live === true
              ? formValues?.signing_key_live
                ? formValues?.signing_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.signing_key_live
              ? savedgateway[0]?.inputs?.signing_key_live
              : "",
          signing_key_test:
            formValues?.is_live === false
              ? formValues?.signing_key_test
                ? formValues?.signing_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.signing_key_test
              ? savedgateway[0]?.inputs?.signing_key_test
              : "",
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Clickopay") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          salt_key_live:
            formValues?.is_live === true
              ? formValues?.salt_key_live
                ? formValues?.salt_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.salt_key_live
              ? savedgateway[0]?.inputs?.salt_key_live
              : "",
          salt_key_test:
            formValues?.is_live === false
              ? formValues?.salt_key_test
                ? formValues?.salt_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.salt_key_test
              ? savedgateway[0]?.inputs?.salt_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "CFGPayments") {
        newVALUE = {
          secret_key_live:
            formValues?.is_live === true
              ? formValues?.secret_key_live
                ? formValues?.secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_live
              ? savedgateway[0]?.inputs?.secret_key_live
              : "",
          secret_key_test:
            formValues?.is_live === false
              ? formValues?.secret_key_test
                ? formValues?.secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_test
              ? savedgateway[0]?.inputs?.secret_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Capa") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          webhook_secret_live:
            formValues?.is_live === true
              ? formValues?.webhook_secret_live
                ? formValues?.webhook_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.webhook_secret_live
              ? savedgateway[0]?.inputs?.webhook_secret_live
              : "",
          webhook_secret_test:
            formValues?.is_live === true
              ? formValues?.webhook_secret_test
                ? formValues?.webhook_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.webhook_secret_test
              ? savedgateway[0]?.inputs?.webhook_secret_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Orionx") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          secret_key_live:
            formValues?.is_live === true
              ? formValues?.secret_key_live
                ? formValues?.secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_live
              ? savedgateway[0]?.inputs?.secret_key_live
              : "",
          secret_key_test:
            formValues?.is_live === true
              ? formValues?.secret_key_test
                ? formValues?.secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_test
              ? savedgateway[0]?.inputs?.secret_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Mauricio") {
        newVALUE = {
          client_id_live:
            formValues?.is_live === true
              ? formValues?.client_id_live
                ? formValues?.client_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_id_live
              ? savedgateway[0]?.inputs?.client_id_live
              : "",
          client_id_test:
            formValues?.is_live === false
              ? formValues?.client_id_test
                ? formValues?.client_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_id_test
              ? savedgateway[0]?.inputs?.client_id_test
              : "",
          api_secret_live:
            formValues?.is_live === true
              ? formValues?.api_secret_live
                ? formValues?.api_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_live
              ? savedgateway[0]?.inputs?.api_secret_live
              : "",
          api_secret_test:
            formValues?.is_live === true
              ? formValues?.api_secret_test
                ? formValues?.api_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_test
              ? savedgateway[0]?.inputs?.api_secret_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Blox") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === true
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Terracall") {
        newVALUE = {
          client_id_live:
            formValues?.is_live === true
              ? formValues?.client_id_live
                ? formValues?.client_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_id_live
              ? savedgateway[0]?.inputs?.client_id_live
              : "",
          client_id_test:
            formValues?.is_live === true
              ? formValues?.client_id_test
                ? formValues?.client_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_id_test
              ? savedgateway[0]?.inputs?.client_id_test
              : "",
          client_secret_live:
            formValues?.is_live === true
              ? formValues?.client_secret_live
                ? formValues?.client_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_secret_live
              ? savedgateway[0]?.inputs?.client_secret_live
              : "",
          client_secret_test:
            formValues?.is_live === true
              ? formValues?.client_secret_test
                ? formValues?.client_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_secret_test
              ? savedgateway[0]?.inputs?.client_secret_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "MyXspend") {
        newVALUE = {
          email_live:
            formValues?.is_live === true
              ? formValues?.email_live
                ? formValues?.email_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.email_live
              ? savedgateway[0]?.inputs?.email_live
              : "",
          email_test:
            formValues?.is_live === true
              ? formValues?.email_test
                ? formValues?.email_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.email_test
              ? savedgateway[0]?.inputs?.email_test
              : "",
          password_live:
            formValues?.is_live === true
              ? formValues?.password_live
                ? formValues?.password_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_live
              ? savedgateway[0]?.inputs?.password_live
              : "",
          password_test:
            formValues?.is_live === true
              ? formValues?.password_test
                ? formValues?.password_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_test
              ? savedgateway[0]?.inputs?.password_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Bennupay") {
        newVALUE = {
          secret_key_live:
            formValues?.is_live === true
              ? formValues?.secret_key_live
                ? formValues?.secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_live
              ? savedgateway[0]?.inputs?.secret_key_live
              : "",
          secret_key_test:
            formValues?.is_live === true
              ? formValues?.secret_key_test
                ? formValues?.secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_test
              ? savedgateway[0]?.inputs?.secret_key_test
              : "",
          brand_id_live:
            formValues?.is_live === true
              ? formValues?.brand_id_live
                ? formValues?.brand_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.brand_id_live
              ? savedgateway[0]?.inputs?.brand_id_live
              : "",
          brand_id_test:
            formValues?.is_live === true
              ? formValues?.brand_id_test
                ? formValues?.brand_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.brand_id_test
              ? savedgateway[0]?.inputs?.brand_id_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Xorapay") {
        newVALUE = {
          secret_key_live:
            formValues?.is_live === true
              ? formValues?.secret_key_live
                ? formValues?.secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_live
              ? savedgateway[0]?.inputs?.secret_key_live
              : "",
          secret_key_test:
            formValues?.is_live === true
              ? formValues?.secret_key_test
                ? formValues?.secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secret_key_test
              ? savedgateway[0]?.inputs?.secret_key_test
              : "",
          encryption_key_live:
            formValues?.is_live === true
              ? formValues?.encryption_key_live
                ? formValues?.encryption_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.encryption_key_live
              ? savedgateway[0]?.inputs?.encryption_key_live
              : "",
          encryption_key_test:
            formValues?.is_live === true
              ? formValues?.encryption_key_test
                ? formValues?.encryption_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.encryption_key_test
              ? savedgateway[0]?.inputs?.encryption_key_test
              : "",
          webhook_hash_live:
            formValues?.is_live === true
              ? formValues?.webhook_hash_live
                ? formValues?.webhook_hash_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.webhook_hash_live
              ? savedgateway[0]?.inputs?.webhook_hash_live
              : "",
          webhook_hash_test:
            formValues?.is_live === true
              ? formValues?.webhook_hash_test
                ? formValues?.webhook_hash_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.webhook_hash_test
              ? savedgateway[0]?.inputs?.webhook_hash_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Murkon") {
        newVALUE = {
          entity_login_live:
            formValues?.is_live === true
              ? formValues?.entity_login_live
                ? formValues?.entity_login_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_login_live
              ? savedgateway[0]?.inputs?.entity_login_live
              : "",
          entity_login_test:
            formValues?.is_live === true
              ? formValues?.entity_login_test
                ? formValues?.entity_login_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_login_test
              ? savedgateway[0]?.inputs?.entity_login_test
              : "",
          entity_pass_live:
            formValues?.is_live === true
              ? formValues?.entity_pass_live
                ? formValues?.entity_pass_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_pass_live
              ? savedgateway[0]?.inputs?.entity_pass_live
              : "",
          entity_pass_test:
            formValues?.is_live === true
              ? formValues?.entity_pass_test
                ? formValues?.entity_pass_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_pass_test
              ? savedgateway[0]?.inputs?.entity_pass_test
              : "",
          entity_code_live:
            formValues?.is_live === true
              ? formValues?.entity_code_live
                ? formValues?.entity_code_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_code_live
              ? savedgateway[0]?.inputs?.entity_code_live
              : "",
          entity_code_test:
            formValues?.is_live === true
              ? formValues?.entity_code_test
                ? formValues?.entity_code_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_code_test
              ? savedgateway[0]?.inputs?.entity_code_test
              : "",
          entity_type_live:
            formValues?.is_live === true
              ? formValues?.entity_type_live
                ? formValues?.entity_type_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_type_live
              ? savedgateway[0]?.inputs?.entity_type_live
              : "",
          entity_type_test:
            formValues?.is_live === true
              ? formValues?.entity_type_test
                ? formValues?.entity_type_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.entity_type_test
              ? savedgateway[0]?.inputs?.entity_type_test
              : "",
          terminal_id_live:
            formValues?.is_live === true
              ? formValues?.terminal_id_live
                ? formValues?.terminal_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.terminal_id_live
              ? savedgateway[0]?.inputs?.terminal_id_live
              : "",
          terminal_id_test:
            formValues?.is_live === true
              ? formValues?.terminal_id_test
                ? formValues?.terminal_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.terminal_id_test
              ? savedgateway[0]?.inputs?.terminal_id_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Changelly Fiat") {
        newVALUE = {
          public_api_key_live:
            formValues?.is_live === true
              ? formValues?.public_api_key_live
                ? formValues?.public_api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.public_api_key_live
              ? savedgateway[0]?.inputs?.public_api_key_live
              : "",
          public_api_key_test:
            formValues?.is_live === true
              ? formValues?.public_api_key_test
                ? formValues?.public_api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.public_api_key_test
              ? savedgateway[0]?.inputs?.public_api_key_test
              : "",
          private_key_live:
            formValues?.is_live === true
              ? formValues?.private_key_live
                ? formValues?.private_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.private_key_live
              ? savedgateway[0]?.inputs?.private_key_live
              : "",
          private_key_test:
            formValues?.is_live === true
              ? formValues?.private_key_test
                ? formValues?.private_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.private_key_test
              ? savedgateway[0]?.inputs?.private_key_test
              : "",
          provider_live:
            formValues?.is_live === true
              ? formValues?.provider_live
                ? formValues?.provider_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.provider_live
              ? savedgateway[0]?.inputs?.provider_live
              : "",
          provider_test:
            formValues?.is_live === true
              ? formValues?.provider_test
                ? formValues?.provider_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.provider_test
              ? savedgateway[0]?.inputs?.provider_test
              : "",
          wallet_address_live:
            formValues?.is_live === true
              ? formValues?.wallet_address_live
                ? formValues?.wallet_address_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.wallet_address_live
              ? savedgateway[0]?.inputs?.wallet_address_live
              : "",
          wallet_address_test:
            formValues?.is_live === true
              ? formValues?.wallet_address_test
                ? formValues?.wallet_address_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.wallet_address_test
              ? savedgateway[0]?.inputs?.wallet_address_test
              : "",
          to_currency_live:
            formValues?.is_live === true
              ? formValues?.to_currency_live
                ? formValues?.to_currency_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.to_currency_live
              ? savedgateway[0]?.inputs?.to_currency_live
              : "",
          to_currency_test:
            formValues?.is_live === true
              ? formValues?.to_currency_test
                ? formValues?.to_currency_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.to_currency_test
              ? savedgateway[0]?.inputs?.to_currency_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Changelly Crypto") {
        newVALUE = {
          public_api_key_live:
            formValues?.is_live === true
              ? formValues?.public_api_key_live
                ? formValues?.public_api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.public_api_key_live
              ? savedgateway[0]?.inputs?.public_api_key_live
              : "",
          public_api_key_test:
            formValues?.is_live === true
              ? formValues?.public_api_key_test
                ? formValues?.public_api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.public_api_key_test
              ? savedgateway[0]?.inputs?.public_api_key_test
              : "",
          private_key_live:
            formValues?.is_live === true
              ? formValues?.private_key_live
                ? formValues?.private_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.private_key_live
              ? savedgateway[0]?.inputs?.private_key_live
              : "",
          private_key_test:
            formValues?.is_live === true
              ? formValues?.private_key_test
                ? formValues?.private_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.private_key_test
              ? savedgateway[0]?.inputs?.private_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Transvoucher") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === true
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          api_secret_live:
            formValues?.is_live === true
              ? formValues?.api_secret_live
                ? formValues?.api_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_live
              ? savedgateway[0]?.inputs?.api_secret_live
              : "",
          api_secret_test:
            formValues?.is_live === true
              ? formValues?.api_secret_test
                ? formValues?.api_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_test
              ? savedgateway[0]?.inputs?.api_secret_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "DNSPay") {
        newVALUE = {
          endpoint_id_live:
            formValues?.is_live === true
              ? formValues?.endpoint_id_live
                ? formValues?.endpoint_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.endpoint_id_live
              ? savedgateway[0]?.inputs?.endpoint_id_live
              : "",
          endpoint_id_test:
            formValues?.is_live === true
              ? formValues?.endpoint_id_test
                ? formValues?.endpoint_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.endpoint_id_test
              ? savedgateway[0]?.inputs?.endpoint_id_test
              : "",
          merchant_key_live:
            formValues?.is_live === true
              ? formValues?.merchant_key_live
                ? formValues?.merchant_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_key_live
              ? savedgateway[0]?.inputs?.merchant_key_live
              : "",
          merchant_key_test:
            formValues?.is_live === true
              ? formValues?.merchant_key_test
                ? formValues?.merchant_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_key_test
              ? savedgateway[0]?.inputs?.merchant_key_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Gate2Way") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === true
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          api_secret_live:
            formValues?.is_live === true
              ? formValues?.api_secret_live
                ? formValues?.api_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_live
              ? savedgateway[0]?.inputs?.api_secret_live
              : "",
          api_secret_test:
            formValues?.is_live === true
              ? formValues?.api_secret_test
                ? formValues?.api_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_test
              ? savedgateway[0]?.inputs?.api_secret_test
              : "",
          payment_method_live:
            formValues?.is_live === true
              ? formValues?.payment_method_live
                ? formValues?.payment_method_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.payment_method_live
              ? savedgateway[0]?.inputs?.payment_method_live
              : "",
          payment_method_test:
            formValues?.is_live === true
              ? formValues?.payment_method_test
                ? formValues?.payment_method_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.payment_method_test
              ? savedgateway[0]?.inputs?.payment_method_test
              : "",
          payout_payment_method_live:
            formValues?.is_live === true
              ? formValues?.payout_payment_method_live
                ? formValues?.payout_payment_method_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_payment_method_live
              ? savedgateway[0]?.inputs?.payout_payment_method_live
              : "",
          payout_payment_method_test:
            formValues?.is_live === true
              ? formValues?.payout_payment_method_test
                ? formValues?.payout_payment_method_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_payment_method_test
              ? savedgateway[0]?.inputs?.payout_payment_method_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Payouts Tech") {
        newVALUE = {
          client_key_live:
            formValues?.is_live === true
              ? formValues?.client_key_live
                ? formValues?.client_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_key_live
              ? savedgateway[0]?.inputs?.client_key_live
              : "",
          client_key_test:
            formValues?.is_live === true
              ? formValues?.client_key_test
                ? formValues?.client_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_key_test
              ? savedgateway[0]?.inputs?.client_key_test
              : "",
          password_live:
            formValues?.is_live === true
              ? formValues?.password_live
                ? formValues?.password_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_live
              ? savedgateway[0]?.inputs?.password_live
              : "",
          password_test:
            formValues?.is_live === true
              ? formValues?.password_test
                ? formValues?.password_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_test
              ? savedgateway[0]?.inputs?.password_test
              : "",
          brand_live:
            formValues?.is_live === true
              ? formValues?.brand_live
                ? formValues?.brand_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.brand_live
              ? savedgateway[0]?.inputs?.brand_live
              : "",
          brand_test:
            formValues?.is_live === true
              ? formValues?.brand_test
                ? formValues?.brand_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.brand_test
              ? savedgateway[0]?.inputs?.brand_test
              : "",
          payout_client_key_live:
            formValues?.is_live === true
              ? formValues?.payout_client_key_live
                ? formValues?.payout_client_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_client_key_live
              ? savedgateway[0]?.inputs?.payout_client_key_live
              : "",
          payout_client_key_test:
            formValues?.is_live === true
              ? formValues?.payout_client_key_test
                ? formValues?.payout_client_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_client_key_test
              ? savedgateway[0]?.inputs?.payout_client_key_test
              : "",
          payout_password_live:
            formValues?.is_live === true
              ? formValues?.payout_password_live
                ? formValues?.payout_password_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_password_live
              ? savedgateway[0]?.inputs?.payout_password_live
              : "",
          payout_password_test:
            formValues?.is_live === true
              ? formValues?.payout_password_test
                ? formValues?.payout_password_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_password_test
              ? savedgateway[0]?.inputs?.payout_password_test
              : "",
          payout_brand_live:
            formValues?.is_live === true
              ? formValues?.payout_brand_live
                ? formValues?.payout_brand_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_brand_live
              ? savedgateway[0]?.inputs?.payout_brand_live
              : "",
          payout_brand_test:
            formValues?.is_live === true
              ? formValues?.payout_brand_test
                ? formValues?.payout_brand_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.payout_brand_test
              ? savedgateway[0]?.inputs?.payout_brand_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "TestGateway") {
        newVALUE = {
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Re-set") {
        newVALUE = {
          secretKey_live:
            formValues?.is_live === true
              ? formValues?.secretKey_live
                ? formValues?.secretKey_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.secretKey_live
              ? savedgateway[0]?.inputs?.secretKey_live
              : "",
          secretKey_test:
            formValues?.is_live === false
              ? formValues?.secretKey_test
                ? formValues?.secretKey_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.secretKey_test
              ? savedgateway[0]?.inputs?.secretKey_test
              : "",
          brand_id_live:
            formValues?.is_live === true
              ? formValues?.brand_id_live
                ? formValues?.brand_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.brand_id_live
              ? savedgateway[0]?.inputs?.brand_id_live
              : "",
          brand_id_test:
            formValues?.is_live === false
              ? formValues?.brand_id_test
                ? formValues?.brand_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.brand_id_test
              ? savedgateway[0]?.inputs?.brand_id_test
              : "",
          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Betapay") {
        newVALUE = {
          api_token_live:
            formValues?.is_live === true
              ? formValues?.api_token_live
                ? formValues?.api_token_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_token_live
              ? savedgateway[0]?.inputs?.api_token_live
              : "",
          api_token_test:
            formValues?.is_live === false
              ? formValues?.api_token_test
                ? formValues?.api_token_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_token_test
              ? savedgateway[0]?.inputs?.api_token_test
              : "",
          merchant_id_live:
            formValues?.is_live === true
              ? formValues?.merchant_id_live
                ? formValues?.merchant_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_id_live
              ? savedgateway[0]?.inputs?.merchant_id_live
              : "",
          merchant_id_test:
            formValues?.is_live === true
              ? formValues?.merchant_id_test
                ? formValues?.merchant_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_id_test
              ? savedgateway[0]?.inputs?.merchant_id_test
              : "",
          terminal_id_live:
            formValues?.is_live === true
              ? formValues?.terminal_id_live
                ? formValues?.terminal_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.terminal_id_live
              ? savedgateway[0]?.inputs?.terminal_id_live
              : "",
          terminal_id_test:
            formValues?.is_live === true
              ? formValues?.terminal_id_test
                ? formValues?.terminal_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.terminal_id_test
              ? savedgateway[0]?.inputs?.terminal_id_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Aurea Via") {
        newVALUE = {
          companyNum_live:
            formValues?.is_live === true
              ? formValues?.companyNum_live
                ? formValues?.companyNum_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.companyNum_live
              ? savedgateway[0]?.inputs?.companyNum_live
              : "",
          companyNum_test:
            formValues?.is_live === false
              ? formValues?.companyNum_test
                ? formValues?.companyNum_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.companyNum_test
              ? savedgateway[0]?.inputs?.companyNum_test
              : "",
          personalHashkey_live:
            formValues?.is_live === true
              ? formValues?.personalHashkey_live
                ? formValues?.personalHashkey_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.personalHashkey_live
              ? savedgateway[0]?.inputs?.personalHashkey_live
              : "",
          personalHashkey_test:
            formValues?.is_live === false
              ? formValues?.personalHashkey_test
                ? formValues?.personalHashkey_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.personalHashkey_test
              ? savedgateway[0]?.inputs?.personalHashkey_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Kasha") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",

          merchant_domain_live:
            formValues?.is_live === true
              ? formValues?.merchant_domain_live
                ? formValues?.merchant_domain_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_domain_live
              ? savedgateway[0]?.inputs?.merchant_domain_live
              : "",
          merchant_domain_test:
            formValues?.is_live === false
              ? formValues?.merchant_domain_test
                ? formValues?.merchant_domain_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_domain_test
              ? savedgateway[0]?.inputs?.merchant_domain_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Supefina") {
        newVALUE = {
          merchant_id_live:
            formValues?.is_live === true
              ? formValues?.merchant_id_live
                ? formValues?.merchant_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_id_live
              ? savedgateway[0]?.inputs?.merchant_id_live
              : "",
          merchant_id_test:
            formValues?.is_live === false
              ? formValues?.merchant_id_test
                ? formValues?.merchant_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.merchant_id_test
              ? savedgateway[0]?.inputs?.merchant_id_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "3xpay") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          
          api_secret_live:
            formValues?.is_live === false
              ? formValues?.api_secret_live
                ? formValues?.api_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_live
              ? savedgateway[0]?.inputs?.api_secret_live
              : "",

          api_secret_test:
            formValues?.is_live === false
              ? formValues?.api_secret_test
                ? formValues?.api_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_secret_test
              ? savedgateway[0]?.inputs?.api_secret_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Platy 2DS") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          password_live:
            formValues?.is_live === true
              ? formValues?.password_live
                ? formValues?.password_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_live
              ? savedgateway[0]?.inputs?.password_live
              : "",
          password_test:
            formValues?.is_live === false
              ? formValues?.password_test
                ? formValues?.password_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_test
              ? savedgateway[0]?.inputs?.password_test
              : "",

          platy_api_key_live:
            formValues?.is_live === false
              ? formValues?.platy_api_key_live
                ? formValues?.platy_api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_api_key_live
              ? savedgateway[0]?.inputs?.platy_api_key_live
              : "",

          platy_api_key_test:
            formValues?.is_live === false
              ? formValues?.platy_api_key_test
                ? formValues?.platy_api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_api_key_test
              ? savedgateway[0]?.inputs?.platy_api_key_test
              : "",

          platy_secret_key_live:
            formValues?.is_live === false
              ? formValues?.platy_secret_key_live
                ? formValues?.platy_secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_secret_key_live
              ? savedgateway[0]?.inputs?.platy_secret_key_live
              : "",

          platy_secret_key_test:
            formValues?.is_live === false
              ? formValues?.platy_secret_key_test
                ? formValues?.platy_secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_secret_key_test
              ? savedgateway[0]?.inputs?.platy_secret_key_test
              : "",

          username_live:
            formValues?.is_live === false
              ? formValues?.username_live
                ? formValues?.username_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.username_live
              ? savedgateway[0]?.inputs?.username_live
              : "",

          username_test:
            formValues?.is_live === false
              ? formValues?.username_test
                ? formValues?.username_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.username_test
              ? savedgateway[0]?.inputs?.username_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Platy 3DS") {
        newVALUE = {
          api_key_live:
            formValues?.is_live === true
              ? formValues?.api_key_live
                ? formValues?.api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_live
              ? savedgateway[0]?.inputs?.api_key_live
              : "",
          api_key_test:
            formValues?.is_live === false
              ? formValues?.api_key_test
                ? formValues?.api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.api_key_test
              ? savedgateway[0]?.inputs?.api_key_test
              : "",
          password_live:
            formValues?.is_live === true
              ? formValues?.password_live
                ? formValues?.password_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_live
              ? savedgateway[0]?.inputs?.password_live
              : "",
          password_test:
            formValues?.is_live === false
              ? formValues?.password_test
                ? formValues?.password_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.password_test
              ? savedgateway[0]?.inputs?.password_test
              : "",

          platy_api_key_live:
            formValues?.is_live === false
              ? formValues?.platy_api_key_live
                ? formValues?.platy_api_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_api_key_live
              ? savedgateway[0]?.inputs?.platy_api_key_live
              : "",

          platy_api_key_test:
            formValues?.is_live === false
              ? formValues?.platy_api_key_test
                ? formValues?.platy_api_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_api_key_test
              ? savedgateway[0]?.inputs?.platy_api_key_test
              : "",

          platy_secret_key_live:
            formValues?.is_live === false
              ? formValues?.platy_secret_key_live
                ? formValues?.platy_secret_key_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_secret_key_live
              ? savedgateway[0]?.inputs?.platy_secret_key_live
              : "",

          platy_secret_key_test:
            formValues?.is_live === false
              ? formValues?.platy_secret_key_test
                ? formValues?.platy_secret_key_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.platy_secret_key_test
              ? savedgateway[0]?.inputs?.platy_secret_key_test
              : "",

          username_live:
            formValues?.is_live === false
              ? formValues?.username_live
                ? formValues?.username_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.username_live
              ? savedgateway[0]?.inputs?.username_live
              : "",

          username_test:
            formValues?.is_live === false
              ? formValues?.username_test
                ? formValues?.username_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.username_test
              ? savedgateway[0]?.inputs?.username_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (type === "Bm2pay") {
        newVALUE = {
          client_id_live:
            formValues?.is_live === true
              ? formValues?.client_id_live
                ? formValues?.client_id_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_id_live
              ? savedgateway[0]?.inputs?.client_id_live
              : "",
          client_id_test:
            formValues?.is_live === false
              ? formValues?.client_id_test
                ? formValues?.client_id_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_id_test
              ? savedgateway[0]?.inputs?.client_id_test
              : "",

          client_secret_live:
            formValues?.is_live === true
              ? formValues?.client_secret_live
                ? formValues?.client_secret_live?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_secret_live
              ? savedgateway[0]?.inputs?.client_secret_live
              : "",
          client_secret_test:
            formValues?.is_live === false
              ? formValues?.client_secret_test
                ? formValues?.client_secret_test?.trim()
                : ""
              : savedgateway[0]?.inputs?.client_secret_test
              ? savedgateway[0]?.inputs?.client_secret_test
              : "",

          descriptor: formValues?.descriptor,
          mark_up: formValues?.mark_up,
        };
      }
      if (gateway_id) {
        setIsLoading(true);
        let NewWalletDetails: any = [];
        if (formValues?.wallet_ids?.length > 0) {
          formValues?.wallet_ids?.forEach((data: any) => {
              NewWalletDetails.push({
                wallet_address: data.wallet_id,
                percentage: data.percentage,
              });
            });
        }
     
        if (formValues?.ewallet_New_addressess?.length > 0) {
          formValues?.ewallet_New_addressess?.forEach((data: any) => {
            NewWalletDetails.push(data);
          });
        }

        
        let newFormValuesForPayload = {
          ...formValues,
        };

        Object.keys(newFormValuesForPayload)?.forEach((key) => {
          if (
            [
              "client_card_types",
              "additional_fees",
              "payout_fees",
              "wallet_ids",
              "disCard_walletes",
              "ewallet_New_addressess",
              "bank_account_numbers",
              "cardTypes",
              "fess_conditions",
              "payment_methods",
              "velocity",
              "advanced_avs",
              "whitelist_enabled",
              "cost",
            ].includes(key)
          ) {
            delete newFormValuesForPayload[key];
          }
        });
        const filterPaymentMethod = formValues?.payment_methods?.map(
          (i: any) => {
            return {
              ...i,
              name: i.name.toLowerCase(),
            };
          }
        );
        const defaultAVS = {
          validate_address : false,
          validate_phone_number : false,
          validate_email : false,
          validate_ip_address : false
        }

        const newAuthInfo = {
          ...(
            type === "Pix" || type === "Stripe"
              ? newVALUE
              : newFormValuesForPayload
          ),
          credential_type : credentialsType,
          predefinedCredentials : selectedPredefinedCredentials ? selectedPredefinedCredentials : null
        };

        const inputs = {
          client_id: id,
          gateway_id: gateway_id,
          method: saved_gateway_id ? "put" : "post",
          body: {
            auth_info: newAuthInfo
          },
          is_live: formValues?.is_live ? formValues?.is_live : false,
          to_convert: currencyConv == "requestPassthrough" ? false : true,
          new_currency:
            currencyConv == "requestPassthrough" ? "none" : selectedCurrency,
          reserved_pricing: {
            client_card_types: formValues?.client_card_types?.map((m: any) => {
              return {
                card_name: m?.card_name,
                percentage_fee: m?.percentage_fee,
                fixed_fee: m?.fixed_fee,
                currency_code: m?.currency_code,
                allow_card: m?.allow_card,
              };
            }),
            additional_fees: {
              chargeback_fees: formValues?.additional_fees?.chargeback_fees,
              dispute_fees: formValues?.additional_fees?.dispute_fees,
              reserve_fees: formValues?.additional_fees?.reserve_fees,
              refunded_tnx_fees: formValues?.additional_fees?.refunded_tnx_fees,
              declined_tnx_fees: formValues?.additional_fees?.declined_tnx_fees,
            },
            // gateway_method_fees: formValues?.gateway_method_fees,
            gateway_method_fees: {
              apm_fees: formValues?.gateway_method_fees?.apm_fees,
              payout_fees: formValues?.gateway_method_fees?.payout_fees,
              payin_fees: formValues?.gateway_method_fees?.payin_fees,
            },
            crypto_fees:{
              percentage_fee : formValues?.crypto_fees?.percentage_fee ?? "",
              fixed_fee : formValues?.crypto_fees?.fixed_fee ?? "",
              currency_code : formValues?.crypto_fees?.currency_code ?? "",
            }
            // client_cost: formValues?.client_cost,
          },
          settlement: {
            payout_fees: formValues?.payout_fees,
            ewallet_addressess: NewWalletDetails,
            discarded_wallets: formValues?.disCard_walletes,
          },
          cost: {
            client_card_types: formValues?.client_card_types?.map((m: any) => {
              return {
                card_name: m?.card_name,
                percentage_fee: m?.cost_percentage_fee,
                fixed_fee: m?.cost_fixed_fee,
                currency_code: m?.cost_currency_code,
                allow_card: m?.allow_card,
              };
            }),
            additional_fees: {
              chargeback_fees:
                formValues?.additional_fees?.cost_chargeback_fees,
              dispute_fees: formValues?.additional_fees?.cost_dispute_fees,
              reserve_fees: formValues?.additional_fees?.cost_reserve_fees,
              refunded_tnx_fees:
                formValues?.additional_fees?.cost_refunded_tnx_fees,
              declined_tnx_fees:
                formValues?.additional_fees?.cost_declined_tnx_fees,
            },
            gateway_method_fees: {
              apm_fees: formValues?.gateway_method_fees?.cost_apm_fees,
              payout_fees: formValues?.gateway_method_fees?.cost_payout_fees,
              payin_fees: formValues?.gateway_method_fees?.cost_payin_fees,
            },
            crypto_fees:{
              percentage_fee : formValues?.crypto_fees?.percentage_fee ?? "",
              fixed_fee : formValues?.crypto_fees?.fixed_fee ?? "",
              currency_code : formValues?.crypto_fees?.currency_code ?? "",
            }
          },
          velocity: formValues?.velocity,
          advanced_avs: (formValues?.advanced_avs) ? formValues?.advanced_avs : defaultAVS,
          payment_method: { filterPaymentMethod },
          is_active: formValues?.is_active, //formValues.payment_methods,
          whitelist_enabled:
            formValues?.whitelist_enabled == undefined
              ? false
              : formValues?.whitelist_enabled,
        };


        
        createClientGateway(inputs)
          .then((data : any) => {
            refreshParent();
            toast.success("Client gateway saved");
          })
          .catch((err : any) => {
            toast.error(
              err?.response?.data?.message ?? "Client gateway adding failed"
            );
          })
          .finally(() => {
            // setIsLoading(false);
          });
      }
    }
  };

  const handleVerifyWallet = () => {
    setTwoFaLoading(true);
    const pwdd = wallertVerifyIput?.password;
    const passCoded = authCode.join("");
    if (!pwdd) { setTwoFaLoading(false); toast.error("Please enter password"); return; }
    if (pwdd.length < 8) { setTwoFaLoading(false); toast.error("Password must contain at least 8 characters"); return; }
    if (!passCoded) { setTwoFaLoading(false); toast.error("please enter 2fa code"); return; }
    if (passCoded.length < 6) { setTwoFaLoading(false); toast.error("please enter valid 2fa code"); return; }
    const gateway = gatewayTypes.filter((data) => data?.name === type);
    const gateway_id = gateway?.length > 0 ? gateway[0]?.id : "";
    verifyWalletAddress({ id, gateway_id, password: wallertVerifyIput?.password, otp: passCoded, wallet_id: wallertVerifyIput?.wallet_id })
      .then((data: any) => {
        const ewallet = { ...data?.ewallet, is_verified: data?.is_verified };
        const res_wallet_id = ewallet?.wallet_address;
        setFormValues((prev: any) => ({ ...prev, wallet_ids: prev?.wallet_ids?.map((m: any) => res_wallet_id === m?.wallet_id ? { ...m, ...ewallet } : m) }));
        toast.success("Verified successfully!");
        onCloseWalletAddress();
      })
      .catch((err: any) => toast.error(err?.response?.data?.message))
      .finally(() => setTwoFaLoading(false));
  };

  // ── Derived ────────────────────────────────────────────────────────────────
  const currentAddedGateway = addedgateways.find((d: any) => d?.name === type);
  const currentGatewayMeta = gatewayTypes.find((d: any) => d?.name === type);
  const isLive = !!formValues?.is_live;

  // ── Shared sub-components ─────────────────────────────────────────────────
  const CurrencySelect = ({ value, onChange, disabled }: any) => (
    <AntSelect showSearch placeholder="Currency" optionFilterProp="children" className="w-full"
      filterOption={(input: string, option: any) => (option?.label ?? "").includes(input?.toUpperCase())}
      filterSort={(a: any, b: any) => (a?.label ?? "").toLowerCase().localeCompare((b?.label ?? "").toLowerCase())}
      options={currencyCodes.map((c) => { const d = getCurrencySymbol(c); return { value: c, label: `${c}: ${d.title?.toUpperCase()}` }; })}
      value={value} onChange={onChange} disabled={disabled} notFoundContent="No options found"
    />
  );

  const PeriodSelect = ({ value, onChange, disabled }: any) => (
    <AntSelect placeholder="Period" className="w-full"
      options={[{value:"Day",label:"Day"},{value:"Week",label:"Week"},{value:"Month",label:"Month"}]}
      value={value || undefined} onChange={onChange} disabled={disabled}
    />
  );

  const ErrMsg = ({ msg }: { msg?: string }) => msg ? <p className="cg-err-msg">{msg}</p> : null;


  if (isLoading || isupdating) {
    return (
      <>
        {(isLoading) ? (
          <div className="cco-loading">
            <span className="cco-spinner-lg"></span>
            <p className="cco-loading-txt">Loading/Saving gateway settings…</p>
          </div>
        ) : (
          <div className="cco-root">
            ...
          </div>
        )}
        <style>{`
          .cco-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px;gap:14px;}
          .cco-spinner-lg {width:26px;height:26px;border:3px solid #e2e8f0;border-top-color:#2563eb;border-radius:50%;animation: ccoSpinLg .7s linear infinite;}
          @keyframes ccoSpinLg {to { transform: rotate(360deg); }}
          .cco-loading-txt {font-size:13.5px;color:#94a3b8;font-weight:500;}
        `}</style>
      </>
    );
  }

  return (
    <div className="cg-root">
      <CgStyles />

      {/* ── Page header ── */}
      <div className="cg-page-header">
        <div className="cd-card-icon cd-card-icon--blue">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
        </div>
        <div className="flex-1">
          <h3 className="cg-page-title">Gateway Settings</h3>
          <p className="cg-page-sub">Configure payment gateways and credentials for this client</p>
        </div>
        <div className="cg-toggle">
          {singleRoleData?.[0]?.client?.value?.assign_client_gateway && (
            <AssignGateways
              fetchClients={() => {}}
              id={id}
              infoData={infoData}
              assigned_payment_methods={assigned_payment_methods}
              refreshParent={refreshParent}
              gatewayRefreshKey={gatewayRefreshKey}
              paymentMethods={paymentMethods}
              allGateways={allGateways}
              org_id = {org_id}
              setIsLoading={setIsLoading}
            />
          )}
          {/* <button className="wm-add-btn" onClick={()=>setIsOpenAssignGateway(true)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
            Assign New Gateway
          </button> */}
        </div>
      </div>

      {gatewayTypes.length === 0 && !isLoading && (
        <div className="cg-empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
          <p>No gateways are assigned to this client.</p>
        </div>
      )}

      {gatewayTypes.length > 0 && (
        <div className="cg-layout">

          {/* ══════════════════════════════════════════
              LEFT SIDEBAR — gateway list
          ══════════════════════════════════════════ */}
          <div className="cg-sidebar">
            <div className="cg-sidebar-header">
              <span className="cg-sidebar-title">Gateways</span>
              <span className="cd-card-badge">{gatewayTypes.length}</span>
            </div>
            
            <div className="cg-gw-list">
              {gatewayTypes.map((gw: any) => {
                const added = addedgateways.find((a: any) => a.name === gw.name);
                const activeStatus = added ? added.is_active : gw?.is_active;
                return (
                  <div
                    key={gw.name}
                    className={`cg-gw-card${type === gw.name ? " cg-gw-card--active" : ""}`}
                    onClick={() => { setType(gw.name); setHashID(gw.id); setGatewayTypes(gatewayTypesCopy); }}
                  >
                    <span className={`cg-gw-badge${activeStatus ? " cg-gw-badge--on" : " cg-gw-badge--off"}`}>
                      {activeStatus ? "Active" : "Inactive"}
                    </span>

                    <div className="cg-gw-main">
                      {methodName && gw.image && (
                        <img src={gw.image} alt={gw.name} className="cg-gw-img" />
                      )}
                      <p className="cg-gw-name">
                        {methodName ? gw?.name.replaceAll("_", " ") : gw?.id}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* ══════════════════════════════════════════
              RIGHT PANEL — gateway config
          ══════════════════════════════════════════ */}
          {sideLoading ? (
            <div className="cco-loading">
              <span className="cco-spinner-lg"></span>
              <p className="cco-loading-txt">Loading gateway configurations....</p>
            </div>
          ) : (
            <div className="cg-panel">
              {type && (
                <>
                  {/* Panel header */}
                  <div className="cg-panel-hd">
                    <div className="cg-panel-hd-left">
                      {methodName && currentGatewayMeta?.image && (
                        <img src={currentGatewayMeta.image} alt={type} className="cg-panel-logo" />
                      )}
                      <div>
                        <h4 className="cg-panel-gw-name">
                          {methodName ? type : hashID}
                        </h4>
                        {currentGatewayMeta?.gateway_type && (
                          <span className="cg-type-badge">{currentGatewayMeta.gateway_type}</span>
                        )}
                      </div>
                    </div>
                    <div className="cg-panel-hd-right">
                      {/* Active / Inactive toggle */}
                      <label className="cg-toggle">
                        <input type="checkbox" className="peer sr-only" checked={!!formValues?.is_active}
                          id={formValues?.type} onChange={handleActiveToggle} />
                        <div className={`cg-toggle-track${formValues?.is_active ? " cg-toggle-track--on" : ""}`} />
                        <span className="cg-toggle-lbl">{formValues?.is_active ? "Active" : "Inactive"}</span>
                      </label>
                      {/* Live / Test toggle */}
                      
                    </div>
                  </div>

                  <Accordion allowToggle className="cg-accordion">

                    {/* ── 1. Credentials ── */}
                    <AccordionItem className="cg-acc-item">
                      <h4>
                        <AccordionButton className="cg-acc-btn">
                          <div className="cg-acc-label">
                            <div className="cd-card-icon cd-card-icon--blue">
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                            </div>
                            Credentials
                            {credentialError && <span className="cg-err-badge">{credentialError}</span>}
                          </div>
                          <AccordionIcon className="cg-acc-icon" />
                        </AccordionButton>
                      </h4>
                      <AccordionPanel className="cg-acc-panel">
                        <div className="bl-card">
                          <div className="mb-4">
                            <div className="cg-field-row">
                              <p className="cg-field-lbl">Credential Type</p>

                              <label className="cg-toggle">
                                <input
                                  type="checkbox"
                                  className="peer sr-only"
                                  checked={isLive}
                                  onChange={handleToggle}
                                />
                                <div className={`cg-toggle-track${isLive ? " cg-toggle-track--indigo" : ""}`} />
                                <span className="cg-toggle-lbl">{isLive ? "Live" : "Test"}</span>
                              </label>
                            </div>

                            <div className="cg-radio-grp">
                              {["custom", "predefined"].map((ct) => (
                                <label
                                  key={ct}
                                  className={`cg-radio-opt${credentialsType === ct ? " cg-radio-opt--on" : ""}`}
                                >
                                  <input
                                    type="radio"
                                    value={ct}
                                    checked={credentialsType === ct}
                                    onChange={(e) => {
                                      setCredentialsType(e.target.value);
                                      setSelectedCredential("");
                                      setSelectedPredefinedCredentials(null);
                                      setCredentialError("");
                                    }}
                                  />
                                  {ct.charAt(0).toUpperCase() + ct.slice(1)}
                                </label>
                              ))}
                            </div>
                          </div>

                          {/* Predefined credential picker */}
                          {credentialsType === "predefined" && (
                            <div className="mb-4">
                              <p className="cg-field-lbl mb-1">Select Predefined Credential <span className="text-red-500">*</span></p>
                              <AntSelect showSearch placeholder="Select credential" optionFilterProp="children" className="w-full"
                                options={predefinedCredentials.map((c) => ({ value: c?.id, label: c?.name }))}
                                value={selectedCredential || undefined} onChange={handleCredentialSelect}
                                status={credentialError ? "error" : ""} notFoundContent="No predefined credentials found" />
                              {credentialError && <ErrMsg msg={credentialError} />}
                              {selectedPredefinedCredentials && (
                                <div className="cg-cred-preview mt-3">
                                  {Object.entries(selectedPredefinedCredentials).map(([key, value]) => {
                                    if (key === "id" || key === "name") return null;
                                    if ((key === "test_endpoint" && isLive) || (key === "live_endpoint" && !isLive)) return null;
                                    const label = key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
                                    return <InputField key={key} variant="auth" extra="mb-1" label={label} placeholder="" type="text" value={value as string} disabled />;
                                  })}
                                  <InputField variant="auth" extra="mb-1" label="Descriptor" placeholder="descriptor" id="descriptor" type="text" value={formValues?.descriptor ?? ""} state={formValuesErr?.descriptor ? "error" : ""} onChange={handleValueChange} />
                                </div>
                              )}
                            </div>
                          )}

                          {/* Custom credentials */}
                          {credentialsType === "custom" && (
                            <>
                              {/* Endpoint — same disabled input for all gateways */}
                              <InputField variant="auth" extra="mb-3" label="Endpoint *" placeholder="https://gateway.com"
                                id={isLive ? "live_endpoint" : "test_endpoint"} type="text"
                                value={isLive ? formValues?.live_endpoint : formValues?.test_endpoint}
                                state={isLive ? (formValuesErr?.live_endpoint ? "error" : "") : (formValuesErr?.test_endpoint ? "error" : "")}
                                onChange={handleValueChange} disabled />

                              {/* ─ Stripe ─ */}
                              {type === "Stripe" && (<>
                                <InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="sk_..." id={isLive?"secret_key_live":"secret_key_test"} type="text" value={isLive?formValues?.secret_key_live:formValues?.secret_key_test} state={isLive?(formValuesErr?.secret_key_live?"error":""):(formValuesErr?.secret_key_test?"error":"")} onChange={handleValueChange} />
                                <div className="cg-two-col">
                                  <InputField variant="auth" extra="mb-1 w-full" label="Statement Descriptor" placeholder="descriptor" id="statement_descriptor" type="text" value={formValues?.statement_descriptor??""} state={formValuesErr?.statement_descriptor?"error":""} onChange={handleValueChange} />
                                  <InputField variant="auth" extra="mb-1 w-full" label="Descriptor Suffix" placeholder="suffix" id="statement_descriptor_suffix" type="text" value={formValues?.statement_descriptor_suffix??""} state={formValuesErr?.statement_descriptor_suffix?"error":""} onChange={handleValueChange} />
                                </div>
                              </>)}
                              {/* ─ Sipe ─ */}
                              {type === "Sipe" && (<>
                                <InputField variant="auth" extra="mb-3" label="Merchant ID *" placeholder="Google inc." id="merchant_id" type="text" value={formValues?.merchant_id??""} state={formValuesErr?.merchant_id?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="App ID *" placeholder="" id="app_id" type="text" value={formValues?.app_id??""} state={formValuesErr?.app_id?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Nonce String *" placeholder="" id="nonce_string" type="text" value={formValues?.nonce_string??""} state={formValuesErr?.nonce_string?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Notify URL *" placeholder="" id="notify_url" type="text" value={formValues?.notify_url??""} state={formValuesErr?.notify_url?"error":""} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Blumon ─ */}
                              {type === "Blumon" && (<>
                                <InputField variant="auth" extra="mb-3" label="Business Name *" placeholder="Google inc." id="business_name" type="text" value={formValues?.business_name??""} state={formValuesErr?.business_name?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Username *" placeholder="test" id="username" type="text" value={formValues?.username??""} state={formValuesErr?.username?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="********" id="password" type={passwordShow?"text":"password"} value={formValues?.password??""} state={formValuesErr?.password?"error":""} onChange={handleValueChange} passwordShow={passwordShow} setPasswordShow={setPasswordShow} />
                              </>)}
                              {/* ─ Pix-Lotus ─ */}
                              {type === "Pix-Lotus" && (<>
                                <InputField variant="auth" extra="mb-3" label="Subscription Key *" placeholder="" id="subscription_key" type="text" value={formValues?.subscription_key??""} state={formValuesErr?.subscription_key?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Authorization" placeholder="" id="authorization" type="text" value={formValues?.authorization??""} state={formValuesErr?.authorization?"error":""} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Base URL" placeholder="" id="base_url" type="text" value={formValues?.base_url??""} state={formValuesErr?.base_url?"error":""} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Pix ─ */}
                              {type === "Pix" && (<>
                                <InputField variant="auth" extra="mb-3" label="Email *" placeholder="Email" id={isLive?"email_live":"email_test"} type="text" value={isLive?formValues?.email_live:formValues?.email_test} state={isLive?(formValuesErr?.email_live?"error":""):(formValuesErr?.email_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="Password" id={isLive?"name_live":"name_test"} type="text" value={isLive?formValues?.name_live:formValues?.name_test} state={isLive?(formValuesErr?.name_live?"error":""):(formValuesErr?.name_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Re-set ─ */}
                              {type === "Re-set" && (<>
                                <InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="Secret Key" id={isLive?"secretKey_live":"secretKey_test"} type="text" value={isLive?formValues?.secretKey_live:formValues?.secretKey_test} state={isLive?(formValuesErr?.secretKey_live?"error":""):(formValuesErr?.secretKey_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Brand ID *" placeholder="Brand ID" id={isLive?"brand_id_live":"brand_id_test"} type="text" value={isLive?formValues?.brand_id_live:formValues?.brand_id_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Raypd ─ */}
                              {type === "Raypd" && (<>
                                <InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="Secret key" id={isLive?"secret_key_live":"secret_key_test"} type="text" value={isLive?formValues?.secret_key_live:formValues?.secret_key_test} state={isLive?(formValuesErr?.secret_key_live?"error":""):(formValuesErr?.secret_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Access Key *" placeholder="Access key" id={isLive?"access_key_live":"access_key_test"} type="text" value={isLive?formValues?.access_key_live:formValues?.access_key_test} state={isLive?(formValuesErr?.access_key_live?"error":""):(formValuesErr?.access_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="MID Country" placeholder="MID Country" id={isLive?"mid_country_live":"mid_country_test"} type="text" value={isLive?formValues?.mid_country_live:formValues?.mid_country_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Banwire ─ */}
                              {type === "Banwire" && (<InputField variant="auth" extra="mb-3" label="Username *" placeholder="Username" id={isLive?"username_live":"username_test"} type="text" value={isLive?formValues?.username_live:formValues?.username_test} state={isLive?(formValuesErr?.username_live?"error":""):(formValuesErr?.username_test?"error":"")} onChange={handleValueChange} />)}
                              {/* ─ Valitor ─ */}
                              {type === "Valitor" && (<InputField variant="auth" extra="mb-3" label="API Key *" placeholder="API Key" id={isLive?"apikey_live":"apikey_test"} type="text" value={isLive?formValues?.apikey_live:formValues?.apikey_test} state={isLive?(formValuesErr?.apikey_live?"error":""):(formValuesErr?.apikey_test?"error":"")} onChange={handleValueChange} />)}
                              {/* ─ Bambora ─ */}
                              {type === "Bambora" && (<>
                                <InputField variant="auth" extra="mb-3" label="Merchant Id *" placeholder="Merchant Id" id={isLive?"merchantId_live":"merchantId_test"} type="text" value={isLive?formValues?.merchantId_live:formValues?.merchantId_test} state={isLive?(formValuesErr?.merchantId_live?"error":""):(formValuesErr?.merchantId_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Payment Passcode *" placeholder="Passcode" id={isLive?"passcode_live":"passcode_test"} type="text" value={isLive?formValues?.passcode_live:formValues?.passcode_test} state={isLive?(formValuesErr?.passcode_live?"error":""):(formValuesErr?.passcode_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Hash Key *" placeholder="Hash Key" id={isLive?"hash_key_live":"hash_key_test"} type="text" value={isLive?formValues?.hash_key_live:formValues?.hash_key_test} state={isLive?(formValuesErr?.hash_key_live?"error":""):(formValuesErr?.hash_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Recurring Passcode *" placeholder="" id={isLive?"recurring_passcode_live":"recurring_passcode_test"} type="text" value={isLive?formValues?.recurring_passcode_live:formValues?.recurring_passcode_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Reporting Passcode *" placeholder="" id={isLive?"reporting_passcode_live":"reporting_passcode_test"} type="text" value={isLive?formValues?.reporting_passcode_live:formValues?.reporting_passcode_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Batch Passcode *" placeholder="" id={isLive?"batch_passcode_live":"batch_passcode_test"} type="text" value={isLive?formValues?.batch_passcode_live:formValues?.batch_passcode_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Subscription Passcode *" placeholder="" id={isLive?"subscription_passcode_live":"subscription_passcode_test"} type="text" value={isLive?formValues?.subscription_passcode_live:formValues?.subscription_passcode_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Scipiopay ─ */}
                              {type === "Scipiopay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Shop ID *" placeholder="Shop id" id={isLive?"shop_id_live":"shop_id_test"} type="text" value={isLive?formValues?.shop_id_live:formValues?.shop_id_test} state={isLive?(formValuesErr?.shop_id_live?"error":""):(formValuesErr?.shop_id_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Shop Secret Key *" placeholder="" id={isLive?"shop_secret_key_live":"shop_secret_key_test"} type="text" value={isLive?formValues?.shop_secret_key_live:formValues?.shop_secret_key_test} state={isLive?(formValuesErr?.shop_secret_key_live?"error":""):(formValuesErr?.shop_secret_key_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Aurea Via ─ */}
                              {type === "Aurea Via" && (<>
                                <InputField variant="auth" extra="mb-3" label="Company Number *" placeholder="" id={isLive?"companyNum_live":"companyNum_test"} type="text" value={isLive?formValues?.companyNum_live:formValues?.companyNum_test} state={isLive?(formValuesErr?.companyNum_live?"error":""):(formValuesErr?.companyNum_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Personal Hash Key *" placeholder="" id={isLive?"personalHashkey_live":"personalHashkey_test"} type="text" value={isLive?formValues?.personalHashkey_live:formValues?.personalHashkey_test} state={isLive?(formValuesErr?.personalHashkey_live?"error":""):(formValuesErr?.personalHashkey_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Betapay ─ */}
                              {type === "Betapay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Token *" placeholder="" id={isLive?"api_token_live":"api_token_test"} type="text" value={isLive?formValues?.api_token_live:formValues?.api_token_test} state={isLive?(formValuesErr?.api_token_live?"error":""):(formValuesErr?.api_token_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Merchant Id *" placeholder="" id={isLive?"merchant_id_live":"merchant_id_test"} type="text" value={isLive?formValues?.merchant_id_live:formValues?.merchant_id_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Terminal Id *" placeholder="" id={isLive?"terminal_id_live":"terminal_id_test"} type="text" value={isLive?formValues?.terminal_id_live:formValues?.terminal_id_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Kasha ─ */}
                              {type === "Kasha" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Merchant Domain *" placeholder="" id={isLive?"merchant_domain_live":"merchant_domain_test"} type="text" value={isLive?formValues?.merchant_domain_live:formValues?.merchant_domain_test} state={isLive?(formValuesErr?.merchant_domain_live?"error":""):(formValuesErr?.merchant_domain_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Supefina ─ */}
                              {type === "Supefina" && (<InputField variant="auth" extra="mb-3" label="Merchant Id *" placeholder="" id={isLive?"merchant_id_live":"merchant_id_test"} type="text" value={isLive?formValues?.merchant_id_live:formValues?.merchant_id_test} state={isLive?(formValuesErr?.merchant_id_live?"error":""):(formValuesErr?.merchant_id_test?"error":"")} onChange={handleValueChange} />)}
                              {/* ─ Platy 2DS / 3DS ─ */}
                              {(type === "Platy 2DS" || type === "Platy 3DS") && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Username *" placeholder="" id={isLive?"username_live":"username_test"} type="text" value={isLive?formValues?.username_live:formValues?.username_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="" id={isLive?"password_live":"password_test"} type="text" value={isLive?formValues?.password_live:formValues?.password_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Platy Api Key *" placeholder="" id={isLive?"platy_api_key_live":"platy_api_key_test"} type="text" value={isLive?formValues?.platy_api_key_live:formValues?.platy_api_key_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Platy Secret Key *" placeholder="" id={isLive?"platy_secret_key_live":"platy_secret_key_test"} type="text" value={isLive?formValues?.platy_secret_key_live:formValues?.platy_secret_key_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Masterpay ─ */}
                              {type === "Masterpay" && (<InputField variant="auth" extra="mb-3" label="Merchant Private Key *" placeholder="" id={isLive?"merchant_private_key_live":"merchant_private_key_test"} type="text" value={isLive?formValues?.merchant_private_key_live:formValues?.merchant_private_key_test} state={isLive?(formValuesErr?.merchant_private_key_live?"error":""):(formValuesErr?.merchant_private_key_test?"error":"")} onChange={handleValueChange} />)}
                              {/* ─ Neonpay ─ */}
                              {type === "Neonpay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Merchant Key *" placeholder="" id={isLive?"merchant_key_live":"merchant_key_test"} type="text" value={isLive?formValues?.merchant_key_live:formValues?.merchant_key_test} state={isLive?(formValuesErr?.merchant_key_live?"error":""):(formValuesErr?.merchant_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="" id={isLive?"password_live":"password_test"} type="text" value={isLive?formValues?.password_live:formValues?.password_test} state={isLive?(formValuesErr?.password_live?"error":""):(formValuesErr?.password_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Bm2pay ─ */}
                              {type === "Bm2pay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Client Id *" placeholder="" id={isLive?"client_id_live":"client_id_test"} type="text" value={isLive?formValues?.client_id_live:formValues?.client_id_test} state={isLive?(formValuesErr?.client_id_live?"error":""):(formValuesErr?.client_id_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Client Secret *" placeholder="" id={isLive?"client_secret_live":"client_secret_test"} type="text" value={isLive?formValues?.client_secret_live:formValues?.client_secret_test} state={isLive?(formValuesErr?.client_secret_live?"error":""):(formValuesErr?.client_secret_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Digitarium ─ */}
                              {type === "Digitarium" && (<>
                                <InputField variant="auth" extra="mb-3" label="Merchant Key *" placeholder="" id={isLive?"merchantKey_live":"merchantKey_test"} type="text" value={isLive?formValues?.merchantKey_live:formValues?.merchantKey_test} state={isLive?(formValuesErr?.merchantKey_live?"error":""):(formValuesErr?.merchantKey_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="" id={isLive?"password_live":"password_test"} type="text" value={isLive?formValues?.password_live:formValues?.password_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Tangoindia ─ */}
                              {type === "Tangoindia" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api ID *" placeholder="" id={isLive?"api_id_live":"api_id_test"} type="text" value={isLive?formValues?.api_id_live:formValues?.api_id_test} state={isLive?(formValuesErr?.api_id_live?"error":""):(formValuesErr?.api_id_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ G2Pay ─ */}
                              {type === "G2Pay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Signing Key *" placeholder="" id={isLive?"signing_key_live":"signing_key_test"} type="text" value={isLive?formValues?.signing_key_live:formValues?.signing_key_test} state={isLive?(formValuesErr?.signing_key_live?"error":""):(formValuesErr?.signing_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Clickopay ─ */}
                              {type === "Clickopay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Salt Key *" placeholder="" id={isLive?"salt_key_live":"salt_key_test"} type="text" value={isLive?formValues?.salt_key_live:formValues?.salt_key_test} state={isLive?(formValuesErr?.salt_key_live?"error":""):(formValuesErr?.salt_key_test?"error":"")} onChange={handleValueChange} />
                              </>)}
                              {/* ─ CFGPayments ─ */}
                              {type === "CFGPayments" && (<InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="" id={isLive?"secret_key_live":"secret_key_test"} type="text" value={isLive?formValues?.secret_key_live:formValues?.secret_key_test} state={isLive?(formValuesErr?.secret_key_live?"error":""):(formValuesErr?.secret_key_test?"error":"")} onChange={handleValueChange} />)}
                              {/* ─ Capa ─ */}
                              {type === "Capa" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Webhook Secret *" placeholder="" id={isLive?"webhook_secret_live":"webhook_secret_test"} type="text" value={isLive?formValues?.webhook_secret_live:formValues?.webhook_secret_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Orionx ─ */}
                              {type === "Orionx" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="" id={isLive?"secret_key_live":"secret_key_test"} type="text" value={isLive?formValues?.secret_key_live:formValues?.secret_key_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Mauricio ─ */}
                              {type === "Mauricio" && (<>
                                <InputField variant="auth" extra="mb-3" label="Client Id *" placeholder="" id={isLive?"client_id_live":"client_id_test"} type="text" value={isLive?formValues?.client_id_live:formValues?.client_id_test} state={isLive?(formValuesErr?.client_id_live?"error":""):(formValuesErr?.client_id_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Api Secret *" placeholder="" id={isLive?"api_secret_live":"api_secret_test"} type="text" value={isLive?formValues?.api_secret_live:formValues?.api_secret_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Blox ─ */}
                              {type === "Blox" && (<InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />)}
                              {/* ─ Terracall ─ */}
                              {type === "Terracall" && (<>
                                <InputField variant="auth" extra="mb-3" label="Client ID *" placeholder="" id={isLive?"client_id_live":"client_id_test"} type="text" value={isLive?formValues?.client_id_live:formValues?.client_id_test} state={isLive?(formValuesErr?.client_id_live?"error":""):(formValuesErr?.client_id_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Client Secret *" placeholder="" id={isLive?"client_secret_live":"client_secret_test"} type="text" value={isLive?formValues?.client_secret_live:formValues?.client_secret_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ MyXspend ─ */}
                              {type === "MyXspend" && (<>
                                <InputField variant="auth" extra="mb-3" label="Email *" placeholder="" id={isLive?"email_live":"email_test"} type="text" value={isLive?formValues?.email_live:formValues?.email_test} state={isLive?(formValuesErr?.email_live?"error":""):(formValuesErr?.email_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="" id={isLive?"password_live":"password_test"} type="text" value={isLive?formValues?.password_live:formValues?.password_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Bennupay ─ */}
                              {type === "Bennupay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="" id={isLive?"secret_key_live":"secret_key_test"} type="text" value={isLive?formValues?.secret_key_live:formValues?.secret_key_test} state={isLive?(formValuesErr?.secret_key_live?"error":""):(formValuesErr?.secret_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Brand ID *" placeholder="" id={isLive?"brand_id_live":"brand_id_test"} type="text" value={isLive?formValues?.brand_id_live:formValues?.brand_id_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Xorapay ─ */}
                              {type === "Xorapay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Secret Key *" placeholder="" id={isLive?"secret_key_live":"secret_key_test"} type="text" value={isLive?formValues?.secret_key_live:formValues?.secret_key_test} state={isLive?(formValuesErr?.secret_key_live?"error":""):(formValuesErr?.secret_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Encryption Key *" placeholder="" id={isLive?"encryption_key_live":"encryption_key_test"} type="text" value={isLive?formValues?.encryption_key_live:formValues?.encryption_key_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Webhook Hash *" placeholder="" id={isLive?"webhook_hash_live":"webhook_hash_test"} type="text" value={isLive?formValues?.webhook_hash_live:formValues?.webhook_hash_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Murkon ─ */}
                              {type === "Murkon" && (<>
                                <InputField variant="auth" extra="mb-3" label="Entity Login *" placeholder="" id={isLive?"entity_login_live":"entity_login_test"} type="text" value={isLive?formValues?.entity_login_live:formValues?.entity_login_test} state={isLive?(formValuesErr?.entity_login_live?"error":""):(formValuesErr?.entity_login_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Entity Pass *" placeholder="" id={isLive?"entity_pass_live":"entity_pass_test"} type="text" value={isLive?formValues?.entity_pass_live:formValues?.entity_pass_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Entity Code *" placeholder="" id={isLive?"entity_code_live":"entity_code_test"} type="text" value={isLive?formValues?.entity_code_live:formValues?.entity_code_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Entity Type *" placeholder="" id={isLive?"entity_type_live":"entity_type_test"} type="text" value={isLive?formValues?.entity_type_live:formValues?.entity_type_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Terminal ID *" placeholder="" id={isLive?"terminal_id_live":"terminal_id_test"} type="text" value={isLive?formValues?.terminal_id_live:formValues?.terminal_id_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Changelly Fiat / Crypto ─ */}
                              {(type === "Changelly Fiat" || type === "Changelly Crypto") && (<>
                                <InputField variant="auth" extra="mb-3" label="Public API Key *" placeholder="" id={isLive?"public_api_key_live":"public_api_key_test"} type="text" value={isLive?formValues?.public_api_key_live:formValues?.public_api_key_test} state={isLive?(formValuesErr?.public_api_key_live?"error":""):(formValuesErr?.public_api_key_test?"error":"")} onChange={handleValueChange} />
                                {type === "Changelly Crypto"
                                  ? <TextArea variant="auth" extra="mb-3" label="Private Key *" placeholder="" id={isLive?"private_key_live":"private_key_test"} value={isLive?formValues?.private_key_live:formValues?.private_key_test} errMessage={isLive?(formValuesErr?.private_key_live?"error":""):(formValuesErr?.private_key_test?"error":"")} onChange={handleValueChange} />
                                  : <InputField variant="auth" extra="mb-3" label="Private Key *" placeholder="" id={isLive?"private_key_live":"private_key_test"} type="text" value={isLive?formValues?.private_key_live:formValues?.private_key_test} onChange={handleValueChange} />
                                }
                                {type === "Changelly Fiat" && (<>
                                  <div className="mb-3">
                                    <p className="cg-field-lbl mb-1">Provider *</p>
                                    <select id={isLive?"provider_live":"provider_test"} value={isLive?formValues?.provider_live:formValues?.provider_test} onChange={handleValueChange} className={`cg-select${(isLive?formValuesErr?.provider_live:formValuesErr?.provider_test)?" border-red-500":""}`}>
                                      <option value="">Select Provider</option>
                                      {["banxa","moonpay","transak","wert","skrill_crypto"].map(p => <option key={p} value={p}>{p}</option>)}
                                    </select>
                                  </div>
                                  <InputField variant="auth" extra="mb-3" label="Wallet Address *" placeholder="" id={isLive?"wallet_address_live":"wallet_address_test"} type="text" value={isLive?formValues?.wallet_address_live:formValues?.wallet_address_test} onChange={handleValueChange} />
                                  <InputField variant="auth" extra="mb-3" label="To Currency *" placeholder="" id={isLive?"to_currency_live":"to_currency_test"} type="text" value={isLive?formValues?.to_currency_live:formValues?.to_currency_test} onChange={handleValueChange} />
                                </>)}
                              </>)}
                              {/* ─ Transvoucher ─ */}
                              {type === "Transvoucher" && (<>
                                <InputField variant="auth" extra="mb-3" label="API Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="API Secret *" placeholder="" id={isLive?"api_secret_live":"api_secret_test"} type="text" value={isLive?formValues?.api_secret_live:formValues?.api_secret_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ DNSPay ─ */}
                              {type === "DNSPay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Endpoint ID *" placeholder="" id={isLive?"endpoint_id_live":"endpoint_id_test"} type="text" value={isLive?formValues?.endpoint_id_live:formValues?.endpoint_id_test} state={isLive?(formValuesErr?.endpoint_id_live?"error":""):(formValuesErr?.endpoint_id_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Merchant Key *" placeholder="" id={isLive?"merchant_key_live":"merchant_key_test"} type="text" value={isLive?formValues?.merchant_key_live:formValues?.merchant_key_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ Gate2Way ─ */}
                              {type === "Gate2Way" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Api Secret *" placeholder="" id={isLive?"api_secret_live":"api_secret_test"} type="text" value={isLive?formValues?.api_secret_live:formValues?.api_secret_test} onChange={handleValueChange} />
                                <div className="mb-3">
                                  <p className="cg-field-lbl mb-1">APM Payment Method *</p>
                                  <select id={isLive?"payment_method_live":"payment_method_test"} value={isLive?formValues?.payment_method_live:formValues?.payment_method_test} onChange={handleValueChange} className={`cg-select${(isLive?formValuesErr?.payment_method_live:formValuesErr?.payment_method_test)?" border-red-500":""}`}>
                                    <option value="">Select Method</option>
                                    {["GCash-AP","PayMaya-AP","Gotyme-AP","Grabpay-AP","DUITNOW-AP","TouchNGo-AP","ShopeePay-AP","GrabPay-MYR-AP","BoostPay-AP","FPX-MYR-AP","OnlineBanking-MYR-AP","DanaWallet-AP","OvoWallet-AP","QRIS-IDR-AP","VirutalAccount-IDR-AP","OnlineBanking-IDR-AP","Momo-AP","Vieel-AP","Zalo-AP","BankTransfer-VND-AP","VierQR-AP","MomoVietQR-AP","TrueMoney-AP","BankTransfer-THB-AP","Promptpay-AP","UPI-AP","OnlineBanking-SGD-AP","BankTransfer-HKD-AP","TAPNGO-AP"].map(m=><option key={m} value={m}>{m}</option>)}
                                  </select>
                                </div>
                                <div className="mb-3">
                                  <p className="cg-field-lbl mb-1">Payout Payment Method *</p>
                                  <select id={isLive?"payout_payment_method_live":"payout_payment_method_test"} value={isLive?formValues?.payout_payment_method_live:formValues?.payout_payment_method_test} onChange={handleValueChange} className="cg-select">
                                    <option value="">Select Method</option>
                                    {["payout-PHP-AP","BankTransfer-payout-IDR-AP","BankTransfer-payout-VND-AP","BankTransfer-payout-THB-AP","BankTransfer-payout-INR-AP","BankTransfer-payout-SGD-AP","BankTransfer-payout-HKD-AP"].map(m=><option key={m} value={m}>{m}</option>)}
                                  </select>
                                </div>
                              </>)}
                              {/* ─ Payouts Tech ─ */}
                              {type === "Payouts Tech" && (<>
                                <InputField variant="auth" extra="mb-3" label="Client Key *" placeholder="" id={isLive?"client_key_live":"client_key_test"} type="text" value={isLive?formValues?.client_key_live:formValues?.client_key_test} state={isLive?(formValuesErr?.client_key_live?"error":""):(formValuesErr?.client_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Password *" placeholder="" id={isLive?"password_live":"password_test"} type="text" value={isLive?formValues?.password_live:formValues?.password_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Brand *" placeholder="" id={isLive?"brand_live":"brand_test"} type="text" value={isLive?formValues?.brand_live:formValues?.brand_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Payout Client Key *" placeholder="" id={isLive?"payout_client_key_live":"payout_client_key_test"} type="text" value={isLive?formValues?.payout_client_key_live:formValues?.payout_client_key_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Payout Password *" placeholder="" id={isLive?"payout_password_live":"payout_password_test"} type="text" value={isLive?formValues?.payout_password_live:formValues?.payout_password_test} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Payout Brand *" placeholder="" id={isLive?"payout_brand_live":"payout_brand_test"} type="text" value={isLive?formValues?.payout_brand_live:formValues?.payout_brand_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ 3xpay ─ */}
                              {type === "3xpay" && (<>
                                <InputField variant="auth" extra="mb-3" label="Api Key *" placeholder="" id={isLive?"api_key_live":"api_key_test"} type="text" value={isLive?formValues?.api_key_live:formValues?.api_key_test} state={isLive?(formValuesErr?.api_key_live?"error":""):(formValuesErr?.api_key_test?"error":"")} onChange={handleValueChange} />
                                <InputField variant="auth" extra="mb-3" label="Api Secret *" placeholder="" id={isLive?"api_secret_live":"api_secret_test"} type="text" value={isLive?formValues?.api_secret_live:formValues?.api_secret_test} onChange={handleValueChange} />
                              </>)}
                              {/* ─ TestGateway — no extra fields ─ */}

                              {/* Descriptor (common) */}
                              <InputField variant="auth" extra="mb-1 mt-2" label="Descriptor" placeholder="descriptor" id="descriptor" type="text" value={formValues?.descriptor??""} state={formValuesErr?.descriptor?"error":""} onChange={handleValueChange} />
                            </>
                          )}

                          {/* ── Currency Converter ── */}
                          <hr className="cg-divider" />
                          <p className="cg-field-lbl mb-2">Currency Converter</p>
                          <div className="cg-radio-grp mb-3">
                            {["requestPassthrough","currencyConverter"].map(opt => (
                              <label key={opt} className={`cg-radio-opt${currencyConv===opt?" cg-radio-opt--on":""}`}>
                                <input type="radio" value={opt} checked={currencyConv===opt} onChange={e=>setCurrencyConv(e.target.value)} />
                                {opt==="requestPassthrough"?"Request Passthrough":"Currency Converter"}
                              </label>
                            ))}
                          </div>
                          {currencyConv === "currencyConverter" && (
                            <>
                              <p className="cg-field-lbl mb-1">Select Currency <span className="text-red-500">*</span></p>
                              <CurrencySelect value={selectedCurrency} onChange={handleCurrencySelect} />
                              <InputField variant="auth" extra="mb-1 mt-3" label="Markup Fees (%) *" placeholder="10%" id="mark_up" type="text" value={formValues?.mark_up??"0"} errMessage={formValuesErr?.mark_up??""} onChange={handleValueChange} />
                            </>
                          )}
                        </div>
                      </AccordionPanel>
                    </AccordionItem>

                    {/* ── 2. Payment Methods ── */}
                    <AccordionItem className="cg-acc-item">
                      <h4>
                        <AccordionButton className="cg-acc-btn">
                          <div className="cg-acc-label">
                            <div className="cd-card-icon cd-card-icon--green">
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                            </div>
                            Payment Methods
                          </div>
                          <AccordionIcon className="cg-acc-icon" />
                        </AccordionButton>
                      </h4>
                      <AccordionPanel className="cg-acc-panel">
                        <div className="bl-card">
                          <div className="cg-methods-grid">
                            {formValues?.payment_methods?.map((p: any) => (
                              <div key={p.name}
                                className={`cg-method-chip${p.is_Active?" cg-method-chip--on":""}${p?.disabled?" cg-method-chip--click":""}`}
                                onClick={() => {
                                  if (!p?.disabled) return;
                                  const updated = formValues?.payment_methods?.map((m: any) => m.name===p.name?{...m,is_Active:!m.is_Active}:m);
                                  setFormValues((prev: any) => ({...prev,payment_methods:updated}));
                                }}>
                                <div className={`cg-check-box${p.is_Active?" cg-check-box--on":""}`}>
                                  {p.is_Active&&<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="9" height="9"><polyline points="20 6 9 17 4 12" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                                </div>
                                <span className="capitalize">{p?.name?.replace("_"," ")}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </AccordionPanel>
                    </AccordionItem>

                    {/* ── 3. Pricing ── */}
                    {pricingRight && (
                      <AccordionItem className="cg-acc-item">
                        <h4>
                          <AccordionButton className="cg-acc-btn">
                            <div className="cg-acc-label">
                              <div className="cd-card-icon cd-card-icon--purple">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                              </div>
                              Pricing
                              {(formValuesErr?.client_card_types?.filter((f:any)=>f?.allow_card&&(f?.percentage_fee||f?.fixed_fee||f?.currency_code))?.length>0||isValidateAdditionalFeesPricing)&&(
                                <span className="cg-err-badge">Please fill required fields</span>
                              )}
                            </div>
                            <AccordionIcon className="cg-acc-icon" />
                          </AccordionButton>
                        </h4>
                        <AccordionPanel className="cg-acc-panel">
                          <div className="bl-card">
                            {clientGatewayType==="crypto" ? (
                              <div className="cg-fee-row">
                                <span className="cg-fee-label">Margin Fee</span>
                                <div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" value={formValues?.crypto_fees?.percentage_fee??""} onChange={handleMarginFee} className={`cg-inp${formValuesErr?.crypto_fees?.percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.crypto_fees?.percentage_fee}/></div>
                                <span className="cg-plus">+</span>
                                <div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="fixed_fee" value={formValues?.crypto_fees?.fixed_fee??""} onChange={handleMarginFee} className={`cg-inp${formValuesErr?.crypto_fees?.fixed_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.crypto_fees?.fixed_fee}/></div>
                                <div className="cg-inp-wrap" style={{minWidth:140}}><CurrencySelect value={formValues?.crypto_fees?.currency_code} onChange={(e:any)=>hanldleCryptoCurrenyChange(e,"crypto_currency_code")}/><ErrMsg msg={formValuesErr?.crypto_fees?.currency_code}/></div>
                              </div>
                            ) : (
                              <>
                                {formValues?.cardTypes?.length>0&&(
                                  <>
                                    <p className="cg-tbl-lbl">Card Types</p>
                                    <div className="overflow-x-auto">
                                      <table className="cg-tbl">
                                        <thead><tr className="cg-tbl-head"><th>Type</th><th>Fee%</th><th></th><th>Fixed</th><th>Currency</th></tr></thead>
                                        <tbody>
                                          {formValues?.cardTypes?.map((card:any,idx:number)=>{
                                            const ct=formValues?.client_card_types?.find((f:any)=>f?.card_name===card);
                                            const ctE=formValuesErr?.client_card_types?.find((f:any)=>f?.card_name===card);
                                            return(
                                              <tr key={card} className="cg-tbl-row">
                                                <td><div className="cg-check-row"><Checkbox id="allow_card" value={!ct?.allow_card} checked={!!ct?.allow_card} onChange={(e:any)=>handlePriceValueChange(e,idx,card,"")}/><span>{card}</span></div></td>
                                                <td><div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" disabled={!ct?.allow_card} value={ct?.percentage_fee??""} onChange={(e)=>handlePriceValueChange(e,idx,card,"")} className={`cg-inp cg-inp-sm${ctE?.percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={ctE?.percentage_fee}/></div></td>
                                                <td className="cg-plus">+</td>
                                                <td><div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="fixed_fee" disabled={!ct?.allow_card} value={ct?.fixed_fee??""} onChange={(e)=>handlePriceValueChange(e,idx,card,"")} className={`cg-inp cg-inp-sm${ctE?.fixed_fee?" cg-inp--err":""}`}/><ErrMsg msg={ctE?.fixed_fee}/></div></td>
                                                <td><div className="cg-inp-wrap" style={{minWidth:130}}><CurrencySelect value={ct?.currency_code} onChange={(e:any)=>handlePriceValueChange(e,idx,card,"cardType_currency_code")} disabled={!ct?.allow_card}/><ErrMsg msg={ctE?.currency_code}/></div></td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </>
                                )}
                                <>
                                  <p className="cg-tbl-lbl mt-4">Additional Fees</p>
                                  {[
                                    {key:"chargeback_fees",label:"Chargeback Fee",tk:"allow_chargeback_fees",ck:"chargeback_currency_code"},
                                    {key:"dispute_fees",label:"Dispute Fee",tk:"allow_dispute_fees",ck:"dispute_currency_code"},
                                    {key:"declined_tnx_fees",label:"Declined Transaction Fee",tk:"allow_declined_tnx_fees",ck:"decliened_tnx_currency_code"},
                                    {key:"refunded_tnx_fees",label:"Refunded Transaction Fee",tk:"allow_refunded_tnx_fees",ck:"refunded_tnx_currency_code"},
                                  ].map(({key,label,tk,ck})=>(
                                    <div key={key} className="cg-addl-row">
                                      <div className="cg-addl-lbl"><Checkbox id={tk} value={!formValues?.additional_fees?.[key]?.[tk]} checked={!!formValues?.additional_fees?.[key]?.[tk]} onChange={(e:any)=>handleAdditionalValueChange(e,key)}/><span>{label}</span></div>
                                      <div className="cg-fee-row" style={{flex:1}}>
                                        <div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" disabled={!formValues?.additional_fees?.[key]?.[tk]} value={formValues?.additional_fees?.[key]?.percentage_fee??""} onChange={(e)=>handleAdditionalValueChange(e,key)} className={`cg-inp cg-inp-sm${formValuesErr?.additional_fees?.[key]?.percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.additional_fees?.[key]?.percentage_fee}/></div>
                                        <span className="cg-plus">+</span>
                                        <div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="fixed_fee" disabled={!formValues?.additional_fees?.[key]?.[tk]} value={formValues?.additional_fees?.[key]?.fixed_fee??""} onChange={(e)=>handleAdditionalValueChange(e,key)} className={`cg-inp cg-inp-sm${formValuesErr?.additional_fees?.[key]?.fixed_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.additional_fees?.[key]?.fixed_fee}/></div>
                                        <div className="cg-inp-wrap" style={{minWidth:130}}><CurrencySelect value={formValues?.additional_fees?.[key]?.currency_code} onChange={(e:any)=>handleAdditionalValueChange(e,ck)} disabled={!formValues?.additional_fees?.[key]?.[tk]}/><ErrMsg msg={formValuesErr?.additional_fees?.[key]?.currency_code}/></div>
                                      </div>
                                    </div>
                                  ))}
                                  {/* Reserve */}
                                  <div className="cg-addl-row">
                                    <div className="cg-addl-lbl"><Checkbox id="allow_reserve_fees" value={!formValues?.additional_fees?.reserve_fees?.allow_reserve_fees} checked={!!formValues?.additional_fees?.reserve_fees?.allow_reserve_fees} onChange={(e:any)=>handleAdditionalValueChange(e,"reserve_fees")}/><span>Reserve</span></div>
                                    <div className="cg-fee-row" style={{flex:1}}>
                                      <div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" disabled={!formValues?.additional_fees?.reserve_fees?.allow_reserve_fees} value={formValues?.additional_fees?.reserve_fees?.percentage_fee??""} onChange={(e)=>handleAdditionalValueChange(e,"reserve_fees")} className={`cg-inp cg-inp-sm${formValuesErr?.additional_fees?.reserve_fees?.percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.additional_fees?.reserve_fees?.percentage_fee}/></div>
                                      <span className="cg-plus">+</span>
                                      <div className="cg-inp-wrap"><input type="number" placeholder="Days" id="number_of_days" disabled={!formValues?.additional_fees?.reserve_fees?.allow_reserve_fees} value={formValues?.additional_fees?.reserve_fees?.number_of_days??""} onChange={(e)=>handleAdditionalValueChange(e,"reserve_fees")} className={`cg-inp cg-inp-sm${formValuesErr?.additional_fees?.reserve_fees?.number_of_days?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.additional_fees?.reserve_fees?.number_of_days}/></div>
                                    </div>
                                  </div>
                                  <div className="cg-fee-row" style={{ marginTop: "10px" }}>
                                    <span className="cg-fee-label">Margin Fee</span>
                                    <div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" value={formValues?.crypto_fees?.percentage_fee??""} onChange={handleMarginFee} className={`cg-inp${formValuesErr?.crypto_fees?.percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.crypto_fees?.percentage_fee}/></div>
                                    <span className="cg-plus">+</span>
                                    <div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="fixed_fee" value={formValues?.crypto_fees?.fixed_fee??""} onChange={handleMarginFee} className={`cg-inp${formValuesErr?.crypto_fees?.fixed_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.crypto_fees?.fixed_fee}/></div>
                                    <div className="cg-inp-wrap" style={{minWidth:140}}><CurrencySelect value={formValues?.crypto_fees?.currency_code} onChange={(e:any)=>hanldleCryptoCurrenyChange(e,"crypto_currency_code")}/><ErrMsg msg={formValuesErr?.crypto_fees?.currency_code}/></div>
                                  </div>
                                </>
                              </>
                            )}
                          </div>
                        </AccordionPanel>
                      </AccordionItem>
                    )}

                    {/* ── 4. Cost ── */}
                    {pricingRight && (
                      <AccordionItem className="cg-acc-item">
                        <h4>
                          <AccordionButton className="cg-acc-btn">
                            <div className="cg-acc-label">
                              <div className="cd-card-icon cd-card-icon--blue">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                              </div>
                              Cost
                              {(formValuesErr?.client_card_types?.filter((f:any)=>f?.allow_card&&(f?.cost_percentage_fee||f?.cost_fixed_fee||f?.cost_currency_code))?.length>0||isValidateAdditionalFeesCost)&&(
                                <span className="cg-err-badge">Please fill required fields</span>
                              )}
                            </div>
                            <AccordionIcon className="cg-acc-icon" />
                          </AccordionButton>
                        </h4>
                        <AccordionPanel className="cg-acc-panel">
                          <div className="bl-card">
                            {clientGatewayType==="crypto" ? (
                              <div className="cg-fee-row">
                                <span className="cg-fee-label">Margin Fee</span>
                                <div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" value={formValues?.crypto_fees?.percentage_fee??""} onChange={handleMarginFee} className={`cg-inp${formValuesErr?.crypto_fees?.percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.crypto_fees?.percentage_fee}/></div>
                                <span className="cg-plus">+</span>
                                <div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="fixed_fee" value={formValues?.crypto_fees?.fixed_fee??""} onChange={handleMarginFee} className={`cg-inp${formValuesErr?.crypto_fees?.fixed_fee?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.crypto_fees?.fixed_fee}/></div>
                                <div className="cg-inp-wrap" style={{minWidth:140}}><CurrencySelect value={formValues?.crypto_fees?.currency_code} onChange={(e:any)=>hanldleCryptoCurrenyChange(e,"crypto_currency_code")}/><ErrMsg msg={formValuesErr?.crypto_fees?.currency_code}/></div>
                              </div>
                            ) : (
                            <>
                              {clientGatewayType!=="crypto"&&formValues?.cardTypes?.length>0&&(
                                <>
                                  <p className="cg-tbl-lbl">Card Types (Cost)</p>
                                  <div className="overflow-x-auto">
                                    <table className="cg-tbl">
                                      <thead><tr className="cg-tbl-head"><th>Type</th><th>Cost%</th><th></th><th>Fixed</th><th>Currency</th></tr></thead>
                                      <tbody>
                                        {formValues?.cardTypes?.map((card:any,idx:number)=>{
                                          const ct=formValues?.client_card_types?.find((f:any)=>f?.card_name===card);
                                          const ctE=formValuesErr?.client_card_types?.find((f:any)=>f?.card_name===card);
                                          return(
                                            <tr key={card} className="cg-tbl-row">
                                              <td><div className="cg-check-row"><Checkbox id="allow_card" value={!ct?.allow_card} checked={!!ct?.allow_card} disabled onChange={(e:any)=>{}} title="Selection based on Pricing."/><span>{card}</span></div></td>
                                              <td><div className="cg-inp-wrap"><input type="number" placeholder="%" id="cost_percentage_fee" disabled={!ct?.allow_card} value={ct?.cost_percentage_fee??""} onChange={(e)=>handlePriceValueChange(e,idx,card,"")} className={`cg-inp cg-inp-sm${ctE?.cost_percentage_fee?" cg-inp--err":""}`}/><ErrMsg msg={ctE?.cost_percentage_fee}/></div></td>
                                              <td className="cg-plus">+</td>
                                              <td><div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="cost_fixed_fee" disabled={!ct?.allow_card} value={ct?.cost_fixed_fee??""} onChange={(e)=>handlePriceValueChange(e,idx,card,"")} className={`cg-inp cg-inp-sm${ctE?.cost_fixed_fee?" cg-inp--err":""}`}/><ErrMsg msg={ctE?.cost_fixed_fee}/></div></td>
                                              <td><div className="cg-inp-wrap" style={{minWidth:130}}><CurrencySelect value={ct?.cost_currency_code} onChange={(e:any)=>handlePriceValueChange(e,idx,card,"cost_cardType_currency_code")} disabled={!ct?.allow_card}/><ErrMsg msg={ctE?.cost_currency_code}/></div></td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              )}
                            
                              <>
                                <p className="cg-tbl-lbl mt-4">Additional Fees (Cost)</p>
                                {[
                                  {key:"cost_chargeback_fees",label:"Chargeback Fee",tk:"allow_chargeback_fees",ck:"cost_chargeback_currency_code"},
                                  {key:"cost_dispute_fees",label:"Dispute Fee",tk:"allow_dispute_fees",ck:"cost_dispute_currency_code"},
                                  {key:"cost_declined_tnx_fees",label:"Declined Transaction Fee",tk:"allow_declined_tnx_fees",ck:"cost_decliened_tnx_currency_code"},
                                  {key:"cost_refunded_tnx_fees",label:"Refunded Transaction Fee",tk:"allow_refunded_tnx_fees",ck:"cost_refunded_tnx_currency_code"},
                                ].map(({key,label,tk,ck})=>(
                                  <div key={key} className="cg-addl-row">
                                    <div className="cg-addl-lbl"><Checkbox id={tk} value={!formValues?.additional_fees?.[key]?.[tk]} checked={!!formValues?.additional_fees?.[key]?.[tk]} onChange={(e:any)=>handleAdditionalValueChangeOfCost(e,key)}/><span>{label}</span></div>
                                    <div className="cg-fee-row" style={{flex:1}}>
                                      <div className="cg-inp-wrap"><input type="number" placeholder="%" id="percentage_fee" disabled={!formValues?.additional_fees?.[key]?.[tk]} value={formValues?.additional_fees?.[key]?.percentage_fee??""} onChange={(e)=>handleAdditionalValueChangeOfCost(e,key)} className={`cg-inp cg-inp-sm${formValuesErr?.additional_fees?.[key]?.percentage_fee?" cg-inp--err":""}`}/></div>
                                      <span className="cg-plus">+</span>
                                      <div className="cg-inp-wrap"><input type="number" placeholder="Fixed" id="fixed_fee" disabled={!formValues?.additional_fees?.[key]?.[tk]} value={formValues?.additional_fees?.[key]?.fixed_fee??""} onChange={(e)=>handleAdditionalValueChangeOfCost(e,key)} className={`cg-inp cg-inp-sm${formValuesErr?.additional_fees?.[key]?.fixed_fee?" cg-inp--err":""}`}/></div>
                                      <div className="cg-inp-wrap" style={{minWidth:130}}><CurrencySelect value={formValues?.additional_fees?.[key]?.currency_code} onChange={(e:any)=>handleAdditionalValueChangeOfCost(e,ck)} disabled={!formValues?.additional_fees?.[key]?.[tk]}/></div>
                                    </div>
                                  </div>
                                ))}
                                <div className="cg-addl-row">
                                  <div className="cg-addl-lbl"><Checkbox id="allow_reserve_fees" value={!formValues?.additional_fees?.cost_reserve_fees?.allow_reserve_fees} checked={!!formValues?.additional_fees?.cost_reserve_fees?.allow_reserve_fees} onChange={(e:any)=>handleAdditionalValueChangeOfCost(e,"cost_reserve_fees")}/><span>Reserve</span></div>
                                  <div className="cg-fee-row" style={{flex:1}}>
                                    <input type="number" placeholder="%" id="percentage_fee" disabled={!formValues?.additional_fees?.cost_reserve_fees?.allow_reserve_fees} value={formValues?.additional_fees?.cost_reserve_fees?.percentage_fee??""} onChange={(e)=>handleAdditionalValueChangeOfCost(e,"cost_reserve_fees")} className="cg-inp cg-inp-sm" />
                                    <span className="cg-plus">+</span>
                                    <input type="number" placeholder="Days" id="number_of_days" disabled={!formValues?.additional_fees?.cost_reserve_fees?.allow_reserve_fees} value={formValues?.additional_fees?.cost_reserve_fees?.number_of_days??""} onChange={(e)=>handleAdditionalValueChangeOfCost(e,"cost_reserve_fees")} className="cg-inp cg-inp-sm" />
                                  </div>
                                </div>
                              </>
                            </>
                            )}
                          </div>
                        </AccordionPanel>
                      </AccordionItem>
                    )}

                    {/* ── 5. Advanced AVS ── */}
                    <AccordionItem className="cg-acc-item">
                      <h4>
                        <AccordionButton className="cg-acc-btn">
                          <div className="cg-acc-label">
                            <div className="cd-card-icon cd-card-icon--purple">
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                            </div>
                            Advanced AVS
                          </div>
                          <AccordionIcon className="cg-acc-icon" />
                        </AccordionButton>
                      </h4>
                      <AccordionPanel className="cg-acc-panel">
                        <div className="bl-card">
                          <div className="cg-methods-grid">
                            {[
                              {id:"validate_address",label:"Validate Address"},
                              {id:"validate_phone_number",label:"Validate Phone Number"},
                              {id:"validate_email",label:"Validate Email"},
                              {id:"validate_ip_address",label:"Validate IP Address"},
                            ].map(({id,label})=>(
                              <label key={id} className={`cg-method-chip${formValues?.advanced_avs?.[id]?" cg-method-chip--on":""} cg-method-chip--click`}>
                                <input type="checkbox" checked={!!formValues?.advanced_avs?.[id]} onChange={(e)=>handleAdvancedAVSChange(e,id)} className="sr-only" />
                                <div className={`cg-check-box${formValues?.advanced_avs?.[id]?" cg-check-box--on":""}`}>
                                  {formValues?.advanced_avs?.[id]&&<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="9" height="9"><polyline points="20 6 9 17 4 12" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                                </div>
                                {label}
                              </label>
                            ))}
                          </div>
                        </div>
                      </AccordionPanel>
                    </AccordionItem>

                    {/* ── 6. Velocity ── */}
                    <AccordionItem className="cg-acc-item">
                      <h4>
                        <AccordionButton className="cg-acc-btn">
                          <div className="cg-acc-label">
                            <div className="cd-card-icon cd-card-icon--blue">
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                            </div>
                            Velocity Controls
                            {isValidateVelocity&&<span className="cg-err-badge">Please fill required fields</span>}
                          </div>
                          <AccordionIcon className="cg-acc-icon" />
                        </AccordionButton>
                      </h4>
                      <AccordionPanel className="cg-acc-panel">
                        <div className="bl-card">
                          <div className="cg-vel-grid">
                            {/* Transaction Limit */}
                            <div className="cg-vel-row">
                              <div className="cg-vel-lbl"><Checkbox id="allow_transaction_limit" checked={!!formValues?.velocity?.transaction_limit?.allow_transaction_limit} value={!formValues?.velocity?.transaction_limit?.allow_transaction_limit} onChange={(e:any)=>handleVelocityValueChange(e,"allow_transaction_limit","transaction_limit")}/><span>Transaction Limit</span></div>
                              <div className="cg-vel-fields">
                                <div className="cg-inp-wrap"><input type="number" placeholder="Limit" id="limit_no" disabled={!formValues?.velocity?.transaction_limit?.allow_transaction_limit} value={formValues?.velocity?.transaction_limit?.limit_no??""} onChange={(e)=>handleVelocityValueChange(e,"limit_no","transaction_limit")} className={`cg-inp cg-inp-sm${formValuesErr?.velocity?.transaction_limit?.limit_no?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.velocity?.transaction_limit?.limit_no}/></div>
                                <div className="cg-inp-wrap" style={{minWidth:120}}><PeriodSelect value={formValues?.velocity?.transaction_limit?.period} onChange={(e:any)=>handleVelocityValueChange(e,"period","transaction_limit")} disabled={!formValues?.velocity?.transaction_limit?.allow_transaction_limit}/><ErrMsg msg={formValuesErr?.velocity?.transaction_limit?.period}/></div>
                              </div>
                            </div>
                            {/* Blocked Countries */}
                            <div className="cg-vel-row cg-vel-row--wide">
                              <div className="cg-vel-lbl"><Checkbox id="allow_blocked_countries" checked={!!formValues?.velocity?.blocked_countries?.allow_blocked_countries} value={!formValues?.velocity?.blocked_countries?.allow_blocked_countries} onChange={(e:any)=>handleVelocityValueChange(e,"allow_blocked_countries","blocked_countries")}/><span>Blocked Countries</span></div>
                              <div className="cg-vel-fields" style={{flex:1}}>
                                <MultiSelect options={CountryOptions} value={formValues?.velocity?.blocked_countries?.country_code||[]} disabled={!formValues?.velocity?.blocked_countries?.allow_blocked_countries} onChange={(e:any)=>handleVelocityValueChange(e,"country_code","blocked_countries")} labelledBy="Select Countries" isCreatable={false} className="!bg-slate-100 w-full" valueRenderer={(sel:any)=>sel.length===0?"Select country":sel.length===CountryOptions.length?"All countries":sel.map((o:any)=>o.label).join(", ")} />
                                <ErrMsg msg={formValuesErr?.velocity?.blocked_countries?.country_code}/>
                              </div>
                            </div>
                            {/* Blocked Countries BIN */}
                            <div className="cg-vel-row cg-vel-row--wide">
                              <div className="cg-vel-lbl"><Checkbox id="allow_blocked_countries_bin" checked={!!formValues?.velocity?.blocked_countries_bin?.allow_blocked_countries_bin} value={!formValues?.velocity?.blocked_countries_bin?.allow_blocked_countries_bin} onChange={(e:any)=>handleVelocityValueChange(e,"allow_blocked_countries_bin","blocked_countries_bin")}/><span>Blocked Countries BIN</span></div>
                              <div className="cg-vel-fields" style={{flex:1}}>
                                <MultiSelect options={binCountryOptions} value={formValues?.velocity?.blocked_countries_bin?.country_code||[]} disabled={!formValues?.velocity?.blocked_countries_bin?.allow_blocked_countries_bin} onChange={(e:any)=>handleVelocityValueChange(e,"country_code","blocked_countries_bin")} labelledBy="Select Countries BIN" isCreatable={false} className="!bg-slate-100 w-full" valueRenderer={(sel:any)=>sel.length===0?"Select country":sel.map((o:any)=>o.label).join(", ")} />
                                <ErrMsg msg={formValuesErr?.velocity?.blocked_countries_bin?.country_code}/>
                              </div>
                            </div>
                            {/* Max Amount Per Transaction */}
                            <div className="cg-vel-row">
                              <div className="cg-vel-lbl"><Checkbox id="allow_max_transaction_limit" checked={!!formValues?.velocity?.max_transaction_limit?.allow_max_transaction_limit} value={!formValues?.velocity?.max_transaction_limit?.allow_max_transaction_limit} onChange={(e:any)=>handleVelocityValueChange(e,"allow_max_transaction_limit","max_transaction_limit")}/><span>Max Amount / Txn</span></div>
                              <div className="cg-vel-fields">
                                <div className="cg-inp-wrap"><input type="number" placeholder="Amount" id="limit_amount" disabled={!formValues?.velocity?.max_transaction_limit?.allow_max_transaction_limit} value={formValues?.velocity?.max_transaction_limit?.limit_amount??""} onChange={(e)=>handleVelocityValueChange(e,"limit_amount","max_transaction_limit")} className={`cg-inp cg-inp-sm${formValuesErr?.velocity?.max_transaction_limit?.limit_amount?" cg-inp--err":""}`}/></div>
                                <div className="cg-inp-wrap" style={{minWidth:130}}><CurrencySelect value={formValues?.velocity?.max_transaction_limit?.currency||undefined} onChange={(e:any)=>handleVelocityValueChange(e,"currency","max_transaction_limit")} disabled={!formValues?.velocity?.max_transaction_limit?.allow_max_transaction_limit}/><ErrMsg msg={formValuesErr?.velocity?.max_transaction_limit?.currency}/></div>
                              </div>
                            </div>
                            {/* Min Amount Per Transaction */}
                            <div className="cg-vel-row">
                              <div className="cg-vel-lbl"><Checkbox id="allow_min_transaction_limit" checked={!!formValues?.velocity?.min_transaction_limit?.allow_min_transaction_limit} value={!formValues?.velocity?.min_transaction_limit?.allow_min_transaction_limit} onChange={(e:any)=>handleVelocityValueChange(e,"allow_min_transaction_limit","min_transaction_limit")}/><span>Min Amount / Txn</span></div>
                              <div className="cg-vel-fields">
                                <div className="cg-inp-wrap"><input type="number" placeholder="Amount" id="limit_amount" disabled={!formValues?.velocity?.min_transaction_limit?.allow_min_transaction_limit} value={formValues?.velocity?.min_transaction_limit?.limit_amount??""} onChange={(e)=>handleVelocityValueChange(e,"limit_amount","min_transaction_limit")} className={`cg-inp cg-inp-sm${formValuesErr?.velocity?.min_transaction_limit?.limit_amount?" cg-inp--err":""}`}/></div>
                                <div className="cg-inp-wrap" style={{minWidth:130}}><CurrencySelect value={formValues?.velocity?.min_transaction_limit?.currency||undefined} onChange={(e:any)=>handleVelocityValueChange(e,"currency","min_transaction_limit")} disabled={!formValues?.velocity?.min_transaction_limit?.allow_min_transaction_limit}/></div>
                              </div>
                            </div>
                            {/* Max Transaction Period */}
                            <div className="cg-vel-row">
                              <div className="cg-vel-lbl"><Checkbox id="allow_max_transaction_period" checked={!!formValues?.velocity?.max_transaction_period?.allow_max_transaction_period} value={!formValues?.velocity?.max_transaction_period?.allow_max_transaction_period} onChange={(e:any)=>handleVelocityValueChange(e,"allow_max_transaction_period","max_transaction_period")}/><span>Max Txn Amount</span></div>
                              <div className="cg-vel-fields">
                                <input type="number" placeholder="Amount" id="limit_amount" disabled={!formValues?.velocity?.max_transaction_period?.allow_max_transaction_period} value={formValues?.velocity?.max_transaction_period?.limit_amount??""} onChange={(e)=>handleVelocityValueChange(e,"limit_amount","max_transaction_period")} className={`cg-inp cg-inp-sm${formValuesErr?.velocity?.max_transaction_period?.limit_amount?" cg-inp--err":""}`}/>
                                <div style={{minWidth:130}}><CurrencySelect value={formValues?.velocity?.max_transaction_period?.currency||undefined} onChange={(e:any)=>handleVelocityValueChange(e,"currency","max_transaction_period")} disabled={!formValues?.velocity?.max_transaction_period?.allow_max_transaction_period}/></div>
                                <div style={{minWidth:120}}><PeriodSelect value={formValues?.velocity?.max_transaction_period?.period} onChange={(e:any)=>handleVelocityValueChange(e,"period","max_transaction_period")} disabled={!formValues?.velocity?.max_transaction_period?.allow_max_transaction_period}/></div>
                              </div>
                            </div>
                            {/* Retry Time */}
                            <div className="cg-vel-row">
                              <div className="cg-vel-lbl"><Checkbox id="allow_retry_time" checked={!!formValues?.velocity?.retry_time?.allow_retry_time} value={!formValues?.velocity?.retry_time?.allow_retry_time} onChange={(e:any)=>handleVelocityValueChange(e,"allow_retry_time","retry_time")}/><span>Retry Time</span></div>
                              <div className="cg-vel-fields">
                                <div className="cg-inp-wrap"><input type="number" placeholder="Minutes" id="limit_minutes" disabled={!formValues?.velocity?.retry_time?.allow_retry_time} value={formValues?.velocity?.retry_time?.limit_minutes??""} onChange={(e)=>handleVelocityValueChange(e,"limit_minutes","retry_time")} className={`cg-inp cg-inp-sm${formValuesErr?.velocity?.retry_time?.limit_minutes?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.velocity?.retry_time?.limit_minutes}/></div>
                              </div>
                            </div>
                            {/* Attempts Day/Week/Month/Total */}
                            {[
                              {key:"max_attempts_day",tk:"allow_max_attempts_day",label:"Max Attempts / Card (Day)"},
                              {key:"max_attempts_week",tk:"allow_max_attempts_week",label:"Max Attempts / Card (Week)"},
                              {key:"max_attempts_month",tk:"allow_max_attempts_month",label:"Max Attempts / Card (Month)"},
                              {key:"max_attempts_total",tk:"allow_max_attempts_total",label:"Max Attempts / Card (Total)"},
                            ].map(({key,tk,label})=>(
                              <div key={key} className="cg-vel-row">
                                <div className="cg-vel-lbl"><Checkbox id={tk} checked={!!formValues?.velocity?.[key]?.[tk]} value={!formValues?.velocity?.[key]?.[tk]} onChange={(e:any)=>handleVelocityValueChange(e,tk,key)}/><span>{label}</span></div>
                                <div className="cg-vel-fields">
                                  <div className="cg-inp-wrap"><input type="number" placeholder="Limit" id="limit_no" disabled={!formValues?.velocity?.[key]?.[tk]} value={formValues?.velocity?.[key]?.limit_no??""} onChange={(e)=>handleVelocityValueChange(e,"limit_no",key)} className={`cg-inp cg-inp-sm${formValuesErr?.velocity?.[key]?.limit_no?" cg-inp--err":""}`}/><ErrMsg msg={formValuesErr?.velocity?.[key]?.limit_no}/></div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </AccordionPanel>
                    </AccordionItem>

                    {/* ── 7. Whitelist ── */}
                    {singleRoleData?.[0]?.whitelist?.value?.view_whitelist_list && (
                      <AccordionItem className="cg-acc-item">
                        <h4>
                          <AccordionButton className="cg-acc-btn">
                            <div className="cg-acc-label">
                              <div className="cd-card-icon cd-card-icon--green">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                              </div>
                              Whitelist
                            </div>
                            <div className="flex items-center gap-3" onClick={e=>e.stopPropagation()}>
                              <label className="cg-toggle">
                                <input type="checkbox" className="peer sr-only" checked={!!formValues?.whitelist_enabled}
                                  onChange={()=>setFormValues((p:any)=>({...p,whitelist_enabled:!p?.whitelist_enabled}))}/>
                                <div className={`cg-toggle-track${formValues?.whitelist_enabled?" cg-toggle-track--on":""}`}/>
                                <span className="cg-toggle-lbl">{formValues?.whitelist_enabled?"Enabled":"Disabled"}</span>
                              </label>
                              <AccordionIcon className="cg-acc-icon"/>
                            </div>
                          </AccordionButton>
                        </h4>
                        <AccordionPanel className="cg-acc-panel">
                          <WhiteListClients gatewayTypes={gatewayTypes} type={type} client_id={id} />
                        </AccordionPanel>
                      </AccordionItem>
                    )}

                    {/* ── 8. Settlement ── */}
                    {settelmentRight && (
                      <AccordionItem className="cg-acc-item">
                        <h4>
                          <AccordionButton className="cg-acc-btn">
                            <div className="cg-acc-label">
                              <div className="cd-card-icon cd-card-icon--green">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                              </div>
                              Settlement &amp; Wallets
                            </div>
                            <AccordionIcon className="cg-acc-icon"/>
                          </AccordionButton>
                        </h4>
                        <AccordionPanel className="cg-acc-panel">
                          <div className="wl-toolbar">
                            <div className="wl-toolbar-left">
                              <div className="wl-section-icon">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
                                </svg>
                              </div>
                              <div>
                                <h3 className="wl-section-title">Wallets</h3>
                                <p className="wl-section-sub">Manage wallets for this gateway</p>
                              </div>
                            </div>
                            <button className="wm-add-btn" onClick={()=>handleNewWallet("add_New_wallet","")}>
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
                              </svg>
                              Add Wallet
                            </button>
                          </div>
                          <div className="bl-card">
                            <div className="cg-wallets">
                              {/* <div className="cg-wallets-hd">
                                <span className="cg-field-lbl">Wallets</span>
                                {walletErrors&&<span className="cg-err-badge">{walletErrors}</span>}
                                <button className="cg-add-btn" onClick={()=>handleNewWallet("add_New_wallet","")}>
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                  Add Wallet
                                </button>
                              </div> */}
                              {formValues?.wallet_ids?.length===0&&formValues?.ewallet_New_addressess?.length===0&&(
                                // <p className="cg-no-wallets">No wallets configured.</p>
                                <div className="bl-empty-state">
                                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
                                  </svg>
                                  <p>No wallets configured.</p>
                                </div>
                              )}
                              {formValues?.wallet_ids?.map((w:any,i:number)=>(
                                <div key={i} className="cg-wallet-row">
                                  <input type="text" id="wallet_address" className="cg-inp cg-inp--grow" disabled={!w?.is_verified}
                                    placeholder={w?.is_verified?"Wallet address":"•••••••••••••••••"}
                                    value={w?.wallet_address??""} onChange={(e)=>handleEwalletValueChange(e,w,"e_wallet_address")}/>
                                  {!w?.is_verified&&(
                                    <button className="cg-icon-btn" title="Verify wallet" onClick={()=>{
                                      getProfileSecond().then((d:any)=>{
                                        setIsOpenWalletAddress(true);
                                        setWallertVerifyIput({wallet_id:w?.wallet_id,is_auth_2fa_activate:d[0]?.auth_2fa});
                                      }).catch(()=>toast.error("Something went wrong!"));
                                    }}><IoEyeOutline/></button>
                                  )}
                                  <div className="cg-wallet-pct">
                                    <input type="number" id="percentage" placeholder="%" className="cg-inp" style={{width:70}} disabled={!w?.is_verified}
                                      value={w?.percentage??""} onChange={(e)=>handleEwalletValueChange(e,w,"e_wallet_percentage")}/>
                                    <span className="cg-pct-lbl">%</span>
                                  </div>
                                  <button className="cg-icon-btn cg-icon-btn--del" onClick={()=>handleDiscardExistingWallets(w)}><CiCircleMinus/></button>
                                </div>
                              ))}
                              {formValues?.ewallet_New_addressess?.map((w:any,i:number)=>(
                                <div key={i} className="cg-wallet-row">
                                  <input type="text" id="wallet_address" placeholder="New wallet address" className="cg-inp cg-inp--grow"
                                    value={w?.wallet_address??""} onChange={(e)=>handleNewWalletValueChange(e,"","e_wallet_address",i)}/>
                                  <div className="cg-wallet-pct">
                                    <input type="number" id="percentage" placeholder="%" className="cg-inp" style={{width:70}}
                                      value={w?.percentage??""} onChange={(e)=>handleNewWalletValueChange(e,"","e_wallet_percentage",i)}/>
                                    <span className="cg-pct-lbl">%</span>
                                  </div>
                                  <button className="cg-icon-btn cg-icon-btn--del" onClick={()=>handleNewWallet("remove_New_wallet",i)}><CiCircleMinus/></button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </AccordionPanel>
                      </AccordionItem>
                    )}

                  </Accordion>

                  {/* ── Action bar ── */}
                  <div className="cg-action-bar">
                    {currentAddedGateway?.inputs&&(
                      <DeleteClientGatewayModal 
                        data={currentAddedGateway} 
                        fetchClients={fetchClients} 
                        refreshParent={refreshParent}
                        gatewayRefreshKey={gatewayRefreshKey}
                        setIsLoading={setIsLoading}/>
                    )}
                    <button className="cg-save-btn" disabled={isLoading} onClick={handleSubmit}>
                      {isLoading?<DivLoader className="h-5 w-5 border-white"/>:(
                        <>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                            <polyline points="17 21 17 13 7 13 7 21"/>
                            <polyline points="7 3 7 8 15 8"/>
                          </svg>
                          {currentAddedGateway?.inputs ? "Update Gateway Settings" : "Setup Gateway"}
                        </>
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {isOpenWalletAddress && (
        <div className="cg-overlay" onClick={onCloseWalletAddress}>
          <div className="cg-modal" onClick={e=>e.stopPropagation()}>
            <div className="cg-modal-hd">
              <h4>2FA Verification</h4>
              <button onClick={onCloseWalletAddress} className="cg-modal-close"><MdHighlightOff/></button>
            </div>
            <div className="cg-modal-body">
              {!wallertVerifyIput?.is_auth_2fa_activate?(
                <div className="cg-warn-banner">
                  <MdWarning className="cg-warn-icon"/>
                  <div>
                    <p className="font-semibold">2FA Not Activated</p>
                    <p className="text-sm mt-1">Please visit <Link to="/admin/profile" className="underline text-blue-600">profile settings</Link> to activate 2FA before viewing wallet addresses.</p>
                  </div>
                </div>
              ):(
                <>
                  <div className="cg-warn-banner cg-warn-banner--info">
                    <MdWarning className="cg-warn-icon"/>
                    <p>Enter your password and 2FA code to reveal the wallet address.</p>
                  </div>
                  <InputField variant="auth" extra="mb-3" label="Password *" placeholder="Enter password" id="password"
                    type={wallertVerifyIput?.isShow?"text":"password"} value={wallertVerifyIput?.password??""}
                    onChange={(e:any)=>setWallertVerifyIput((p:any)=>({...p,password:e.target.value}))}
                    passwordShow={wallertVerifyIput?.isShow} setPasswordShow={()=>setWallertVerifyIput((p:any)=>({...p,isShow:!p?.isShow}))}/>
                  <p className="cg-field-lbl mb-2">2FA Code *</p>
                  <div className="cg-2fa-boxes">
                    {authCode.map((digit, idx) => (
                      <input
                        key={idx}
                        ref={(el) => (inputRefs.current[idx] = el)}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange2fa(idx, e)}
                        onKeyDown={(e) => handleKeyDown2fa(idx, e)}
                        onPaste={idx === 0 ? handlePaste2fa : undefined}
                        className={`cg-2fa-box${digit ? " cg-2fa-box--filled" : ""}`}
                        aria-label={`Digit ${idx + 1}`}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="cg-modal-ft">
              <button className="cg-cancel-btn" onClick={onCloseWalletAddress}>Cancel</button>
              {wallertVerifyIput?.is_auth_2fa_activate&&(
                <button className="cg-save-btn" onClick={handleVerifyWallet}>
                  {TwoFaLoading?<DivLoader className="h-5 w-5 border-white"/>:"Verify"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────────────
const CgStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    @keyframes cgSpin { to { transform: rotate(360deg); } }
    .bl-card { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px; overflow: hidden; box-shadow: 0 1px 4px rgba(15,23,42,.05);padding:10px 10px !important }
    .wl-toolbar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 20px 24px; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px; box-shadow: 0 1px 4px rgba(15,23,42,.05);margin-bottom:20px }
    .wl-toolbar-left { display: flex; align-items: center; gap: 12px; }
    .wl-section-icon { width: 38px; height: 38px; border-radius: 10px; background: linear-gradient(135deg,#f0fdf4,#dcfce7); border: 1.5px solid #bbf7d0; display: flex; align-items: center; justify-content: center; color: #16a34a; flex-shrink: 0; }
    .wl-section-title { font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 2px;line-height:22px }
    .wl-section-sub { font-size: 12px; color: #94a3b8; font-weight: 500; }
    .bl-empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 40px 20px; }
    .bl-empty-state p { font-size: 13px; color: #94a3b8; font-weight: 500; }
    .cg-field-row { display:flex;align-items:center;justify-content:space-between;margin-bottom:8px; }
    .cg-root { font-family: 'Plus Jakarta Sans', sans-serif; display: flex; flex-direction: column; gap: 20px; }
    .cg-page-header { display: flex; align-items: center; gap: 12px; }
    .cg-page-title { font-size: 15.5px; font-weight: 700; color: #0f172a; margin: 0;line-height:22px }
    .cg-page-sub { font-size: 12.5px; color: #94a3b8; font-weight: 500; margin: 0; }
    .cg-empty { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 48px 0; color: #94a3b8; font-size: 13px; font-weight: 500; }
    .cg-toggle { display: flex; align-items: center; gap: 8px; cursor: pointer; margin-left: auto; }
    /* Layout */
    .cg-layout { display: grid; grid-template-columns: 300px 1fr; gap: 20px; align-items: start; }
    @media (max-width: 768px) { .cg-layout { grid-template-columns: 1fr; } }

    /* Sidebar */
    .cg-sidebar { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; overflow: hidden; box-shadow: 0 1px 4px rgba(15,23,42,.05); position: sticky; top: 20px; }
    .cg-sidebar-header { padding: 12px 16px; border-bottom: 1px solid #f1f5f9; background: #fafbfc; display: flex; align-items: center; justify-content: space-between; }
    .cg-sidebar-title { font-size: 11.5px; font-weight: 700; color: #0f172a; text-transform: uppercase; letter-spacing: .5px; }
    .cg-gw-list { display: flex; flex-direction: column; max-height: 540px; overflow-y: auto; }
    .cg-gw-list::-webkit-scrollbar { width: 4px; }
    .cg-gw-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 100px; }

    /* Gateway card */

    .cg-gw-card { padding:20px 14px;border-bottom:1px solid #f1f5f9;cursor:pointer;transition:background .12s;display:flex;align-items:center;gap:10px;position:relative; }
    .cg-gw-main { display:flex;align-items:center;gap:10px; }
    .cg-gw-badge { font-size:10px;font-weight:700;padding:2px 7px;border-radius:100px;letter-spacing:.2px;position:absolute;top:8px;right:10px; }
    .cg-gw-img { width:38px;height:28px;object-fit:contain; }

    .cg-gw-card:last-child { border-bottom: none; }
    .cg-gw-card:hover { background: #f8fafc; }
    .cg-gw-card--active { background: #eff6ff !important; border-left: 3px solid #2563eb; }
    .cg-gw-badge--on { background: #15803d; color: #f0fdf4; }
    .cg-gw-badge--off { background: #dc2626; color: #fef2f2; }
    .cg-gw-img-wrap { display: flex; justify-content: center; width: 100%; }
    .cg-gw-name { font-size: 11.5px; font-weight: 600; color: #374151; word-break: break-all; }

    /* Right panel */
    .cg-panel { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; overflow: hidden; box-shadow: 0 1px 4px rgba(15,23,42,.05); }
    .cg-panel-hd { padding: 16px 22px; border-bottom: 1.5px solid #f1f5f9; background: #fafbfc; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
    .cg-panel-hd-left { display: flex; align-items: center; gap: 12px; }
    .cg-panel-hd-right { display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
    .cg-panel-logo { width: 44px; height: 32px; object-fit: contain; border-radius: 8px; border: 1px solid #e2e8f0; padding: 4px; background: #fff; }
    .cg-panel-gw-name { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0 0 3px; }
    .cg-type-badge { font-size: 11px; font-weight: 600; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; padding: 2px 8px; border-radius: 100px; text-transform: capitalize; }

    /* Toggle */
    .cg-toggle { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; }
    .cg-toggle-track { position: relative; display: inline-block; width: 40px; height: 22px; border-radius: 100px; background: #cbd5e1; transition: background .15s; flex-shrink: 0; }
    .cg-toggle-track::after { content: ''; position: absolute; left: 3px; top: 3px; width: 16px; height: 16px; border-radius: 50%; background: white; transition: transform .15s; box-shadow: 0 1px 3px rgba(0,0,0,.2); }
    .cg-toggle-track--on { background: #22c55e; }
    .cg-toggle-track--on::after { transform: translateX(18px); }
    .cg-toggle-track--indigo { background: #6366f1; }
    .cg-toggle-track--indigo::after { transform: translateX(18px); }
    .cg-toggle-lbl { font-size: 13px; font-weight: 600; color: #374151; min-width: 52px; }

    /* Accordion */
    .cg-accordion { border: none !important; }
    .cg-acc-item { border-bottom: 1px solid #f1f5f9 !important; border-left: none !important; border-right: none !important; border-top: none !important; }
    .cg-acc-item:last-child { border-bottom: none !important; }
    .cg-acc-btn { padding: 15px 22px !important; background: transparent !important; border: none !important; width: 100% !important; display: flex !important; align-items: center !important; justify-content: space-between !important; }
    .cg-acc-btn:hover { background: #f8fafc !important; }
    .cg-acc-label { display: flex; align-items: center; gap: 10px; font-size: 13.5px; font-weight: 700; color: #0f172a; }
    .cg-acc-icon { color: #94a3b8 !important; }
    .cg-acc-panel { padding: 20px 20px 20px 20px !important; }

    /* Helpers */
    .cg-field-lbl { font-size: 11.5px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: .4px; }
    .cg-two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    @media (max-width: 600px) { .cg-two-col { grid-template-columns: 1fr; } }
    .cg-divider { border: none; border-top: 1px solid #f1f5f9; margin: 16px 0; }
    .cg-select { width: 100%; border: 1.5px solid #e2e8f0; border-radius: 9px; padding: 8px 11px; font-size: 13px; font-family: inherit; background: #fff; outline: none; }
    .cg-select:focus { border-color: #93c5fd; }

    /* Radio group */
    .cg-radio-grp { display: flex; gap: 8px; flex-wrap: wrap; }
    .cg-radio-opt { display: inline-flex; align-items: center; gap: 7px; padding: 7px 13px; border-radius: 9px; border: 1.5px solid #e2e8f0; font-size: 13px; font-weight: 600; color: #64748b; cursor: pointer; transition: all .12s; background: #fff; }
    .cg-radio-opt input { display: none; }
    .cg-radio-opt:hover { border-color: #93c5fd; color: #2563eb; }
    .cg-radio-opt--on { border-color: #2563eb; color: #2563eb; background: #eff6ff; }

    /* Credential preview */
    .cg-cred-preview { padding: 14px; background: #f8fafc; border-radius: 10px; border: 1px solid #e2e8f0; }

    /* Inputs */
    .cg-inp { border: 1.5px solid #e2e8f0; border-radius: 9px; padding: 7px 11px; font-size: 13px; font-family: inherit; color: #0f172a; background: #fff; transition: border-color .12s; outline: none; width: 100%; }
    .cg-inp:focus { border-color: #93c5fd; }
    .cg-inp:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
    .cg-inp--err { border-color: #fca5a5 !important; background: #fff5f5; }
    .cg-inp--grow { flex: 1; min-width: 0; }
    .cg-inp-sm { padding: 6px 9px; font-size: 12.5px; }
    .cg-inp-wrap { display: flex; flex-direction: column; }
    .cg-err-msg { font-size: 10.5px; color: #dc2626; font-weight: 600; margin-top: 3px; }
    .cg-err-badge { font-size: 10.5px; font-weight: 700; padding: 2px 8px; border-radius: 100px; background: #fef2f2; color: #dc2626; border: 1px solid #fca5a5; }

    /* Methods / chips */
    .cg-methods-grid { display: flex; flex-wrap: wrap; gap: 8px; }
    .cg-method-chip { display: inline-flex; align-items: center; gap: 7px; padding: 7px 12px; border-radius: 9px; border: 1.5px solid #e2e8f0; font-size: 12.5px; font-weight: 600; color: #64748b; background: #f8fafc; transition: all .12s; }
    .cg-method-chip--click { cursor: pointer; }
    .cg-method-chip--click:hover { border-color: #93c5fd; }
    .cg-method-chip--on { border-color: #bfdbfe; background: #eff6ff; color: #1d4ed8; }
    .cg-check-box { width: 15px; height: 15px; border-radius: 4px; border: 2px solid #cbd5e1; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all .12s; }
    .cg-check-box--on { background: #2563eb; border-color: #2563eb; color: #fff; }

    /* Tables */
    .cg-tbl-lbl { font-size: 11px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 8px; }
    .cg-tbl { width: 100%; border-collapse: collapse; font-size: 13px; }
    .cg-tbl-head th { font-size: 10.5px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: .4px; padding: 6px 8px; text-align: left; border-bottom: 1px solid #f1f5f9; }
    .cg-tbl-row td { padding: 8px; vertical-align: top; }
    .cg-check-row { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: #374151; white-space: nowrap; }
    .cg-plus { color: #94a3b8; text-align: center; padding: 0 4px; padding-top: 8px; }

    /* Fee rows */
    .cg-fee-row { display: flex; align-items: flex-start; gap: 8px; flex-wrap: wrap; }
    .cg-fee-label { font-size: 13px; font-weight: 600; color: #374151; white-space: nowrap; min-width: 80px; padding-top: 6px; }
    .cg-addl-row { display: flex; align-items: flex-start; gap: 12px; padding: 10px 0; border-bottom: 1px solid #f8fafc; flex-wrap: wrap; }
    .cg-addl-row:last-child { border-bottom: none; }
    .cg-addl-lbl { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: #374151; min-width: 190px; padding-top: 4px; }

    /* Velocity */
    .cg-vel-grid { display: flex; flex-direction: column; gap: 8px; }
    .cg-vel-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; padding: 11px 14px; background: #f8fafc; border-radius: 10px; border: 1px solid #f1f5f9; flex-wrap: wrap; }
    .cg-vel-row--wide { flex-wrap: wrap; }
    .cg-vel-lbl { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: #374151; min-width: 185px; }
    .cg-vel-fields { display: flex; gap: 8px; flex-wrap: wrap; align-items: flex-start; }

    /* Wallets */
    .cg-wallets { display: flex; flex-direction: column; gap: 10px; }
    .cg-wallets-hd { display: flex; align-items: center; gap: 10px; }
    .cg-no-wallets { font-size: 13px; color: #94a3b8; font-style: italic; padding: 8px 0; }
    .cg-wallet-row { display: flex; align-items: center; gap: 10px; padding: 10px; background: #f8fafc; border-radius: 10px; border: 1px solid #f1f5f9; flex-wrap: wrap; }
    .cg-wallet-pct { display: flex; align-items: center; gap: 4px; }
    .cg-pct-lbl { font-size: 12px; color: #64748b; font-weight: 600; }
    .cg-add-btn { display: inline-flex; align-items: center; gap: 5px; padding: 6px 12px; border-radius: 8px; background: #eff6ff; border: 1.5px solid #bfdbfe; color: #2563eb; font-size: 12px; font-weight: 600; cursor: pointer; margin-left: auto; transition: all .12s; }
    .cg-add-btn:hover { background: #dbeafe; }
    .cg-icon-btn { display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 8px; border: 1.5px solid #e2e8f0; background: #fff; color: #64748b; cursor: pointer; font-size: 18px; transition: all .12s; flex-shrink: 0; }
    .cg-icon-btn:hover { border-color: #93c5fd; color: #2563eb; }
    .cg-icon-btn--del:hover { border-color: #fca5a5 !important; color: #dc2626 !important; }

    /* Action bar */
    .cg-action-bar { padding: 14px 22px; border-top: 1.5px solid #f1f5f9; background: #fafbfc; display: flex; align-items: center; justify-content: flex-end; gap: 10px; }
    .cg-save-btn { display: inline-flex; align-items: center; gap: 7px; padding: 10px 20px; border-radius: 10px; background: linear-gradient(135deg,#1d4ed8,#2563eb); color: #fff; font-family: 'Plus Jakarta Sans',sans-serif; font-size: 13.5px; font-weight: 700; border: none; cursor: pointer; transition: all .15s; box-shadow: 0 2px 8px rgba(37,99,235,.3); }
    .cg-save-btn:hover { background: linear-gradient(135deg,#1e40af,#1d4ed8); box-shadow: 0 4px 14px rgba(37,99,235,.4); }
    .cg-save-btn:disabled { opacity: .6; cursor: not-allowed; }
    .cg-cancel-btn { display: inline-flex; align-items: center; padding: 10px 18px; border-radius: 10px; background: #f1f5f9; border: 1.5px solid #e2e8f0; color: #374151; font-family: 'Plus Jakarta Sans',sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all .12s; }
    .cg-cancel-btn:hover { background: #e2e8f0; }

    /* 2FA Modal */
    .cg-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.4); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 20px; }
    .cg-modal { background: #fff; border-radius: 18px; width: 100%; max-width: 460px; box-shadow: 0 20px 60px rgba(0,0,0,.15); overflow: hidden; }
    .cg-modal-hd { padding: 18px 22px; background: linear-gradient(135deg,#1d4ed8,#2563eb); color: #fff; display: flex; align-items: center; justify-content: space-between; }
    .cg-modal-hd h4 { font-size: 15px; font-weight: 700; margin: 0; }
    .cg-modal-close { background: none; border: none; color: rgba(255,255,255,.8); cursor: pointer; font-size: 22px; display: flex; align-items: center; padding: 0; }
    .cg-modal-close:hover { color: #fff; }
    .cg-modal-body { padding: 22px; }
    .cg-modal-ft { padding: 14px 22px; border-top: 1px solid #f1f5f9; background: #fafbfc; display: flex; justify-content: flex-end; gap: 10px; }

    /* Warning banners */
    .cg-warn-banner { display: flex; align-items: flex-start; gap: 12px; padding: 13px 15px; border-radius: 11px; background: #fffbeb; border: 1.5px solid #fde68a; color: #92400e; font-size: 13px; font-weight: 500; margin-bottom: 16px; }
    .cg-warn-banner--info { background: #eff6ff; border-color: #bfdbfe; color: #1e3a8a; }
    .cg-warn-icon { font-size: 18px; flex-shrink: 0; margin-top: 1px; }

    /* 2FA boxes */
    .cg-2fa-boxes {display: flex;justify-content: center;gap: 10px;padding: 8px 0;margin-bottom: 4px;}
    .cg-2fa-box {width: 54px;height: 62px;background: #f8fafc;border: 1.5px solid #e2e8f0;border-radius: 14px;font-family: 'Plus Jakarta Sans', sans-serif;font-size: 24px;font-weight: 700;color: #0f172a;text-align: center;outline: none;transition:border-color 0.18s,box-shadow 0.18s,background 0.18s;caret-color: #2563eb;}
    .cg-2fa-box:focus {border-color: #2563eb;background: #ffffff;box-shadow:0 0 0 3px rgba(37, 99, 235, 0.1);}
    .cg-2fa-box--filled {border-color: #93c5fd;background: #eff6ff;color: #1d4ed8;}

    .cco-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px;gap:14px;}
    .cco-spinner-lg {width:26px;height:26px;border:3px solid #e2e8f0;border-top-color:#2563eb;border-radius:50%;animation: ccoSpinLg .7s linear infinite;}
    @keyframes ccoSpinLg {to { transform: rotate(360deg); }}
    .cco-loading-txt {font-size:13.5px;color:#94a3b8;font-weight:500;}
  `}</style>
);

export default CreateClientGatewaysModal;